/*
 * Copyright (c) Secureroo PTY LTD 2022
 */
import Debugger from "./Debugger";
import { initializeApp } from "firebase/app";
import { initializeAppCheck, ReCaptchaEnterpriseProvider, ReCaptchaV3Provider } from "firebase/app-check";
import {
  getAuth,
  signOut,
  onAuthStateChanged,
  getIdToken,
} from "firebase/auth";
import { getFunctions, httpsCallable } from "firebase/functions";
import {
  getFirestore,
  collection,
  addDoc,
  doc,
  getDoc,
  getDocs,
  updateDoc,
  setDoc,
  query,
  where,
  serverTimestamp,
  or,
  Timestamp,
  deleteField,
  FieldValue,
  arrayUnion,
} from "firebase/firestore";
import {
  getStorage,
  ref,
  getDownloadURL,
  uploadBytesResumable,
} from "firebase/storage";
import CountryAndCurrency from "@workmate/country-and-currency";
import emojiFlags from "emoji-flags";
import cityList from "./city.json";
import { AsYouType, parsePhoneNumber } from "libphonenumber-js";
import "requestidlecallback-polyfill";

if (
  import.meta.env.VITE_ENV_LOADED == true ||
  import.meta.env.VITE_ENV_LOADED == "true"
) {
  console.log("[ENV TEST] Environment variables loaded");
} else {
  console.error("[ENV TEST] Environment variables not loaded");
}

const FBConfig = {
  apiKey: import.meta.env.VITE_apiKey,
  authDomain: import.meta.env.VITE_authDomain,
  projectId: import.meta.env.VITE_projectId,
  storageBucket: import.meta.env.VITE_storageBucket,
  messagingSenderId: import.meta.env.VITE_messagingSenderId,
  appId: import.meta.env.VITE_appId,
  measurementId: import.meta.env.VITE_measurementId,
};

const FBApp = initializeApp(FBConfig);
const FBAuth = getAuth(FBApp);
const FBDatabase = getFirestore(FBApp);
const FBStorage = getStorage(FBApp);
const FBFunctions = getFunctions(FBApp);

try {
  initializeAppCheck(FBApp, {
    provider: new ReCaptchaEnterpriseProvider(import.meta.env.VITE_recaptchaKey),
    isTokenAutoRefreshEnabled: true // Set to true to allow auto-refresh.
  });
} catch (error) {
  console.error('AppCheck initialization error:', error);
  // Fallback to ReCaptchaV3Provider if Enterprise provider fails
  try {
    initializeAppCheck(FBApp, {
      provider: new ReCaptchaV3Provider(import.meta.env.VITE_recaptchaKey),
      isTokenAutoRefreshEnabled: true
    });
  } catch (fallbackError) {
    console.error('AppCheck fallback initialization error:', fallbackError);
  }
}

const countriesList = [];

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};

window.CountryAndCurrency = CountryAndCurrency;

export default class DeiterateCommon {
  constructor() {
    this.FBApp = FBApp;
    this.FBAuth = FBAuth;
    this.FBDatabase = FBDatabase;
    this.FBStorage = FBStorage;
    this.FBFunctions = FBFunctions;
    this.isDebug = true; // Set to true to enable console logging
    this.demo = false; // Set to false to disable the prod/demo warning message
    this.debug = new Debugger(this.isDebug, this);
    this.assignableUsersPromise = null; // To store the ongoing fetch promise
    window.activeRequestCount = 0; // To track active requests
    if (
      (!this.isDebug && this.demo) ||
      (!this.isDebug && !this.demo) ||
      (this.isDebug && this.demo)
    ) {
      this.consoleWarning();
    }

    if (!this.isDebug) {
      console.log = function () { };
    }

    this.createPlan().then(function () {
      console.log(
        "Plan Details =>",
        JSON.parse(localStorage.getItem("planDetails"))
      );
      window.planDetails = JSON.parse(localStorage.getItem("planDetails"));
    });

    let url = window.location.toString();
    if (url.includes("#!")) {
      const pathAfterHashBang = url.split("#!")[1];
      const pageName = pathAfterHashBang.split("/")[1];
      console.log(
        "Path component after #!: ",
        this.getCapitalised(pageName.replaceAll("/", "").replaceAll("-", " "))
      );
      setTimeout(() => {
        document.querySelector(".currentLoadingItem").innerText =
          this.getCapitalised(
            pageName.replaceAll("/", "").replaceAll("-", " ")
          );
      }, 10);
    } else {
      console.log("URL does not contain the #! pattern.");
    }

    this.pageName = url.includes("#!")
      ? url.split("#!")[1].split("/")[1]
      : "home";
    onAuthStateChanged(this.FBAuth, async (user) => {
      if (user) {
        if (window.assignees === undefined || window.assignees.length === 0) {
          this.getAssignableUsers();
        }
      }
    });
  }

  consoleWarning() {
    // Styling for the console message
    const consoleStyle = `
      background: linear-gradient(#FF6161, #FF3838);
      border: 1px solid #FF3838;
      color: white;
      font-size: 20px;
      padding: 10px;
      font-weight: bold;
    `;

    // The warning message
    const warningMessage = [
      `%c⚠️ WARNING: Do not paste anything in the console! ⚠️`,
      `Pasting code here could allow attackers to access your account and personal information.`,
      `If someone asks you to paste anything here, do not do it!`,
      `Only enter code that you trust and understand.`,
      `This is a browser feature intended for developers. If someone asks you to do anything here, it could be a scam!%c`,
    ].join("\n");

    // Display the warning in the console
    console.warn(warningMessage, consoleStyle, consoleStyle);

    if (this.isDebug || this.demo) {
      console.warn(
        `%cTo Disable this message in the future set to "debug: true" and "demo: false" to the "DeiterateCommon" class in "DeiterateCommon.js"%c`,
        consoleStyle,
        consoleStyle
      );
    }
  }
  isSignedIn(type = Boolean) {
    if (localStorage.getItem("deiterate.expectSignIn") === "1") {
      return true;
    } else {
      if (type.toLowerCase() === "string") {
        return this.FBAuth.currentUser !== null ? "Signed In" : "Signed Out";
      } else {
        return this.FBAuth.currentUser !== null ? true : false;
      }

      return this.FBAuth.currentUser !== null ? true : false;
    }

    return this.FBAuth.currentUser !== null ? true : false;
  }

  async signUserOut() {
    return new Promise(async (resolve, reject) => {
      return await signOut(this.FBAuth)
        .then(async () => {
          // Clear Local Storage
          localStorage.clear();
          // Clear Session Storage
          sessionStorage.clear();
          // Clear IndexedDB
          let r = await window.indexedDB.databases();
          for (var i = 0; i < r.length; i++)
            window.indexedDB.deleteDatabase(r[i].name);
          // Clear all Cookies
          let cookies = document.cookie.split(";");
          for (let i = 0; i < cookies.length; i++) {
            let cookie = cookies[i];
            let eqPos = cookie.indexOf("=");
            let name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
            document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
          }
          // Clear Cache
          if ("caches" in window) {
            // Get all cache names
            caches.keys().then((cacheNames) => {
              // Iterate through each cache and delete it
              cacheNames.forEach((cacheName) => {
                caches.delete(cacheName);
              });
            });
          }
          // Clear SharedStorage
          if ("sharedStorage" in window) {
            window.sharedStorage.clear();
          }
          return resolve({
            status: 201,
            message: "User signed out successfully.",
          });
        })
        .catch((error) => {
          console.log(error);
          return reject({ status: error.code, message: error.message });
        });
    });
  }

  async updateCache() {
    return new Promise(async (resolve, reject) => {
      // Clear Cache
      console.log("Clearing cache");
      if ("caches" in window) {
        // Get all cache names
        caches.keys().then((cacheNames) => {
          // Iterate through each cache and delete it
          cacheNames.forEach((cacheName) => {
            console.log("Deleting cache", cacheName);
            caches.delete(cacheName);
          });
        });
      }

      // Clear Service Worker
      console.log("Clearing service worker");
      if ("serviceWorker" in navigator) {
        console.log("Service worker found");
        navigator.serviceWorker.getRegistrations().then((registrations) => {
          for (let registration of registrations) {
            console.log("Unregistering service worker", registration);
            registration.unregister();
          }
        });
      }

      return resolve({ status: 201, message: "Cache cleared successfully." });
    });
  }

  async getPlan() {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );
    return await getDoc(docRef).then((companyDoc) => {
      if (companyDoc.exists) {
        this.debug.log("Company ID =>", companyDoc.id);
        this.debug.log("Company Data =>", companyDoc.data());
        // Check plan
        let data = companyDoc.data();
        let plan =
          data["customerPlan"] !== undefined ? data["customerPlan"] : "iso";

        if (plan.toLowerCase() === "starter") {
          localStorage.setItem(
            "planDetails",
            JSON.stringify({
              plan: "starter",
              modules: ["pa", "e8"],
            })
          );

          // Hide tabs except policies and settings
          if (document.querySelector("#home-link")) {
            document.querySelector("#home-link").style.display = "flex";
          }
          if (document.querySelector("#compliance-calendar-link")) {
            document.querySelector("#compliance-calendar-link").style.display =
              "flex";
          }
          if (document.querySelector("#supplier-register-link")) {
            document.querySelector("#supplier-register-link").style.display =
              "flex";
          }
          setTimeout(() => {
            try {
              if (document.querySelector("#home-link")) {
                document.querySelector("#home-link").style.display = "flex";
              }
              if (document.querySelector("#compliance-calendar-link")) {
                document.querySelector(
                  "#compliance-calendar-link"
                ).style.display = "flex";
              }
              if (document.querySelector("#supplier-register-link")) {
                document.querySelector(
                  "#supplier-register-link"
                ).style.display = "flex";
              }
            } catch (error) {
              console.log(error);
            }
          }, 2000);
          return JSON.parse(localStorage.getItem("planDetails"));
        } else if (typeof plan === undefined || plan.toLowerCase() === "iso") {
          localStorage.setItem(
            "planDetails",
            JSON.stringify({
              plan: "iso",
              modules: ["27001"],
            })
          );

          window.f7.$(document).on("fab:open", function (el) {
            console.log("FAB open");
            console.log(el);
            // Remove all .item-links from opened element
            document
              .querySelectorAll(".fab-morph-target-visible .item-link")
              .forEach((item) => {
                console.log(item);
                if (
                  item.getAttribute("href") == "/settings/" ||
                  item.getAttribute("href") == "/tenancy-select/"
                ) {
                  // item.remove();
                  console.log("keep me");
                } else {
                  item.remove();
                  console.log("Removing item", item.getAttribute("href"));
                  if (item.getAttribute("href") == "/settings/") {
                    console.log("keep me");
                  }
                }
              });
          });

          // Hide tabs except policies and settings
          if (document.querySelector("#home-link")) {
            document.querySelector("#home-link").style.display = "none";
          }
          if (document.querySelector("#compliance-calendar-link")) {
            document.querySelector("#compliance-calendar-link").style.display =
              "none";
          }
          if (document.querySelector("#supplier-register-link")) {
            document.querySelector("#supplier-register-link").style.display =
              "none";
          }
          setTimeout(() => {
            try {
              if (document.querySelector("#home-link")) {
                document.querySelector("#home-link").style.display = "none";
              }
              if (document.querySelector("#compliance-calendar-link")) {
                document.querySelector(
                  "#compliance-calendar-link"
                ).style.display = "none";
              }
              if (document.querySelector("#supplier-register-link")) {
                document.querySelector(
                  "#supplier-register-link"
                ).style.display = "none";
              }
            } catch (error) {
              console.log(error);
            }
          }, 2000);

          return JSON.parse(localStorage.getItem("planDetails"));
        }
      }
    });
  }

  async getModules() {
    console.log(localStorage.getItem("companyID"));
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );
    return await getDoc(docRef).then((companyDoc) => {
      if (companyDoc.exists) {
        this.debug.log("Company ID =>", companyDoc.id);
        this.debug.log("Company Data =>", companyDoc.data());
        // Check plan
        let data = companyDoc.data();
        let plan =
          data["customerPlan"] !== undefined ? data["customerPlan"] : "iso";

        if (plan.toLowerCase() === "starter") {
          if (data["starterEnabled"] == undefined) {
            return ["pa", "e8"];
          } else {
            let e8 = data["starterEnabled"].e8Enabled == true ? "e8" : "";
            let pa =
              data["starterEnabled"].privacyActEnabled == true ? "pa" : "";

            let modules = [];
            if (e8 !== "") {
              modules.push(e8);
            }

            if (pa !== "") {
              modules.push(pa);
            }

            if (modules.length <= 0) {
              window.f7.dialog
                .create({
                  title: "de.iterate",
                  text: "Please use the web admin to enable ISO 27001, Privacy Act or Essential 8",
                  buttons: [],
                })
                .open();

              return ["error"];
            }

            let planDetails = JSON.parse(localStorage.getItem("planDetails"));
            planDetails.modules = modules;
            localStorage.setItem("planDetails", JSON.stringify(planDetails));

            return modules;
          }
        } else if (typeof plan === undefined) {
          let planDetails = JSON.parse(localStorage.getItem("planDetails"));
          if (planDetails.plan === "iso") {
            planDetails.modules = ["27001"];
            localStorage.setItem("planDetails", JSON.stringify(planDetails));
          }
          return ["27001"];
        }
      }
    });
  }

  async enableModule(module) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );

    if (module.toLowerCase() == "pa") {
      return await setDoc(
        docRef,
        {
          starterEnabled: {
            privacyActEnabled: true,
          },
        },
        { merge: true }
      )
        .then(() => {
          console.log("Document successfully updated!");
          this.savedNotification({
            title: "de.iterate",
            text: "Privacy Act was enabled successfully. Reloading now.",
          }).then(() => {
            window.location.reload();
          });
          return true;
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          return false;
        });
    } else if (module.toLowerCase() == "e8") {
      return await setDoc(
        docRef,
        {
          starterEnabled: {
            e8Enabled: true,
          },
        },
        { merge: true }
      )
        .then(() => {
          console.log("Document successfully updated!");
          this.savedNotification({
            title: "de.iterate",
            text: "Essential 8 was enabled successfully. Reloading now.",
          }).then(() => {
            window.location.reload();
          });
          return true;
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          return false;
        });
    }
  }

  async disableModule(module) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );

    if (module.toLowerCase() == "pa") {
      return await setDoc(
        docRef,
        {
          starterEnabled: {
            privacyActEnabled: false,
          },
        },
        { merge: true }
      )
        .then(() => {
          console.log("Document successfully updated!");
          this.savedNotification({
            title: "de.iterate",
            text: "Privacy Act was disabled successfully. Reloading now.",
          }).then(() => {
            window.location.reload();
          });
          return true;
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          return false;
        });
    } else if (module.toLowerCase() == "e8") {
      return await setDoc(
        docRef,
        {
          starterEnabled: {
            e8Enabled: false,
          },
        },
        { merge: true }
      )
        .then(() => {
          console.log("Document successfully updated!");
          this.savedNotification({
            title: "de.iterate",
            text: "Essential 8 was disabled successfully. Reloading now.",
          }).then(() => {
            window.location.reload();
          });
          return true;
        })
        .catch((error) => {
          console.error("Error updating document: ", error);
          return false;
        });
    }
  }

  async createPlan() {
    await this.getPlan();
    await this.getModules();

    let planDetails = JSON.parse(localStorage.getItem("planDetails")) || {
      plan: "error",
      modules: ["error"],
    };

    return planDetails;
  }
  /**
   * The function downloads or displays a file from Firebase storage using a provided path and
   * filename.
   * @param action - The action to perform, either "download" or "display" or "link".
   * @param selector - The selector parameter is a string that represents a CSS selector used to
   * select one or more HTML elements on the page. These elements will be updated with the downloaded
   * file's URL if the action parameter is set to 'display'.
   * @param fileName - The name of the file to be downloaded or displayed.
   * @param path - The path to the file in Firebase Storage that needs to be downloaded or displayed.
   */
  async downloadFromSDK(action, selector, fileName, path) {
    let bucket = FBConfig["storageBucket"];
    let storage = getStorage();
    return getDownloadURL(ref(storage, path))
      .then((url) => {
        let query = url.substring(1);
        let vars = query.split("&");
        for (let i = 0; i < vars.length; i++) {
          let pair = vars[i].split("=");
          if (decodeURIComponent(pair[0]) === "token") {
            let token = decodeURIComponent(pair[1]);
            let removedDoubleSlash = path.replace("/customers/", "customers/");
            this.debug.log(removedDoubleSlash);
            let newUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
              removedDoubleSlash
            )}?alt=media&token=${token}`;
            let xhr = new XMLHttpRequest();
            xhr.open("GET", newUrl);
            xhr.responseType = "blob";
            xhr.onload = (event) => {
              let blob = event.currentTarget.response;
              newUrl = window.URL.createObjectURL(blob);
              this.debug.log(newUrl);
              if (action === "download") {
                let a = document.createElement("a");
                document.body.appendChild(a);
                a.style = "display: none";
                a.id = "magicDL";
                a.href = newUrl;
                a.download = fileName;
                a.click();
                window.URL.revokeObjectURL(newUrl);
                a.remove();
              } else if (action === "display") {
                document.querySelectorAll(selector).forEach((element) => {
                  element.setAttribute("src", newUrl);
                  element.setAttribute(
                    "onerror",
                    "this.src='logos/deiterate-" +
                    this.prefersColorSchemeImage() +
                    ".svg';"
                  );
                });
              } else if (action === "link") {
                console.log(
                  "[DeiterateCommon] (downloadFromSDK) Company Image Link =>",
                  newUrl
                );
                localStorage.setItem("companyImage", newUrl);
                return newUrl;
              }
            };
            xhr.send();

            if (action === "blob") {
              return fetch(newUrl)
                .then((response) => response.blob())
                .then((blob) => {
                  const url = URL.createObjectURL(blob);
                  return url;
                });
            }

            if (action === "link") {
              return newUrl;
            }
            return xhr;
          }
        }
        this.debug.log("Query variable %s not found", "token");
      })
      .catch((error) => {
        if (selector === ".companyImg" || selector === ".companyLogoImg") {
          if (error.code === "storage/object-not-found") {
            let logoImgNumber = this.getRandomInt(6);
            let fileName = `default_tenancy_logo_${logoImgNumber}`;
            return getDownloadURL(
              ref(storage, `templates/defaults/default_logos/${fileName}.png`)
            ).then((url) => {
              let query = url.substring(1);
              let vars = query.split("&");
              for (let i = 0; i < vars.length; i++) {
                let pair = vars[i].split("=");
                if (decodeURIComponent(pair[0]) === "token") {
                  let token = decodeURIComponent(pair[1]);
                  let newUrl = `https://firebasestorage.googleapis.com/v0/b/${bucket}/o/${encodeURIComponent(
                    `templates/defaults/default_logos/${fileName}.png`
                  )}?alt=media&token=${token}`;
                  let xhr = new XMLHttpRequest();
                  xhr.open("GET", newUrl);
                  xhr.responseType = "blob";
                  xhr.onload = (event) => {
                    let blob = event.currentTarget.response;
                    newUrl = window.URL.createObjectURL(blob);
                    this.debug.log(newUrl);
                    if (action === "download") {
                      let a = document.createElement("a");
                      document.body.appendChild(a);
                      a.style = "display: none";
                      a.id = "magicDL";
                      a.href = newUrl;
                      a.download = fileName;
                      a.click();
                      window.URL.revokeObjectURL(newUrl);
                      a.remove();
                    } else if (action === "display") {
                      document.querySelectorAll(selector).forEach((element) => {
                        element.setAttribute("src", newUrl);
                        element.setAttribute(
                          "onerror",
                          "this.src='logos/deiterate-" +
                          this.prefersColorSchemeImage() +
                          ".svg';"
                        );
                      });
                    } else if (action === "link") {
                      console.log(
                        "[DeiterateCommon] (downloadFromSDK) Company Image Link =>",
                        newUrl
                      );
                      localStorage.setItem("companyImage", newUrl);
                      return newUrl;
                    }
                  };
                  xhr.send();

                  if (action === "blob") {
                    return fetch(newUrl)
                      .then((response) => response.blob())
                      .then((blob) => {
                        const url = URL.createObjectURL(blob);
                        return url;
                      });
                  }

                  if (action === "link") {
                    return newUrl;
                  }
                  return xhr;
                }
              }
              this.debug.log("Query variable %s not found", "token");
            });
          }
        }
      });
  }

  getRandomInt(max) {
    return Math.floor(
      Math.random() * (Math.floor(max) - Math.ceil(1)) + Math.ceil(1)
    );
  }
  /**
   * This function downloads a company logo image from a specified directory and displays it on a
   * webpage.
   */
  async getCompanyImg(companyID = window.localStorage.getItem("companyID")) {
    await this.downloadFromSDK(
      "display",
      ".companyImg",
      companyID + "_logo.png",
      "companyLogos/" + companyID + "/" + companyID + "_logo.png"
    );
  }

  async getCompanyImgLink(
    companyID = window.localStorage.getItem("companyID")
  ) {
    let link = await this.downloadFromSDK(
      "link",
      ".companyImg",
      companyID + "_logo.png",
      "companyLogos/" + companyID + "/" + companyID + "_logo.png"
    );
    console.log(
      "[DeiterateCommon] (getCompanyImgLink) Company Image Link =>",
      link
    );
    return link;
  }
  /**
   * This function downloads a company logo image from an SDK and displays it on a webpage.
   */
  getCompanyLogoImg() {
    let companyID = window.localStorage.getItem("companyID");
    this.downloadFromSDK(
      "display",
      ".companyLogoImg",
      companyID + "_logo.png",
      "companyLogos/" + companyID + "/" + companyID + "_logo.png"
    );
  }
  async saveFCM(token) {
    let docRef = doc(FBDatabase, "users", getAuth().currentUser.uid);
    return await setDoc(
      docRef,
      {
        fcmToken: token,
      },
      { merge: true }
    )
      .then(() => {
        console.log("Document successfully updated!");
        return true;
      })
      .catch((error) => {
        console.error("Error updating document: ", error);
        return false;
      });
  }
  /**
   * This function retrieves user data from a Firebase database and returns it as an object.
   * @returns The `getUserData()` function returns an object with two properties: `uid` and `data`.
   * If the `userData` exists, `uid` is set to the user's ID and `data` is set to the user's data. If
   * `userData` does not exist, `uid` is set to `'None'` and `data` is an empty object.
   */
  async getUserData() {
    let docRef = doc(FBDatabase, "users", getAuth().currentUser.uid);
    let userData = await getDoc(docRef);
    let user = {};
    if (userData.exists) {
      user = {
        uid: userData.id,
        data: userData.data(),
      };
      return user;
    } else {
      return {
        uid: "None",
        data: {},
      };
    }
  }

  /**
   * The function `getPersonalSettings` retrieves the mobile app settings for the current user from a
   * Firebase database.
   * @returns The `getPersonalSettings` function returns the `mobileAppSettings` data from the user
   * document in the Firestore database if it exists. If the `mobileAppSettings` property is present in
   * the user data, it is returned. If not, an empty object `{}` is returned. If the user document does
   * not exist, an empty object `{}` is also returned.
   */
  async getPersonalSettings() {
    let docRef = doc(FBDatabase, "users", getAuth().currentUser.uid);
    let userData = await getDoc(docRef);
    if (userData.exists) {
      if (userData.data().hasOwnProperty("mobileAppSettings")) {
        return userData.data().mobileAppSettings;
      }
      return {};
    } else {
      return {};
    }
  }

  /**
   * The function `getPersonalSetting` retrieves a specific personal setting based on a given key from
   * a set of personal settings.
   * @param key - The `key` parameter in the `getPersonalSetting` function is used to specify the
   * setting that the user wants to retrieve from the personal settings. It is the key corresponding to
   * the specific setting in the personal settings object.
   * @returns The `getPersonalSetting` function returns the value associated with the provided `key`
   * from the personal settings object if the key exists. If the key does not exist in the personal
   * settings object, it returns `null`.
   */
  async getPersonalSetting(key) {
    let personalSettings = await this.getPersonalSettings();
    if (personalSettings.hasOwnProperty(key)) {
      return personalSettings[key];
    } else {
      return null;
    }
  }

  /**
   * The function `applyPersonalSettings` updates the app's visual settings based on the user's
   * personal preferences retrieved asynchronously.
   */
  async applyPersonalSettings() {
    let personalSettings = await this.getPersonalSettings();

    if (personalSettings.hasOwnProperty("appNotifications")) {
      window.appNotifications = personalSettings.appNotifications;
    }

    if (personalSettings.hasOwnProperty("usesMFA")) {
      window.usesMFA = personalSettings.usesMFA;
    }

    if (personalSettings.hasOwnProperty("colorScheme")) {
      let colorScheme = personalSettings.colorScheme;
      let darkMode = colorScheme === "dark";
      window.darkMode = darkMode;

      if (darkMode == "true" || darkMode == true) {
        localStorage.setItem("darkMode", "true");
        document.querySelector("html").classList.add("dark");

        if (window.f7.device.android) {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deit-dark.svg");
          });
        } else {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deiterate-dark.svg");
          });
        }
        setTimeout(() => {
          if (window.f7.device.android) {
            document.querySelectorAll(".deit-logo").forEach((logo) => {
              logo.setAttribute("src", "logos/deit-dark.svg");
            });
          } else {
            document.querySelectorAll(".deit-logo").forEach((logo) => {
              logo.setAttribute("src", "logos/deiterate-dark.svg");
            });
          }
        }, 1500);
        window.f7.statusbar.setTextColor("white");
      } else {
        localStorage.setItem("darkMode", "false");
        document.querySelector("html").classList.remove("dark");

        if (window.f7.device.android) {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deit-light.svg");
          });
        } else {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deiterate-light.svg");
          });
        }
        setTimeout(() => {
          if (window.f7.device.android) {
            document.querySelectorAll(".deit-logo").forEach((logo) => {
              logo.setAttribute("src", "logos/deit-light.svg");
            });
          } else {
            document.querySelectorAll(".deit-logo").forEach((logo) => {
              logo.setAttribute("src", "logos/deiterate-light.svg");
            });
          }
        }, 1500);
        window.f7.statusbar.setTextColor("black");
      }
    }
  }

  /**
   * The function `savePersonalSetting` saves a personal setting for a user in a Firebase database.
   * @param key - The `key` parameter in the `savePersonalSetting` function represents the setting that
   * you want to save or update in the `mobileAppSettings` object for the current user. It is used as
   * the key in the key-value pair where the `value` corresponds to the setting value.
   * @param value - The `value` parameter in the `savePersonalSetting` function represents the value
   * that you want to save for a specific key in the `mobileAppSettings` object. This value can be of
   * any data type (string, number, boolean, object, etc.) depending on the setting you want to
   * @returns The `savePersonalSetting` function is returning a promise that resolves to the result of
   * setting the document in the Firestore database with the provided key-value pair under the
   * `mobileAppSettings` field for the current user. The `{ merge: true }` option is used to merge the
   * new data with any existing data in the document.
   */
  async savePersonalSetting(key, value) {
    let docRef = doc(FBDatabase, "users", getAuth().currentUser.uid);
    window[key] = value;
    await setDoc(
      docRef,
      {
        mobileAppSettings: {
          [key]: value,
        },
      },
      { merge: true }
    );

    return await getDoc(docRef).then((doc) => {
      console.log("Saved Key, checking for check now");
      let docData = doc.data();
      if (docData.hasOwnProperty("mobileAppSettings")) {
        if (docData.mobileAppSettings.hasOwnProperty(key)) {
          console.log(
            `Key ${key} found in document`,
            docData.mobileAppSettings[key]
          );
          return docData.mobileAppSettings[key];
        } else {
          console.log(`Key ${key} not found in document`);
          return null;
        }
      } else {
        return null;
      }
    });
  }
  async isPolicyCompleted(originalCount, policyID) {
    return await this.createPlan().then(async (plan) => {
      let planDetails = plan;
      window.planDetails = plan;
      if (planDetails.plan === "iso") {
        let docRef = collection(
          FBDatabase,
          "users",
          getAuth().currentUser.uid,
          "assignedPolicies"
        );
        let q = query(docRef, where("reference", "==", policyID));
        return await getDocs(q).then((querySnapshot) => {
          if (!querySnapshot.empty) {
            const docData = querySnapshot.docs[0].data();
            console.log('Current Screen:', docData.currentScreen);
            return docData["completed"].toString() == "true" || docData.currentScreen >= originalCount;
          } else {
            return "hello";
          }
        });
      } else {
        return false;
      }
    });
  }
  /**
   * The function loads policies from a Firebase database based on whether they have been completed
   * or not.
   * @param el - The "el" parameter is likely a reference to an HTML element that will be updated
   * with the policy data retrieved from the database.
   * @param [completedOnly=false] - A boolean parameter that determines whether to load only
   * completed policies (if set to true) or all policies (if set to false).
   */
  loadPolicies(el, completedOnly = false) {
    this.createPlan().then((plan) => {
      let planDetails = plan;
      window.planDetails = plan;
      if (planDetails.plan === "iso") {
        let docRef = collection(
          FBDatabase,
          "users",
          getAuth().currentUser.uid,
          "assignedPolicies"
        );
        let q = query(
          docRef,
          or(
            where("completed", "==", completedOnly.toString()),
            where("completed", "==", completedOnly.toString())
          )
        );
        getDocs(q).then((docs) => {
          this.debug.log(Object.keys(docs).length);
          docs.forEach((d) => {
            if (Object.keys(d.data()).length <= 0) {
              return;
            }
            this.debug.log("Completed => ", d.data()["completed"].toString());
            this.debug.log("Looking for completed = ", completedOnly);
            if (d.data()["completed"].toString() === completedOnly.toString()) {
              this.debug.log("Found Policy => ", d.data());
              this.debug.log(
                "Is template",
                d.data()["policy_name"] === "Template Policy"
              );
              if (d.data()["reference"] === "template") {
                return;
              }
              this.getPolicyData(
                d.data()["reference"],
                el,
                completedOnly.toString()
              );
            }
          });
        });
      } else {
        document.querySelector(".subnavbar").style.display = "none";
        this.debug.log("Policy does not exist");
        let noPolicy = document.createElement("div");
        noPolicy.classList.add("block");
        noPolicy.classList.add("block-strong");
        noPolicy.classList.add("text-align-center");
        noPolicy.classList.add("inset");
        noPolicy.classList.add("noPolicy");

        let planDetails = JSON.parse(
          localStorage.getItem("planDetails") || "{}"
        );
        if (planDetails.plan == "starter") {
          let li = document.createElement("li");
          let itemLink = document.createElement("a");
          itemLink.classList.add("item-link");
          itemLink.setAttribute("href", "/privacy-policy/editor/");
          let itemContent = document.createElement("div");
          itemContent.classList.add("item-content");
          let itemMedia = document.createElement("div");
          itemMedia.classList.add("item-media");
          let companyImg = document.createElement("img");
          companyImg.classList.add("companyImg");
          itemMedia.append(companyImg);
          itemContent.append(itemMedia);
          let itemInner = document.createElement("div");
          itemInner.classList.add("item-inner");
          let itemTitleRow = document.createElement("div");
          itemTitleRow.classList.add("item-title-row");
          let itemTitle = document.createElement("div");
          itemTitle.classList.add("item-title");
          itemTitle.innerText = "Privacy Policy";
          itemTitleRow.append(itemTitle);
          let itemAfter = document.createElement("div");
          itemAfter.classList.add("item-after");
          itemAfter.innerText = "";
          itemTitleRow.append(itemAfter);
          itemInner.append(itemTitleRow);
          let itemText = document.createElement("div");
          itemText.classList.add("item-text");
          itemText.innerText = "Privacy Act";
          itemInner.append(itemText);
          itemContent.append(itemInner);
          itemLink.append(itemContent);
          li.append(itemLink);
          document.querySelector(el).append(li);
          const listItems = document
            .querySelector(el)
            .getElementsByTagName("li");

          // Step 3: Loop through the li elements and remove all but one (keeping the first one)
          for (let i = listItems.length - 1; i > 0; i--) {
            document.querySelector(el).removeChild(listItems[i]);
          }
        } else {
          let noPolicyTitle = document.createElement("p");
          noPolicyTitle.classList.add("noPolicyTitle");
          noPolicyTitle.innerText = "No Policies Found";
          noPolicyTitle.style.color = "var(--f7-list-item-after-text-color)";
          noPolicy.append(noPolicyTitle);
          document.querySelector(el).append(noPolicy);

          const listItems = document
            .querySelector(el)
            .getElementsByClassName("noPolicy");

          // Step 3: Loop through the li elements and remove all but one (keeping the first one)
          for (let i = listItems.length - 1; i > 0; i--) {
            document.querySelector(el).removeChild(listItems[i]);
          }
        }
        return;
      }
    });
  }
  /**
   * Calculates the total ReadTime for all policies under a specific company.
   *
   * @param {string} companyID - The ID of the company.
   * @returns {Promise<number>} - The total ReadTime (ExpectedTotalReadTime).
   */
  async calculateExpectedTotalReadTime(companyID = localStorage.getItem("companyID")) {
    try {
      // Reference to the policies subcollection
      const policiesRef = collection(
        this.FBDatabase,
        "customers",
        companyID,
        "product",
        "policyPackages",
        "policies"
      );

      // Fetch all documents in the policies subcollection
      const policiesSnapshot = await getDocs(policiesRef);

      // Initialize total read time
      let ExpectedTotalReadTime = 0;

      // Iterate through each document and sum the ReadTime
      policiesSnapshot.forEach((docSnapshot) => {
        const data = docSnapshot.data();

        // Ensure ReadTime exists and is a number
        if (data.ReadTime && typeof data.ReadTime === "number") {
          ExpectedTotalReadTime += data.ReadTime;
        } else if (data.ReadTime && typeof data.ReadTime === "string") {
          ExpectedTotalReadTime += parseInt(data.ReadTime);
        } else {
          console.warn(
            `Document ${docSnapshot.id} is either; missing ReadTime, it's not a number, or it's value is 0. Skipping.`,
            data
          );
        }
      });

      console.log(
        `Total ExpectedReadTime for companyID ${companyID}: ${ExpectedTotalReadTime}`
      );
      return ExpectedTotalReadTime;
    } catch (error) {
      console.error("Error calculating ExpectedTotalReadTime:", error);
      throw error; // Re-throw the error after logging
    }
  }
  /**
   * This function retrieves policy data from a Firebase database and builds a policy item if an
   * element is provided.
   * @param policyRef - The reference ID of a specific policy document in the Firebase database.
   * @param el - The "el" parameter is a string representing the selector for the HTML element where
   * the policy item will be appended.
   * @returns The `getPolicyData` function returns a Promise that resolves to the policy data object
   * retrieved from the Firestore database. If the `el` parameter is provided, the function also
   * appends a policy item to the specified element in the DOM.
   */
  getPolicyData(policyRef, el = "", completedPolicy = "") {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "policies",
      policyRef
    );
    return getDoc(docRef).then((policyDoc) => {
      if (policyDoc.exists()) {
        this.debug.log("Policy Type =>", policyDoc.data()?.policy_metadata?.policyType)
        this.debug.log("Policy ID =>", policyDoc.id);
        this.debug.log("Policy Data =>", policyDoc.data());
        this.debug.log("Policy Read Time =>", policyDoc.data()["ReadTime"]);
        if (policyDoc.data()?.policy_metadata?.policyType === undefined || policyDoc.data()?.policy_metadata?.policyType === 'default') {
          if (el !== "") {
            this.buildPolicyItem(
              policyDoc.data(),
              policyRef,
              completedPolicy
            ).then((item) => {
              document.querySelector(el).append(item);
            });
          }
        } else {
          if (el !== "") {
            this.buildCustomPolicyItem(
              policyDoc.data(),
              policyRef,
              completedPolicy
            ).then((item) => {
              document.querySelector(el).append(item);
            });
          }
        }
        return policyDoc.data();
      } else {
        this.debug.log("Policy does not exist");
        let noPolicy = document.createElement("div");
        noPolicy.classList.add("block");
        noPolicy.classList.add("block-strong");
        noPolicy.classList.add("text-align-center");
        noPolicy.classList.add("inset");
        noPolicy.classList.add("noPolicy");

        let planDetails = JSON.parse(
          localStorage.getItem("planDetails") || "{}"
        );
        if (planDetails.plan == "starter") {
          let li = document.createElement("li");
          let itemLink = document.createElement("a");
          itemLink.classList.add("item-link");
          itemLink.setAttribute("href", "/privacy-policy/editor/");
          let itemContent = document.createElement("div");
          itemContent.classList.add("item-content");
          let itemMedia = document.createElement("div");
          itemMedia.classList.add("item-media");
          let companyImg = document.createElement("img");
          companyImg.classList.add("companyImg");
          itemMedia.append(companyImg);
          itemContent.append(itemMedia);
          let itemInner = document.createElement("div");
          itemInner.classList.add("item-inner");
          let itemTitleRow = document.createElement("div");
          itemTitleRow.classList.add("item-title-row");
          let itemTitle = document.createElement("div");
          itemTitle.classList.add("item-title");
          itemTitle.innerText = "Privacy Policy";
          itemTitleRow.append(itemTitle);
          let itemAfter = document.createElement("div");
          itemAfter.classList.add("item-after");
          itemAfter.innerText = "";
          itemTitleRow.append(itemAfter);
          itemInner.append(itemTitleRow);
          let itemText = document.createElement("div");
          itemText.classList.add("item-text");
          itemText.innerText = "Privacy Act";
          itemInner.append(itemText);
          itemContent.append(itemInner);
          itemLink.append(itemContent);
          li.append(itemLink);
          document.querySelector(el).append(li);
          const listItems = document
            .querySelector(el)
            .getElementsByTagName("li");

          // Step 3: Loop through the li elements and remove all but one (keeping the first one)
          for (let i = listItems.length - 1; i > 0; i--) {
            document.querySelector(el).removeChild(listItems[i]);
          }
        } else {
          let noPolicyTitle = document.createElement("p");
          noPolicyTitle.classList.add("noPolicyTitle");
          noPolicyTitle.innerText = "No Policies Found";
          noPolicyTitle.style.color = "var(--f7-list-item-after-text-color)";
          noPolicy.append(noPolicyTitle);
          document.querySelector(el).append(noPolicy);

          const listItems = document
            .querySelector(el)
            .getElementsByClassName("noPolicy");

          // Step 3: Loop through the li elements and remove all but one (keeping the first one)
          for (let i = listItems.length - 1; i > 0; i--) {
            document.querySelector(el).removeChild(listItems[i]);
          }
        }
        return;
      }
    });
  }
  /**
   * The function retrieves a specific field from a document in a Firebase database based on the
   * provided parameters.
   * @param [standard=ISO27001keyDocuments] - The standard for which the ISMS scope is being retrieved.
   * In this case, it is "ISO27001keyDocuments".
   * @param [field=1] - The "field" parameter is used to specify which field of the ISMS scope document
   * to retrieve. It is a string value that should correspond to the field number in the document. For
   * example, if "field" is set to "1", the function will retrieve the content of the first field in
   * @returns The function `getISMSScope` returns a Promise that resolves to the value of
   * `ismsScope.data()['content'][`field`]` if it exists, or to the entire `ismsScope.data()`
   * object if the specified field does not exist. If the `ismsScope` document does not exist, nothing
   * is returned.
   */
  getISMSScope(standard = "ISO27001keyDocuments", field = "6") {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      standard,
      "ismsScope"
    );
    return getDoc(docRef).then((ismsScope) => {
      if (ismsScope.exists) {
        this.debug.log("ISMS Scope =>", ismsScope.data());
        if (
          ismsScope.data()["content"][`field${field}`]["text"]["overview"] ==
          undefined
        ) {
          this.debug.log("ISMS Scope Field not found");
          return ismsScope.data();
        }
        console.log(
          "Scope - " +
          ismsScope.data()["content"][`field${field}`]["text"]["overview"]
        );
        return ismsScope.data()["content"][`field${field}`]["text"]["overview"];
      }
    });
  }

  getISMSRoles(standard = "ISO27001keyDocuments") {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      standard,
      "ismsManual"
    );
    return getDoc(docRef).then((ismsManual) => {
      if (ismsManual.exists) {
        this.debug.log("ISMS Manual =>", ismsManual.data());
        if (ismsManual.data()?.ismsRoles === undefined) {
          this.debug.log("ISMS Roles Field not found");
          return ismsManual.data();
        }
        return ismsScope.data().ismsRoles;
      }
    });
  }
  /**
   * This function retrieves the ISMS objectives from a specific document in a Firebase database based on
   * a given standard.
   * @param [standard=ISO27001keyDocuments] - The standard parameter is a string that specifies the
   * standard for which the ISMS (Information Security Management System) objectives are being retrieved.
   * In this case, the default value is "ISO27001keyDocuments", which suggests that the function is
   * retrieving ISMS objectives for the ISO 27001 standard. However
   * @returns the ISMS (Information Security Management System) objectives for a given standard (default
   * is "ISO27001keyDocuments") from a specific location in a Firebase database. The ISMS objectives are
   * retrieved from the "ismsManual" document under the "policyPackages" collection for the specified
   * standard. If the document exists, the function logs the ISMS objectives and returns them.
   */
  getISMSObjectives(standard = "ISO27001keyDocuments") {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      standard,
      "ismsManual"
    );
    return getDoc(docRef).then((ismsObjectives) => {
      if (ismsObjectives.exists) {
        this.debug.log(
          "ISMS Objectives =>",
          ismsObjectives.data()["ismsObjectives"]
        );
        return ismsObjectives.data()["ismsObjectives"];
      }
    });
  }

  getISMSRoles(standard = "ISO27001keyDocuments") {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      standard,
      "ismsManual"
    );

    return getDoc(docRef).then((ismsRoles) => {
      if (ismsRoles.exists) {
        this.debug.log("ISMS Roles =>", ismsRoles.data()["ismsRoles"]);
        return ismsRoles.data()["ismsRoles"];
      }
    });
  }
  /**
   * This function retrieves screen data from a specific policy package and policy reference in a
   * Firebase database.
   * @param policyRef - The reference ID of a specific policy document in the Firebase database.
   * @param screenRef - The `screenRef` parameter is a reference to a specific screen within a policy
   * in a product package for a customer.
   * @returns The function `getScreenData` returns the data of a specific screen in a policy package,
   * which is located in a specific document in a Firebase Firestore database. The data is returned
   * as a Promise that resolves to the screen data object if the document exists, and `undefined`
   * otherwise.
   */
  getScreenData(policyRef, screenRef) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "policies",
      policyRef,
      "screens",
      screenRef
    );
    return getDoc(docRef).then((screenDoc) => {
      if (screenDoc.exists) {
        this.debug.log("Screen ID =>", screenDoc.id);
        this.debug.log("Screen Data =>", screenDoc.data());
        const data = screenDoc.data();
        // Ensure screen data has required structure
        if (!data.procedureObjects) {
          data.procedureObjects = {};
        }
        if (!data.screenLayout) {
          data.screenLayout = 1; // Default to layout type 1
        }
        return data;
      } else {
        this.debug.warn("Screen document does not exist:", screenRef);
        // Return default screen data structure
        return {
          procedureObjects: {},
          screenLayout: 1,
          control_objective: ""
        };
      }
    }).catch(error => {
      this.debug.error("Error getting screen data:", error);
      // Return default screen data structure on error
      return {
        procedureObjects: {},
        screenLayout: 1,
        control_objective: ""
      };
    });
  }
  /**
   * This function retrieves the name of a company from a database and returns it in either a
   * friendly or standard format, or both.
   * @param [friendly=false] - A boolean parameter that determines whether to return the
   * customer-friendly name of the company. If set to true, the function will return the value of the
   * 'customerFriendlyName' key in the company data.
   * @param [both=true] - A boolean parameter that determines whether to return both the customer
   * friendly name and the customer name as an object or not. If set to true, the function will
   * return an object with the keys 'companyName' and 'customerName' and their respective values. If
   * set to false or not provided, the
   * @returns a Promise that resolves to either the customer name or an object containing both the
   * customer name and customer friendly name, depending on the arguments passed to the function. If
   * the company document does not exist, nothing is returned.
   */
  getCompanyName(friendly = false, both = true) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );
    return getDoc(docRef).then((companyDoc) => {
      if (companyDoc.exists) {
        this.debug.log("Company ID =>", companyDoc.id);
        this.debug.log("Company Data =>", companyDoc.data());
        if (friendly) {
          return companyDoc.data()["customerFriendlyName"];
        }
        if (both) {
          return {
            companyName: companyDoc.data()["customerFriendlyName"],
            customerName: companyDoc.data()["customerName"],
          };
        }
        return companyDoc.data()["customerName"];
      }
    });
  }
  /**
   * This function retrieves data from a Firebase database for a specific company and returns either all
   * the data or a specific key's value.
   * @param [key] - The key parameter is an optional argument that can be passed to the getCompanyData
   * function. If a key is provided, the function will return the value of that specific key from the
   * company data. If no key is provided, the function will return the entire company data object.
   * @returns The `getCompanyData` function is returning a Promise that resolves to the data of a
   * document in the "customers" collection of a Firebase Firestore database. If the `key` parameter is
   * provided, the function returns the value of the specified key in the document data. If the `key`
   * parameter is not provided, the function returns the entire document data.
   */
  getCompanyData(key = undefined) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );
    return getDoc(docRef).then((companyDoc) => {
      if (companyDoc.exists) {
        this.debug.log("Company ID =>", companyDoc.id);
        this.debug.log("Company Data =>", companyDoc.data());
        if (key !== undefined) {
          return companyDoc.data()[key];
        }
        return companyDoc.data();
      }
    });
  }

  /**
   * The function `getComplianceModuleData` retrieves compliance module data from a Firestore database
   * based on the specified module.
   * @param [module] - The `module` parameter in the `getComplianceModuleData` function is used to
   * specify a particular compliance module for which you want to retrieve data. If a specific `module`
   * is provided, the function will return data related to that module only. If `module` is not provided
   * (or
   * @returns The `getComplianceModuleData` function is returning a Promise that resolves to the
   * compliance module data from the Firestore database. If a specific `module` is provided as an
   * argument, it will return the data for that module only. If no `module` is provided, it will return
   * all compliance module data.
   */
  async getComplianceModuleData(module = undefined) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules"
    );

    console.log(
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules"
    );
    return getDoc(docRef).then((complianceModulesDoc) => {
      if (complianceModulesDoc.exists) {
        this.debug.log(
          "Compliance Module Data =>",
          complianceModulesDoc.data()
        );
        if (module !== undefined) {
          return complianceModulesDoc.data()[module];
        }
        return complianceModulesDoc.data();
      }
    });
  }

  async updateComplianceModule(module, moduleObject) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules"
    );

    return setDoc(
      docRef,
      {
        [module]: moduleObject,
      },
      {
        merge: true,
      }
    ).then(async () => {
      await this.savedNotification({
        title: "Company Settings",
        text: "Your changes have been saved.",
      });
    });
  }

  getCompanySettingsDoc(key = undefined) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      key
    );
    return getDoc(docRef).then((companySettingsDataDoc) => {
      if (companySettingsDataDoc.exists) {
        this.debug.log(
          "Company Settiongs Data =>",
          companySettingsDataDoc.data()
        );
        return companySettingsDataDoc.data();
      }
    });
  }

  updateCompanyData(key, value) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID")
    );

    return setDoc(
      docRef,
      {
        [key]: value,
      },
      {
        merge: true,
      }
    ).then(async () => {
      await this.savedNotification({
        title: "Company Settings",
        text: "Your changes have been saved.",
      });
    });
  }

  async updateCompanySettingsData(category, keys, value) {
    console.log("Details For Call", {
      category: category,
      key: keys,
      value: value,
    });
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      category
    );
    if (
      typeof keys === "array" ||
      Array.isArray(keys) ||
      typeof keys === "object"
    ) {
      let docData = await getDoc(docRef).then((doc) => {
        if (doc.exists()) {
          return doc.data();
        }
      });

      let rootNode = docData[keys[0]];
      if (rootNode[keys[1]] == undefined) {
        console.log("root node", rootNode);
        console.log("key test", keys[1]);

        let discoveredPath = this.findPath(rootNode, keys[1]);

        if (discoveredPath !== null) {
          let path = discoveredPath.split("/");
          console.log("discovered path", path);
          keys[1] = path[1];
        }

        console.log("key test", keys[1]);
      }

      return setDoc(
        docRef,
        {
          [keys[0]]: {
            [keys[1]]: {
              [keys[2]]: value,
            },
          },
        },
        {
          merge: true,
        }
      ).then(async () => {
        await this.savedNotification({
          title: "Company Settings",
          text: "Your changes have been saved.",
        });
      });
    } else {
      return setDoc(
        docRef,
        {
          [keys]: value,
        },
        {
          merge: true,
        }
      ).then(async () => {
        await this.savedNotification({
          title: "Company Settings",
          text: "Your changes have been saved.",
        });
      });
    }
  }

  findPath(json, keyOrIndex, currentPath = "") {
    if (json instanceof Object) {
      for (const key in json) {
        if (key === keyOrIndex || json[key] === keyOrIndex) {
          return currentPath + "/" + key;
        } else if (json[key] instanceof Object) {
          const path = this.findPath(
            json[key],
            keyOrIndex,
            currentPath + "/" + key
          );
          if (path) {
            return path;
          }
        }
      }
    }
    return null;
  }


  /**
   * Fetches assignable users from the cloud function.
   * Handles multiple MSPs and ensures data consistency.
   * @param {boolean} force - Whether to force a fresh fetch ignoring cached data.
   * @returns {Promise<Array>} - A promise that resolves to the list of assignable users.
   */
  async getAssignableUsers(force = false) {
    // If a request is already in progress, return the existing promise
    if (this.assignableUsersPromise) {
      console.log('Request in progress. Returning existing promise.');
      return this.assignableUsersPromise;
    }

    // If assignees are already cached and force is not true, return the cached data
    if (!force && window.assignees && window.assignees.length > 0) {
      console.log('Returning cached assignees.');
      return Promise.resolve(window.assignees);
    }

    // Create a new promise for the fetch request and store it
    this.assignableUsersPromise = (async () => {
      try {
        const idToken = await getIdToken(this.FBAuth.currentUser);
        const fetchURL = window.location.hostname.includes("localhost")
          ? "http://localhost:5001/dev-deiterate/australia-southeast1"
          : import.meta.env.VITE_cloudFunctionURL;

        const partner = await this.getActivePartner();
        
        // Handle case where customer has multiple MSPs
        const mspIDs = [];
        if (partner.tech?.mspID) {
          mspIDs.push(partner.tech.mspID);
        }
        if (partner.business?.mspID) {
          mspIDs.push(partner.business.mspID);
        }

        // If no MSPs found, use default partner mspID
        if (mspIDs.length === 0 && partner.mspID) {
          mspIDs.push(partner.mspID);
        }

        // Fetch assignees from all MSPs
        const assigneesPromises = mspIDs.map(async (mspID) => {
          const response = await fetch(`${fetchURL}/deiterateInternalAPI/assurance/getAssignee`, {
            method: "POST", 
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${idToken}`,
              "Company-ID": localStorage.getItem("companyID"),
            },
            body: JSON.stringify({
              customerID: localStorage.getItem("companyID"),
              mspID: mspID,
              msp: window.isMSP,
            }),
          });

          if (!response.ok) {
            throw new Error(`Network response was not ok: ${response.statusText}`);
          }

          const res = await response.json();
          return res.assignees || [];
        });

        // Wait for all requests to complete
        const assigneesArrays = await Promise.all(assigneesPromises);

        // Merge and deduplicate assignees based on userID
        const uniqueAssignees = {};
        assigneesArrays.flat().forEach(assignee => {
          if (assignee.userID) {
            uniqueAssignees[assignee.userID] = assignee;
          }
        });

        const mergedAssignees = Object.values(uniqueAssignees);
        console.log('Fetched and merged assignees:', mergedAssignees);

        // Cache the merged assignees
        window.assignees = mergedAssignees;

        return mergedAssignees;
      } catch (error) {
        console.error("Failed to fetch assignable users:", error);
        throw error; // Propagate the error to be handled by the caller
      } finally {
        // Clear the promise
        this.assignableUsersPromise = null;
      }
    })();

    return this.assignableUsersPromise;
  }


  async addToAssignableArray(customerUsers, roleSet) {
    let users = [];

    for (let key in customerUsers) {
      if (customerUsers.hasOwnProperty(key)) {
        const user = customerUsers[key];
        if (user == undefined) continue;

        this.debug.log("Role Set Testing - Customer User", user);
        this.debug.log("Role Set Testing - Customer User", user.ismsRole);

        await this.getAssignedToName(user.userID).then((name) => {
          if (name === undefined) return;
          this.debug.log("Name Testing", name, user.ismsRole, roleSet);

          if (roleSet.includes(user.ismsRole)) {
            let userObj = {
              userID: user.userID,
              firstName: name.split(" ")[0],
              lastName: name.split(" ")[1],
              role: user.ismsRole,
            };
            users.push(userObj);
          }
        });
      }
    }

    console.log(`Users`, users);

    return users;
  }

  async getAssignableUsersByRole(role) {
    if (window.planDetails.plan == "starter") {
      return await this.getAssignableUsers();
    }

    const customerOrg = await this.getCompanyData("customerOrg");
    const customerUsers = customerOrg.users;

    const ismsRoles = await this.getISMSRoles();
    this.debug.log("ISMS Roles =>", ismsRoles);

    let roleSet = [];
    for (let key in ismsRoles) {
      if (ismsRoles.hasOwnProperty(key)) {
        const role = ismsRoles[key];
        this.debug.log("Running Role", role);
        if (role == undefined || role.roleName == "User") continue;
        roleSet.push(role.roleName);
      }
    }
    this.debug.log("Role Set Testing", roleSet);

    const assignableUsers = await this.addToAssignableArray(
      customerUsers,
      roleSet
    );
    this.debug.log("Array Testing", assignableUsers);
    return assignableUsers;
  }

  async getISMSSponsor() {
    if (window.planDetails.plan == "starter") {
      return await this.getAssignableUsers();
    }

    const customerOrg = await this.getCompanyData("customerOrg");
    const customerUsers = customerOrg.users;

    const ismsRoles = await this.getISMSRoles();
    this.debug.log("ISMS Roles =>", ismsRoles);

    let roleSet = ["ISMS Sponsor", "Business Sponsor"];
    // for (let key in ismsRoles) {
    //   if (ismsRoles.hasOwnProperty(key)) {
    //     const role = ismsRoles[key];
    //     this.debug.log('Running Role', role);
    //     if (role == undefined || (role.roleName != 'ISMS Sponsor') || (role.roleName != 'Business Sponsor')) continue;
    //     roleSet.push(role.roleName);
    //   }
    // }
    this.debug.log("Role Set Testing", roleSet);

    const assignableUsers = await this.addToAssignableArray(
      customerUsers,
      roleSet
    );
    this.debug.log("Array Testing", assignableUsers);
    return assignableUsers;
  }

  async getNewAssuranceID() {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "assurance"
    );

    return getDoc(docRef).then((doc) => {
      if (doc.exists()) {
        let data = doc.data();
        let keys = Object.keys(data);
        this.debug.log("Keys =>", keys);
        this.debug.log("Keys Length =>", keys.length);
        let newAssID = keys.length + 6;
        this.debug.log("New Assurance ID =>", newAssID);
        return newAssID;
      }
    });
  }

  async getProcRefs(standard) {
    if (standard == null || standard.length == 0 || standard == undefined)
      return null;

    if (standard.toLowerCase() == "essential_8") {
      // firestore path is /compliance/E8Controls
      // get all documents in the collection
      // and return the corresponding controlID for the control.

      let docRef = doc(FBDatabase, "compliance", "E8Controls");

      return getDoc(docRef)
        .then((doc) => {
          if (doc.exists()) {
            let data = doc.data();
            let keys = Object.keys(data);
            this.debug.log("Keys =>", keys);
            this.debug.log("Keys Length =>", keys.length);

            let procRefs = [];

            for (let i = 0; i < keys.length; i++) {
              const key = keys[i];
              let control = data[key];
              let controlID = control.controlID;
              let controlName = control.acscControl;
              const procData = {
                controlID: controlID,
                controlName: controlName,
              };

              procRefs.push(procData);
            }

            this.debug.log("Proc Refs =>", procRefs);

            return procRefs;
          }
        })
        .catch((error) => {
          this.debug.log(error);
        });
    } else if (standard.toLowerCase() == "privacy_act") {
      // firestore path is /compliance/PAControls
      // get that document from the compliance collection
      // return all corresponsing controlIDs within that map

      let docRef = doc(FBDatabase, "compliance", "paControls");

      return getDoc(docRef)
        .then((doc) => {
          if (doc.exists()) {
            let data = doc.data();
            let keys = Object.keys(data);
            this.debug.log("Keys =>", keys);
            this.debug.log("Keys Length =>", keys.length);

            let procRefs = [];

            for (let i = 0; i < keys.length; i++) {
              const key = keys[i];
              let control = data[key];
              let controlID = control.controlID;
              let controlName = control.paControl;
              const procData = {
                controlID: controlID,
                controlName: controlName,
              };

              procRefs.push(procData);
            }

            this.debug.log("Proc Refs =>", procRefs);

            return procRefs;
          }
        })
        .catch((error) => {
          this.debug.log(error);
        });
    } else if (standard.toLowerCase() == "soc2:2017") {
      // firestore path is /compliance/PAControls
      // get that document from the compliance collection
      // return all corresponsing controlIDs within that map

      let docRef = doc(FBDatabase, "compliance", "SOC2Controls");

      return getDoc(docRef)
        .then((doc) => {
          if (doc.exists()) {
            let data = doc.data();
            let keys = Object.keys(data);
            this.debug.log("Keys =>", keys);
            this.debug.log("Keys Length =>", keys.length);

            let procRefs = [];

            for (let i = 0; i < keys.length; i++) {
              const key = keys[i];
              let control = data[key];
              let controlID = control.controlID;
              const procData = {
                controlID: controlID,
                controlName: "",
              };

              procRefs.push(procData);
            }

            this.debug.log("Proc Refs =>", procRefs);

            return procRefs;
          }
        })
        .catch((error) => {
          this.debug.log(error);
        });
    } else if (standard.toLowerCase() == "iso27001:2013") {
      let docRef = doc(FBDatabase, "compliance", "iso270012013AnnexAControls");

      return getDoc(docRef)
        .then((doc) => {
          if (doc.exists()) {
            let data = doc.data();
            let keys = Object.keys(data);
            this.debug.log("Keys =>", keys);
            this.debug.log("Keys Length =>", keys.length);

            let procRefs = [];

            const sortedKeys = Object.keys(data).sort(
              (a, b) => a.slice(2) - b.slice(2)
            );

            sortedKeys.forEach((k) => {
              const keysWithDot = Object.keys(data[k]).filter((r) =>
                r.includes(".")
              );

              keysWithDot
                .sort((a, b) => a - b)
                .forEach((sk) => {
                  const procData = {
                    controlID: sk,
                    controlName: data[k][sk].controlName,
                  };

                  procRefs.push(procData);
                });
            });

            this.debug.log("Proc Refs =>", procRefs);

            return procRefs;
          }
        })
        .catch((error) => {
          this.debug.log(error);
        });
    }
  }

  async saveNewAssuranceTask() {
    return this.getNewAssuranceID().then(async (newAssID) => {
      let last_check = document.querySelector("#last-check");
      let parts = last_check.value.split("/");
      let lastCheckDate = new Date(parts[2], parts[1] - 1, parts[0]);
      let nextCheckDate = new Date(lastCheckDate + 30);
      nextCheckDate.setDate(
        nextCheckDate.getDate() +
        document.querySelector("#check_interval_value").value
      );
      const docRef = doc(
        FBDatabase,
        "customers",
        localStorage.getItem("companyID"),
        "compliance",
        "assurance"
      );

      if (
        document
          .querySelector("#framework_value")
          .value.replaceAll(" ", "_")
          .toLowerCase() == "iso27001:2013" ||
        document
          .querySelector("#framework_value")
          .value.replaceAll(" ", "_")
          .toLowerCase() == "soc2:2017"
      ) {
        return setDoc(
          docRef,
          {
            ["ass" + newAssID.toString().padStart(3, "0")]: {
              //ass002
              assID: "ass" + newAssID.toString().padStart(3, "0"),
              checkDetail: {
                active: document.querySelector("#status_picker_value").value,
                assignedTo: document.querySelector("#assigned_to_value").value,
                check: document.querySelector("#task_name").value, // change
                createdBy: getAuth().currentUser.uid,
                createdDate: serverTimestamp(),
                evidence: document.querySelector("#evidence_value").value, // change
                framework: {
                  0: {
                    frameName: document.querySelector("#framework_value").value,
                  },
                },
                internalProcess: document.querySelector(
                  "#internal_process_value"
                ).value, // change
                meetingID: "",
                meetingNeeded: document.querySelector("#meeting_value").value,
                procRef: document.querySelector(
                  "#compliance_reference_autocomplete"
                ).value, // change
              },
              checkFrequency: {
                checkDays: parseInt(
                  document.querySelector("#check_interval_value").value
                ),
                lastCheck: {
                  1: {
                    checkDate: lastCheckDate,
                    checkStatus: "complete",
                  },
                },
                nextCheck: nextCheckDate,
                reminderActive: "",
                reminderDays: document.querySelector("#reminder_days_value")
                  .value,
                sendReminder: "true",
              },
              checkHistory: {
                1: {
                  assignedTo:
                    document.querySelector("#assigned_to_value").value,
                  check: document.querySelector("#task_name").value, // change
                  checkStatus: "complete",
                  comments: "",
                  dataClassification: "",
                  lastCheck: lastCheckDate,
                  performedBy:
                    document.querySelector("#assigned_to_value").value,
                  performedDate: lastCheckDate,
                  scheduledDate: lastCheckDate,
                },
                active: "",
                numberPreviousChecks: "1",
              },
              history: {
                0: {
                  changeID: 0,
                  changedBy: getAuth().currentUser.uid,
                  dateChanged: serverTimestamp(),
                  fieldsChanged: {
                    0: {
                      dbFieldName: "assID",
                      fieldName: "Task ID",
                      newValue: "ass" + newAssID.toString(),
                      oldValue: "",
                    },
                    1: {
                      dbFieldName: "active",
                      fieldName: "Active",
                      newValue: document.querySelector("#status_picker_value")
                        .value,
                      oldValue: "",
                    },
                    2: {
                      dbFieldName: "assignedTo",
                      fieldName: "Assigned To",
                      newValue:
                        document.querySelector("#assigned_to_value").value,
                      oldValue: "",
                    },
                    3: {
                      dbFieldName: "check",
                      fieldName: "Task",
                      newValue:
                        document.querySelector("#framework_value").value,
                      oldValue: "",
                    },
                    4: {
                      dbFieldName: "createdBy",
                      fieldName: "",
                      newValue: getAuth().currentUser.uid,
                      oldValue: "",
                    },
                    5: {
                      dbFieldName: "createdDate",
                      fieldName: "",
                      newValue: serverTimestamp(),
                      oldValue: "",
                    },
                    6: {
                      dbFieldName: "evidence",
                      fieldName: "Evidence",
                      newValue: document.querySelector("#evidence_value").value,
                      oldValue: "",
                    },
                    7: {
                      dbFieldName: "frameName",
                      fieldName: "framework",
                      newValue:
                        document.querySelector("#framework_value").value,
                      oldValue: "",
                    },
                    8: {
                      dbFieldName: "internalProcess",
                      fieldName: "Internal Process",
                      newValue: document.querySelector(
                        "#internal_process_value"
                      ).value, // change
                      oldValue: "",
                    },
                    9: {
                      dbFieldName: "meetingID",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    10: {
                      dbFieldName: "meetingNeeded",
                      fieldName: "Meeting Required",
                      newValue: document.querySelector("#meeting_value").value,
                      oldValue: "",
                    },
                    11: {
                      dbFieldName: "active",
                      fieldName: "Active",
                      newValue: document.querySelector("#status_picker_value")
                        .value,
                      oldValue: "",
                    },
                    12: {
                      dbFieldName: "procRef",
                      fieldName: "Compliance",
                      newValue: ["need to figure out"], // change
                      oldValue: "",
                    },
                    13: {
                      dbFieldName: "checkDays",
                      fieldName: "Check Interval (days)",
                      newValue: document.querySelector("#check_interval_value")
                        .value,
                      oldValue: "",
                    },
                    14: {
                      dbFieldName: "checkDate",
                      fieldName: "Last Check",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                    15: {
                      dbFieldName: "checkStatus",
                      fieldName: "",
                      newValue: "complete",
                      oldValue: "",
                    },
                    16: {
                      dbFieldName: "nextCheck",
                      fieldName: "",
                      newValue: nextCheckDate,
                      oldValue: "",
                    },
                    17: {
                      dbFieldName: "reminderActive",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    18: {
                      dbFieldName: "reminderDays",
                      fieldName: "Reminder (days)",
                      newValue: document.querySelector("#reminder_days_value")
                        .value,
                      oldValue: "",
                    },
                    19: {
                      dbFieldName: "sendReminder",
                      fieldName: "",
                      newValue: "true",
                      oldValue: "",
                    },
                    20: {
                      dbFieldName: "assignedTo",
                      fieldName: "",
                      newValue:
                        document.querySelector("#assigned_to_value").value,
                      oldValue: "",
                    },
                    21: {
                      dbFieldName: "check",
                      fieldName: "",
                      newValue: document.querySelector("#task_name").value,
                      oldValue: "",
                    },
                    22: {
                      dbFieldName: "checkStatus",
                      fieldName: "",
                      newValue: "complete",
                      oldValue: "",
                    },
                    23: {
                      dbFieldName: "active",
                      fieldName: "Active",
                      newValue: document.querySelector("#status_picker_value")
                        .value,
                      oldValue: "",
                    },
                    24: {
                      dbFieldName: "comments",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    25: {
                      dbFieldName: "dataClassification",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    26: {
                      dbFieldName: "lastCheck",
                      fieldName: "",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                    27: {
                      dbFieldName: "performedBy",
                      fieldName: "",
                      newValue:
                        document.querySelector("#assigned_to_value").value,
                      oldValue: "",
                    },
                    28: {
                      dbFieldName: "performedDate",
                      fieldName: "",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                    29: {
                      dbFieldName: "scheduledDate",
                      fieldName: "",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                  },
                },
              },
            },
          },
          {
            merge: true,
          }
        )
          .then(async (e) => {
            this.debug.log(
              "(Assurance Creator) Document successfully written!",
              e
            );
            await this.savedNotification({
              title: "Compliance Calendar",
              text: "Assurance Task Created.",
            });
            return true;
          })
          .catch((e) => {
            this.debug.error("(Assurance Creator) Error writing document: ", e);
            return false;
          });
      } else if (
        document
          .querySelector("#framework_value")
          .value.replaceAll(" ", "_")
          .toLowerCase() == "privacy_act"
      ) {
        return setDoc(
          docRef,
          {
            ["PA_ASS" + newAssID.toString().padStart(2, "0")]: {
              //ass002
              assID: "PA_ASS" + newAssID.toString().padStart(2, "0"),
              checkDetail: {
                active: document.querySelector("#status_picker_value").value,
                assignedTo: document.querySelector("#assigned_to_value").value,
                check: document.querySelector("#task_name").value, // change
                createdBy: getAuth().currentUser.uid,
                createdDate: serverTimestamp(),
                evidence: document.querySelector("#evidence_value").value, // change
                framework: {
                  0: {
                    frameName: document.querySelector("#framework_value").value,
                  },
                },
                paDetails: {
                  guidanceNotes:
                    document.querySelector("#guidance_notes").value,
                  paCategory: document.querySelector("#pa_category").value,
                  paSuggestedEvidence: document.querySelector(
                    "#pa_suggested_evidence"
                  ).value,
                }, // change
                procRef: document.querySelector(
                  "#compliance_reference_autocomplete"
                ).value, // change
              },
              checkFrequency: {
                checkDays: parseInt(
                  document.querySelector("#check_interval_value").value
                ),
                lastCheck: {
                  1: {
                    checkDate: lastCheckDate,
                    checkStatus: "complete",
                  },
                },
                nextCheck: nextCheckDate,
                reminderActive: "",
                reminderDays: document.querySelector("#reminder_days_value")
                  .value,
                sendReminder: "true",
              },
              checkHistory: {
                1: {
                  assignedTo:
                    document.querySelector("#assigned_to_value").value,
                  check: document.querySelector("#task_name").value, // change
                  checkStatus: "complete",
                  comments: "",
                  dataClassification: "",
                  lastCheck: lastCheckDate,
                  performedBy:
                    document.querySelector("#assigned_to_value").value,
                  performedDate: lastCheckDate,
                  scheduledDate: lastCheckDate,
                },
                active: "",
                numberPreviousChecks: "1",
              },
              history: {
                0: {
                  changeID: 0,
                  changedBy: getAuth().currentUser.uid,
                  dateChanged: serverTimestamp(),
                  fieldsChanged: {
                    0: {
                      dbFieldName: "assID",
                      fieldName: "Task ID",
                      newValue: "PA_ASS" + newAssID.toString(),
                      oldValue: "",
                    },
                    1: {
                      dbFieldName: "active",
                      fieldName: "Active",
                      newValue: document.querySelector("#status_picker_value")
                        .value,
                      oldValue: "",
                    },
                    2: {
                      dbFieldName: "assignedTo",
                      fieldName: "Assigned To",
                      newValue:
                        document.querySelector("#assigned_to_value").value,
                      oldValue: "",
                    },
                    3: {
                      dbFieldName: "check",
                      fieldName: "Task",
                      newValue:
                        document.querySelector("#framework_value").value,
                      oldValue: "",
                    },
                    4: {
                      dbFieldName: "createdBy",
                      fieldName: "",
                      newValue: getAuth().currentUser.uid,
                      oldValue: "",
                    },
                    5: {
                      dbFieldName: "createdDate",
                      fieldName: "",
                      newValue: serverTimestamp(),
                      oldValue: "",
                    },
                    6: {
                      dbFieldName: "evidence",
                      fieldName: "Evidence",
                      newValue: document.querySelector("#evidence_value").value,
                      oldValue: "",
                    },
                    7: {
                      dbFieldName: "frameName",
                      fieldName: "framework",
                      newValue:
                        document.querySelector("#framework_value").value,
                      oldValue: "",
                    },
                    8: {
                      dbFieldName: "active",
                      fieldName: "Active",
                      newValue: document.querySelector("#status_picker_value")
                        .value,
                      oldValue: "",
                    },
                    9: {
                      dbFieldName: "procRef",
                      fieldName: "Compliance",
                      newValue: document.querySelector(
                        "#compliance_reference_autocomplete"
                      ).value, // change
                      oldValue: "",
                    },
                    10: {
                      dbFieldName: "checkDays",
                      fieldName: "Check Interval (days)",
                      newValue: document.querySelector("#check_interval_value")
                        .value,
                      oldValue: "",
                    },
                    11: {
                      dbFieldName: "checkDate",
                      fieldName: "Last Check",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                    12: {
                      dbFieldName: "checkStatus",
                      fieldName: "",
                      newValue: "complete",
                      oldValue: "",
                    },
                    13: {
                      dbFieldName: "nextCheck",
                      fieldName: "",
                      newValue: nextCheckDate,
                      oldValue: "",
                    },
                    14: {
                      dbFieldName: "reminderActive",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    15: {
                      dbFieldName: "reminderDays",
                      fieldName: "Reminder (days)",
                      newValue: document.querySelector("#reminder_days_value")
                        .value,
                      oldValue: "",
                    },
                    16: {
                      dbFieldName: "sendReminder",
                      fieldName: "",
                      newValue: "true",
                      oldValue: "",
                    },
                    17: {
                      dbFieldName: "assignedTo",
                      fieldName: "",
                      newValue:
                        document.querySelector("#assigned_to_value").value,
                      oldValue: "",
                    },
                    18: {
                      dbFieldName: "check",
                      fieldName: "",
                      newValue: document.querySelector("#task_name").value,
                      oldValue: "",
                    },
                    19: {
                      dbFieldName: "checkStatus",
                      fieldName: "",
                      newValue: "complete",
                      oldValue: "",
                    },
                    20: {
                      dbFieldName: "active",
                      fieldName: "Active",
                      newValue: document.querySelector("#status_picker_value")
                        .value,
                      oldValue: "",
                    },
                    21: {
                      dbFieldName: "comments",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    22: {
                      dbFieldName: "dataClassification",
                      fieldName: "",
                      newValue: "",
                      oldValue: "",
                    },
                    23: {
                      dbFieldName: "lastCheck",
                      fieldName: "",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                    24: {
                      dbFieldName: "performedBy",
                      fieldName: "",
                      newValue:
                        document.querySelector("#assigned_to_value").value,
                      oldValue: "",
                    },
                    25: {
                      dbFieldName: "performedDate",
                      fieldName: "",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                    26: {
                      dbFieldName: "scheduledDate",
                      fieldName: "",
                      newValue: lastCheckDate,
                      oldValue: "",
                    },
                  },
                },
              },
            },
          },
          {
            merge: true,
          }
        )
          .then(async (e) => {
            this.debug.log(
              "(Assurance Creator) Document successfully written!",
              e
            );
            await this.savedNotification({
              title: "Compliance Calendar",
              text: "Assurance Task Created.",
            });
            return true;
          })
          .catch((e) => {
            this.debug.error("(Assurance Creator) Error writing document: ", e);
            return false;
          });
      }
    });
  }

  SVGToDataURI(svgString) {
    // Create a new Blob object with the SVG string
    const blob = new Blob([svgString], {
      type: "image/svg+xml",
    });

    // Create a URL object from the Blob
    const url = URL.createObjectURL(blob);

    // Create an image element and set its source to the URL
    const img = new Image();
    img.src = url;

    // Create a canvas element
    const canvas = document.createElement("canvas");
    const context = canvas.getContext("2d");

    // Wait for the image to load
    return new Promise((resolve, reject) => {
      img.onload = () => {
        // Set the canvas dimensions to match the image
        canvas.width = img.width;
        canvas.height = img.height;

        // Draw the image onto the canvas
        context.drawImage(img, 0, 0);

        // Get the data URI from the canvas
        const dataURI = canvas.toDataURL();

        // Clean up by revoking the URL object
        URL.revokeObjectURL(url);

        // Resolve the promise with the data URI
        resolve(dataURI);
      };

      // Reject the promise if the image fails to load
      img.onerror = () => {
        reject(new Error("Failed to load the SVG image."));
      };
    });
  }

  /**
   * This function retrieves the read progress of a policy for a specific company from a Firebase
   * database.
   * @param policyRef - The policy reference is a parameter that is passed to the function
   * `getCompanyReadProgress()`. It is used to retrieve the read progress of a specific policy for a
   * company.
   * @returns a Promise that resolves to the policyReadData object if the policyReadDoc exists in the
   * "customers" collection in the Firebase database. If the policyReadDoc does not exist, the function
   * does not return anything.
   */
  getCompanyReadProgress(policyRef) {
    if (localStorage.getItem("companyID") !== "") {
      let companyRef = doc(
        FBDatabase,
        "customers",
        localStorage.getItem("companyID")
      );
      this.debug.log("Policy Ref => ", policyRef);
      return getDoc(companyRef).then((policyReadDoc) => {
        if (policyReadDoc.exists) {
          let policyReadData = policyReadDoc.data();
          return policyReadData;
        }
      });
    }
  }
  /**
   * This function retrieves the read progress data for a specific policy reference from a Firebase
   * database.
   * @param policyRef - The policyRef parameter is a reference to a specific policy document in the
   * Firebase database. It is used to retrieve the read progress data for that policy document.
   * @returns a Promise that resolves to the policyReadData object if the policyReadDoc exists in the
   * specified document reference, otherwise it returns undefined.
   */
  getPolicyReadProgress(policyRef) {
    this.debug.log("Policy Ref => ", policyRef);
    let docRef = doc(
      FBDatabase,
      "users",
      getAuth().currentUser.uid,
      "policyReadProgress",
      policyRef
    );
    return getDoc(docRef)
      .then((policyReadDoc) => {
        if (policyReadDoc.exists) {
          let policyReadData = policyReadDoc.data();
          return policyReadData;
        }
      })
      .catch((error) => {
        this.debug.log(error);

        return {
          currentScreen: "0",
          readProgress: 0,
        };
      });
  }

  // checkAnswers(data) {
  //   let correctCount = 0;
  //   let totalQuestions = 0;

  //   // Iterate through the properties of the data object
  //   for (const key in data) {
  //     if (data.hasOwnProperty(key)) {
  //       // Check if the key matches the question format (e.g., "1CorrectAnswer", "1GivenAnswer")
  //       const match = key.match(/^(\d+)(CorrectAnswer|GivenAnswer)$/);
  //       if (match) {
  //         const questionNumber = match[1];
  //         const answerType = match[2];

  //         // Get the correct answer or given answer based on the answer type
  //         const answer = data[key];
  //         const correctAnswer = data[`${questionNumber}CorrectAnswer`];
  //         const givenAnswer = data[`${questionNumber}GivenAnswer`];

  //         // Only count if both answers exist
  //         if (correctAnswer !== undefined && givenAnswer !== undefined) {
  //           totalQuestions++;
  //           if (correctAnswer === givenAnswer) {
  //             correctCount++;
  //           }
  //         }
  //       }
  //     }
  //   }

  //   // If both correctCount and totalQuestions are zero, set allCorrect to false
  //   if (correctCount === 0 && totalQuestions === 0) {
  //     return {
  //       correctCount: 0,
  //       totalQuestions: 0,
  //       allCorrect: false
  //     };
  //   }

  //   return {
  //     correctCount,
  //     totalQuestions,
  //     allCorrect: correctCount === totalQuestions
  //   };
  // }
  checkAnswers(data) {
    let correctCount = 0;
    let totalQuestions = 0;

    // Iterate through the properties of the data object
    for (const key in data) {
      if (data.hasOwnProperty(key)) {
        // Check if the key matches the GivenAnswer format (e.g., "1GivenAnswer")
        const match = key.match(/^(\d+)GivenAnswer$/);
        if (match) {
          const questionNumber = match[1];

          // Get the correct answer and the given answer for this question
          const correctAnswer = data[`${questionNumber}CorrectAnswer`];
          const givenAnswer = data[key];

          // Only count if both answers exist
          if (correctAnswer !== undefined && givenAnswer !== undefined) {
            totalQuestions++;
            if (correctAnswer === givenAnswer) {
              correctCount++;
            }
          }
        }
      }
    }

    // If both correctCount and totalQuestions are zero, set allCorrect to false
    if (correctCount === 0 && totalQuestions === 0) {
      return {
        correctCount: 0,
        totalQuestions: 0,
        allCorrect: false
      };
    }

    return {
      correctCount,
      totalQuestions,
      allCorrect: correctCount === totalQuestions
    };
  }

  getMostRecentAttempt(attempts) {
    let mostRecent = null;
    let mostRecentTime = null;

    // Iterate over the attempts
    for (const attemptKey in attempts) {
      if (attempts.hasOwnProperty(attemptKey) && attemptKey.startsWith("attempt_")) {
        const attempt = attempts[attemptKey];
        let attemptTime = null;

        // Find the latest time answered in this attempt
        for (const key in attempt) {
          if (attempt.hasOwnProperty(key) && key.endsWith("TimeAnswered")) {
            const timeAnswered = new Date(attempt[key].toDate()).getTime();
            attemptTime = attemptTime === null ? timeAnswered : Math.max(attemptTime, timeAnswered);
          }
        }

        // Check if this attempt is more recent than the current most recent
        if (mostRecentTime === null || (attemptTime && attemptTime > mostRecentTime)) {
          mostRecentTime = attemptTime;
          mostRecent = attempt;
        }
      }
    }

    return mostRecent;
  }

  async validateQuizResults(policyRef, customPolicy = false) {
    // /users/SkeNW6MAwyPL3kYHljtfr3R6HRv1/assignedPolicies/policy_02/policy_quiz_results/results
    try {
      let quizQuestions = await this.getQuizQuestions(policyRef);
      console.log('QuizQuestions', quizQuestions)
      let quizResults = getDoc(doc(this.FBDatabase, 'users', getAuth().currentUser.uid, 'assignedPolicies', `${policyRef}`, 'policy_quiz_results', 'results')).then((quizResultsDoc) => {
        if (quizResultsDoc.exists) {
          let attempts = quizResultsDoc.data();
          let attempt = this.getMostRecentAttempt(attempts);
          let results = this.checkAnswers(attempt);

          if (customPolicy) {
            results.totalQuestions = 0;
          } else {
            results.totalQuestions = Object.keys(quizQuestions).length;
          }

          return results;
        }
        return null;
      });

      return quizResults;
    } catch (error) {
      console.error('Error validating quiz results: ', error);
    }
  }
  /**
   * This function builds a policy item with read progress data and returns it as a list item
   * element.
   * @param policyData - It is an object containing data related to a policy, such as the policy
   * name, read time, etc.
   * @param policyRef - The policy reference or identifier used to retrieve policy data.
   * @returns a Promise that resolves to an HTML `li` element containing information about a policy
   * item, including its title, read progress, subtitle, and estimated read time.
   */
  buildPolicyItem(policyData, policyRef, completedPolicy) {
    return this.getPolicyReadProgress(policyRef).then((readProgressData) => {
      let li = document.createElement("li");
      let itemLink = document.createElement("a");
      itemLink.classList.add("item-link");
      return this.getPolicyReadProgress(policyRef).then((readProgressData) => {
        if (readProgressData !== undefined) {
          if (readProgressData["currentScreen"] !== undefined) {
            if (readProgressData["currentScreen"] === "0") {
              itemLink.setAttribute(
                "href",
                `/screen-reader/policy/${policyRef}`
              );
            } else {
              if (readProgressData["readProgress"] >= policyData["ReadTime"]) {
                if (completedPolicy) {
                  itemLink.setAttribute(
                    "href",
                    `/screen-reader/policy/${policyRef}`
                  );
                } else {
                  itemLink.setAttribute(
                    "href",
                    `/screen-reader/policy/${policyRef}/screen/screen${readProgressData["currentScreen"]}/congratulations`
                  );
                }
                this.getQuizResults(policyRef).then((quizResultsX) => {
                  let quizResults = Object.keys(quizResultsX).map((key) => {
                    if (!key.includes("_number")) {
                      return quizResultsX[key];
                    }
                  });
                  if (quizResults !== undefined) {
                    let latestQuizItem = quizResults[0];
                    this.debug.log("Quiz Results", quizResults);
                    this.getQuizQuestions(policyRef).then((quizQuestions) => {
                      let correctlyAnswered = "";
                      if (latestQuizItem == undefined) {
                        correctlyAnswered = 0;
                        return;
                      } else {
                        if (latestQuizItem["correctlyAnswered"] == undefined) {
                          this.debug.log(
                            "Correctly Answered is undefined",
                            correctlyAnswered
                          );
                          this.debug.log(
                            policyRef,
                            "Latest Quiz Item: ",
                            latestQuizItem
                          );
                          correctlyAnswered = 0;
                          return;
                        } else {
                          correctlyAnswered =
                            latestQuizItem["correctlyAnswered"];
                        }
                      }
                      this.debug.log(
                        "Question Count: ",
                        policyData["quizCount"],
                        "Correctly Answered: ",
                        Number(parseInt(correctlyAnswered)),
                        "For Policy: ",
                        policyRef
                      );
                      if (correctlyAnswered < quizQuestions.length) {
                        Object.keys(latestQuizItem).forEach((key) => {
                          if (
                            key.includes("CorrectAnswer") ||
                            key.includes("GivenAnswer")
                          ) {
                            let questionNumber = key.match(/\d+/g)[0];
                            let CorrectAnswer =
                              latestQuizItem[`${questionNumber}CorrectAnswer`];
                            let GivenAnswer =
                              latestQuizItem[`${questionNumber}GivenAnswer`];
                            this.debug.log(
                              policyRef,
                              "Correct Answer: ",
                              CorrectAnswer,
                              "Given Answer: ",
                              GivenAnswer
                            );
                            if (CorrectAnswer !== GivenAnswer) {
                              this.debug.log(
                                "You need to retry policy: ",
                                policyRef,
                                "Question: ",
                                questionNumber
                              );
                              localStorage.setItem(
                                `retryPolicy${policyRef}Question${questionNumber}`,
                                "true"
                              );
                              if (completedPolicy) {
                                itemLink.setAttribute(
                                  "href",
                                  `/screen-reader/policy/${policyRef}`
                                );
                              } else {
                                if (readProgressData["currentScreen"] == "0") {
                                  itemLink.setAttribute(
                                    "href",
                                    `/screen-reader/policy/${policyRef}`
                                  );
                                } else {
                                  itemLink.setAttribute(
                                    "href",
                                    `/screen-reader/policy/${policyRef}/screen/screen${readProgressData["currentScreen"]}/quiz/quiz${questionNumber}`
                                  );
                                }
                              }
                            } else {
                              localStorage.setItem(
                                `retryPolicy${policyRef}Question${questionNumber}`,
                                "false"
                              );
                            }
                          }
                        });
                      }
                    });
                  } else {
                    if (readProgressData["currentScreen"] == "0") {
                      itemLink.setAttribute(
                        "href",
                        `/screen-reader/policy/${policyRef}`
                      );
                    } else {
                      itemLink.setAttribute(
                        "href",
                        `/screen-reader/policy/${policyRef}/screen/screen${readProgressData["currentScreen"]}`
                      );
                    }
                  }
                });
              } else {
                // itemLink.setAttribute("href", `/screen-reader/policy/${policyRef}/screen/screen${readProgressData["currentScreen"]}`);
                if (readProgressData["currentScreen"] == "0") {
                  itemLink.setAttribute(
                    "href",
                    `/screen-reader/policy/${policyRef}`
                  );
                } else {
                  itemLink.setAttribute(
                    "href",
                    `/screen-reader/policy/${policyRef}/screen/screen${readProgressData["currentScreen"]}`
                  );
                }
              }
            }
          } else {
            itemLink.setAttribute("href", `/screen-reader/policy/${policyRef}`);
          }
        } else {
          itemLink.setAttribute("href", `/screen-reader/policy/${policyRef}`);
        }
        let itemContent = document.createElement("div");
        itemContent.classList.add("item-content");
        let itemMedia = document.createElement("div");
        itemMedia.classList.add("item-media");
        let companyImg = document.createElement("img");
        companyImg.classList.add("companyImg");
        itemMedia.append(companyImg);
        itemContent.append(itemMedia);
        let itemInner = document.createElement("div");
        itemInner.classList.add("item-inner");
        let itemTitleRow = document.createElement("div");
        itemTitleRow.classList.add("item-title-row");
        let itemTitle = document.createElement("div");
        itemTitle.classList.add("item-title");
        itemTitle.innerText = policyData["policy_name"];
        itemTitleRow.append(itemTitle);
        let itemAfter = document.createElement("div");
        itemAfter.classList.add("item-after");
        let readProgress = 0;
        if (readProgressData !== undefined) {
          this.debug.log(readProgressData);
          readProgress = readProgressData["readProgress"];
        }
        let companyReadTime = policyData["ReadTime"];
        let calc = Math.round((readProgress / companyReadTime) * 100);
        if (completedPolicy === "false") {
          if (readProgress >= companyReadTime) {
            calc = 100;
          } else if (calc >= 100) {
            calc = 100;
          }
        } else {
          calc = 100;
        }
        // Check quiz here in case its a false 100%
        console.log('Policy References', policyRef)
        return this.validateQuizResults(policyRef).then((quizResults) => {
          console.log('Calculated Quiz Results', quizResults)
          if (!quizResults.allCorrect) {
            itemAfter.innerHTML = `<span>${Math.floor(calc)}% Reading</span>&nbsp;<span>${quizResults.totalQuestions !== 0 ? Math.floor((quizResults.correctCount / quizResults.totalQuestions) * 100) + '%' : 'No'} Quiz</span>`; // Read Progress divided by Company Read Time Times 100 ((readProgress / companyReadTime) * 100)
          } else {
            itemAfter.innerHTML = `<span>${calc}% Reading</span>&nbsp;<span>${quizResults.totalQuestions !== 0 ? Math.round((quizResults.correctCount / quizResults.totalQuestions) * 100) + '%' : 'No'} Quiz</span>`; // Read Progress divided by Company Read Time Times 100 ((readProgress / companyReadTime) * 100)
          }
          itemTitleRow.append(itemAfter);
          itemInner.append(itemTitleRow);
          let itemSubtitle = document.createElement("div");
          itemSubtitle.classList.add("item-subtitle");
          itemSubtitle.innerText = "ISO27001";
          itemInner.append(itemSubtitle);
          let itemText = document.createElement("div");
          itemText.classList.add("item-text");
          itemText.innerText = policyData["ReadTime"] + " minute read";
          itemInner.append(itemText);
          itemContent.append(itemInner);
          itemLink.append(itemContent);
          li.append(itemLink);
          return li;
        });
      });
    });
  }
  /**
   * This function builds a policy item with read progress data and returns it as a list item
   * element.
   * @param policyData - It is an object containing data related to a policy, such as the policy
   * name, read time, etc.
   * @param policyRef - The policy reference or identifier used to retrieve policy data.
   * @returns a Promise that resolves to an HTML `li` element containing information about a policy
   * item, including its title, read progress, subtitle, and estimated read time.
   */
  buildCustomPolicyItem(policyData, policyRef, completedPolicy) {
    return this.getPolicyReadProgress(policyRef).then((readProgressData) => {
      let li = document.createElement("li");
      let itemLink = document.createElement("a");
      itemLink.classList.add("item-link");
      return this.getPolicyReadProgress(policyRef).then((readProgressData) => {
        itemLink.setAttribute(
          "href",
          `/custom-screen-reader/policy/${policyRef}`
        );
        let itemContent = document.createElement("div");
        itemContent.classList.add("item-content");
        let itemMedia = document.createElement("div");
        itemMedia.classList.add("item-media");
        let companyImg = document.createElement("img");
        companyImg.classList.add("companyImg");
        itemMedia.append(companyImg);
        itemContent.append(itemMedia);
        let itemInner = document.createElement("div");
        itemInner.classList.add("item-inner");
        let itemTitleRow = document.createElement("div");
        itemTitleRow.classList.add("item-title-row");
        let itemTitle = document.createElement("div");
        itemTitle.classList.add("item-title");
        itemTitle.innerText = policyData["policy_name"];
        itemTitleRow.append(itemTitle);
        let itemAfter = document.createElement("div");
        itemAfter.classList.add("item-after");
        let readProgress = 0;
        if (readProgressData !== undefined) {
          this.debug.log(readProgressData);
          readProgress = readProgressData["readProgress"];
        }
        let companyReadTime = policyData["ReadTime"];
        let calc = Math.round((readProgress / companyReadTime) * 100);
        if (completedPolicy === "false") {
          if (readProgress >= companyReadTime) {
            calc = 100;
          } else if (calc >= 100) {
            calc = 100;
          }
        } else {
          calc = 100;
        }
        // Check quiz here in case its a false 100%
        console.log('Policy References', policyRef)
        return this.validateQuizResults(policyRef, true).then((quizResults) => {
          console.log('Calculated Quiz Results', quizResults)
          if (!quizResults.allCorrect) {
            itemAfter.innerHTML = `<span>${calc}% Reading</span>&nbsp;<span>${quizResults.totalQuestions !== 0 ? Math.round((quizResults.correctCount / quizResults.totalQuestions) * 100) + '%' : 'No'} Quiz</span>`; // Read Progress divided by Company Read Time Times 100 ((readProgress / companyReadTime) * 100)
          } else {
            itemAfter.innerHTML = `<span>${Math.floor(calc)}% Reading</span>&nbsp;<span>${quizResults.totalQuestions !== 0 ? Math.floor((quizResults.correctCount / quizResults.totalQuestions) * 100) + '%' : 'No'} Quiz</span>`; // Read Progress divided by Company Read Time Times 100 ((readProgress / companyReadTime) * 100)
          }
          itemTitleRow.append(itemAfter);
          itemInner.append(itemTitleRow);
          let itemSubtitle = document.createElement("div");
          itemSubtitle.classList.add("item-subtitle");
          itemSubtitle.innerText = "ISO27001";
          itemInner.append(itemSubtitle);
          let itemText = document.createElement("div");
          itemText.classList.add("item-text");
          itemText.innerText = policyData["ReadTime"] + " minute read";
          itemInner.append(itemText);
          itemContent.append(itemInner);
          itemLink.append(itemContent);
          li.append(itemLink);
          return li;
        });
      });
    });
  }
  // /**
  //  * This function builds a policy item with read progress data and returns it as a list item
  //  * element.
  //  * @param policyData - It is an object containing data related to a policy, such as the policy
  //  * name, read time, etc.
  //  * @param policyRef - The policy reference or identifier used to retrieve policy data.
  //  * @returns a Promise that resolves to an HTML `li` element containing information about a policy
  //  * item, including its title, read progress, subtitle, and estimated read time.
  //  */
  // buildCustomPolicyItem(policyData, policyRef, completedPolicy) {
  //   return this.getPolicyReadProgress(policyRef).then((readProgressData) => {
  //     let li = document.createElement("li");
  //     let itemLink = document.createElement("a");
  //     itemLink.classList.add("item-link");
  //     return this.getPolicyReadProgress(policyRef).then((readProgressData) => {
  //       itemLink.setAttribute(
  //         "href",
  //         `/custom-screen-reader/policy/${policyRef}`
  //       );
  //       let itemContent = document.createElement("div");
  //       itemContent.classList.add("item-content");
  //       let itemMedia = document.createElement("div");
  //       itemMedia.classList.add("item-media");
  //       let companyImg = document.createElement("img");
  //       companyImg.classList.add("companyImg");
  //       itemMedia.append(companyImg);
  //       itemContent.append(itemMedia);
  //       let itemInner = document.createElement("div");
  //       itemInner.classList.add("item-inner");
  //       let itemTitleRow = document.createElement("div");
  //       itemTitleRow.classList.add("item-title-row");
  //       let itemTitle = document.createElement("div");
  //       itemTitle.classList.add("item-title");
  //       itemTitle.innerText = policyData["policy_name"];
  //       itemTitleRow.append(itemTitle);
  //       let itemAfter = document.createElement("div");
  //       itemAfter.classList.add("item-after");
  //       let readProgress = 0;
  //       if (readProgressData !== undefined) {
  //         this.debug.log(readProgressData);
  //         readProgress = readProgressData["readProgress"];
  //       }
  //       let companyReadTime = policyData["ReadTime"];
  //       let calc = Math.round((readProgress / companyReadTime) * 100);
  //       if (completedPolicy === "false") {
  //         if (readProgress >= companyReadTime) {
  //           calc = 80;
  //         } else if (calc >= 100) {
  //           calc = 100;
  //         }
  //       } else {
  //         calc = 100;
  //       }
  //       itemAfter.innerText = calc + "% Completed"; // Read Progress divided by Company Read Time Times 100 ((readProgress / companyReadTime) * 100)
  //       itemTitleRow.append(itemAfter);
  //       itemInner.append(itemTitleRow);
  //       let itemSubtitle = document.createElement("div");
  //       itemSubtitle.classList.add("item-subtitle");
  //       itemSubtitle.innerText = "ISO27001";
  //       itemInner.append(itemSubtitle);
  //       let itemText = document.createElement("div");
  //       itemText.classList.add("item-text");
  //       itemText.innerText = policyData["ReadTime"] + " minute read";
  //       itemInner.append(itemText);
  //       itemContent.append(itemInner);
  //       itemLink.append(itemContent);
  //       li.append(itemLink);
  //       return li;
  //     });
  //   });
  // }
  /**
   * This function retrieves the number of screens associated with a given policy reference.
   * @param policyRef - The `policyRef` parameter is a reference to a specific policy within a policy
   * package in a customer's product.
   * @returns A promise that resolves to the number of documents in the "screens" collection under the
   * specified policy reference in the Firebase database.
   */
  getScreenCount(policyRef) {
    let docRef = collection(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "policies",
      policyRef,
      "screens"
    );
    let screenCount = -1;
    return getDocs(docRef).then((docs) => {
      docs.forEach((doc) => {
        screenCount++;
      });
      return screenCount;
    });
  }
  async updateCurrentScreenForPolicy(policyRef, screenID) {
    let uid = getAuth().currentUser.uid;
    let policiesRef = doc(
      collection(
        FBDatabase,
        "users",
        uid,
        "assignedPolicies"
      ),
      policyRef
    );
    setDoc(
      policiesRef,
      {
        currentScreen: `${screenID}`,
      },
      {
        merge: true,
      }
    )
      .then(() => {
        // Success
        let policyReadProgressRef = doc(
          FBDatabase,
          "users",
          uid,
          "policyReadProgress",
          policyRef
        );
        setDoc(
          policyReadProgressRef,
          {
            currentScreen: screenID,
          },
          {
            merge: true,
          }
        )
          .then(() => {
            // Success
            console.log("Current screen updated successfully.");
          })
          .catch((err) => {
            this.debug.log(
              "Error updating policy read progress:",
              err
            );
          });
      })
      .catch((err) => {
        this.debug.log(
          "Error updating policies document:",
          err
        );
      });
  }
  /**
   * This function updates the read time progress of a policy when the user goes back to the previous
   * screen.
   * @param policyRef - The policy reference, which is used to identify a specific policy document in
   * the database.
   * @param screenRef - The screen reference is a string that represents the current screen being
   * viewed by the user. It is used to calculate the read time for the current screen and update the
   * user's progress accordingly.
   */
  updateReadTimeBack(policyRef, screenRef) {
    let randID = this.random(32, 500, true);
    let screenNumber = parseInt(screenRef.split("screen")[1]);
    let newScreenNumber = screenNumber - 1;
    let newScreenRef = "screen" + newScreenNumber;
    let completedReadTime = 0;
    this.getUserData()
      .then((userData) => {
        let userCurrentReadTime = parseFloat(
          userData.data.currentReadTime || "0"
        );
        this.getPolicyData(policyRef)
          .then((policyData) => {
            const policyReadTime = parseFloat(policyData.ReadTime);
            const pagesCount = parseFloat(policyData.pagesCount);
            this.getPolicyReadProgress(policyRef)
              .then((readProgressData) => {
                let currentReadTime = parseFloat(
                  readProgressData.readProgress || "0"
                );
                currentReadTime = parseFloat(
                  readProgressData.readProgress || "0"
                );
                localStorage.setItem(
                  randID,
                  JSON.stringify(
                    {
                      ...JSON.parse(localStorage.getItem(randID)),
                      currentReadTime: currentReadTime,
                    },
                    null,
                    4
                  )
                );
                this.debug.log(
                  "Current Read Time (Read Progress): " + currentReadTime
                );
                if (localStorage.getItem("companyID") !== "") {
                  this.getCompanyReadProgress(policyRef)
                    .then((companyReadProgressData) => {
                      let companyReadTime = parseInt(
                        companyReadProgressData.completedReadMinutes || "0"
                      );
                      completedReadTime = parseInt(
                        companyReadProgressData.completedReadMinutes || "0"
                      );
                      this.debug.log(
                        "Company Read Time (Completed Minutes): " +
                        companyReadTime
                      );
                      localStorage.setItem(
                        randID,
                        JSON.stringify(
                          {
                            ...JSON.parse(localStorage.getItem(randID)),
                            completedReadTime: completedReadTime,
                          },
                          null,
                          4
                        )
                      );
                      let companyRef = doc(
                        FBDatabase,
                        "customers",
                        localStorage.getItem("companyID")
                      );
                      let readTime = (policyReadTime / pagesCount).toFixed(3);
                      // Success
                      this.getScreenCount(policyRef)
                        .then((screenCount) => {
                          this.debug.log(
                            "Policy Read Time: (back)" + completedReadTime
                          );
                          this.debug.log(
                            "Current Screen Count: " + screenCount
                          );
                          let doubleScreenCount = parseFloat(pagesCount);
                          this.debug.log(
                            "Double Screen Count: " + doubleScreenCount
                          );
                          let doubleCompletedTime =
                            parseFloat(completedReadTime);
                          this.debug.log(
                            "Double Completed Time: " + doubleCompletedTime
                          );
                          let readTime = (policyReadTime / pagesCount).toFixed(
                            3
                          );
                          this.debug.log("Double Read Time: " + readTime);
                          let doubleCurrentReadTime =
                            parseFloat(currentReadTime).toFixed(3);
                          this.debug.log(
                            "Double Current Read Time: " + doubleCurrentReadTime
                          );
                          let doubleUserCurrentReadTime =
                            parseFloat(userCurrentReadTime);
                          this.debug.log(
                            "Double User Current Read Time: " +
                            doubleUserCurrentReadTime
                          );
                          let policyReadingTime =
                            parseFloat(doubleCurrentReadTime) -
                            parseFloat(readTime);
                          let userReadTime =
                            parseFloat(doubleUserCurrentReadTime) -
                            parseFloat(readTime);
                          this.debug.log("Screen Number: " + screenNumber);
                          this.debug.log(
                            "Current Read Time Number: " + currentReadTime
                          );
                          this.debug.log(
                            "Users Current Read Time Number: " +
                            userCurrentReadTime
                          );
                          this.debug.log(
                            "Policies Current Read Time Number: " +
                            policyReadingTime
                          );
                          this.updateReadingEnd(policyRef, screenRef);
                          let policyReadProgressRef = doc(
                            FBDatabase,
                            "users",
                            getAuth().currentUser.uid,
                            "policyReadProgress",
                            policyRef
                          );
                          let userRef = doc(
                            FBDatabase,
                            "users",
                            getAuth().currentUser.uid
                          );
                          if (newScreenRef !== "screen0") {
                            if (policyReadingTime > 0) {
                              setDoc(
                                policyReadProgressRef,
                                {
                                  currentScreen: `${newScreenNumber}`,
                                  readProgress: `${policyReadingTime}`,
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating policy read progress:",
                                    err
                                  );
                                });
                              setDoc(
                                userRef,
                                {
                                  currentReadTime: `${userReadTime}`,
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating user document:",
                                    err
                                  );
                                });
                              let uid = getAuth().currentUser.uid;
                              let policiesRef = doc(
                                collection(
                                  FBDatabase,
                                  "users",
                                  uid,
                                  "assignedPolicies"
                                ),
                                policyRef
                              );
                              setDoc(
                                policiesRef,
                                {
                                  currentScreen: `${newScreenNumber}`,
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating policies document:",
                                    err
                                  );
                                });
                            } else {
                              setDoc(
                                policyReadProgressRef,
                                {
                                  currentScreen: `${newScreenNumber}`,
                                  readProgress: "0",
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating policy read progress:",
                                    err
                                  );
                                });
                              if (doubleUserCurrentReadTime !== 0) {
                                setDoc(
                                  userRef,
                                  {
                                    currentReadTime: `${userReadTime}`,
                                  },
                                  {
                                    merge: true,
                                  }
                                )
                                  .then(() => {
                                    // Success
                                  })
                                  .catch((err) => {
                                    this.debug.log(
                                      "Error updating user document:",
                                      err
                                    );
                                  });
                              } else {
                                setDoc(
                                  userRef,
                                  {
                                    currentReadTime: "0",
                                  },
                                  {
                                    merge: true,
                                  }
                                )
                                  .then(() => {
                                    // Success
                                  })
                                  .catch((err) => {
                                    this.debug.log(
                                      "Error updating user document:",
                                      err
                                    );
                                  });
                              }
                              let uid = getAuth().currentUser.uid;
                              let policiesRef = doc(
                                collection(
                                  FBDatabase,
                                  "users",
                                  uid,
                                  "assignedPolicies"
                                ),
                                policyRef
                              );
                              setDoc(
                                policiesRef,
                                {
                                  currentScreen: `${newScreenNumber}`,
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating policies document:",
                                    err
                                  );
                                });
                            }
                          } else {
                            let policyReadProgressRef = doc(
                              FBDatabase,
                              "users",
                              getAuth().currentUser.uid,
                              "policyReadProgress",
                              policyRef
                            );
                            setDoc(
                              policyReadProgressRef,
                              {
                                currentScreen: newScreenNumber,
                                readProgress: "0",
                              },
                              {
                                merge: true,
                              }
                            )
                              .then(() => {
                                // Success
                              })
                              .catch((err) => {
                                this.debug.log(
                                  "Error updating policy read progress:",
                                  err
                                );
                              });
                            let userRef = doc(
                              FBDatabase,
                              "users",
                              getAuth().currentUser.uid
                            );
                            if (doubleUserCurrentReadTime !== 0) {
                              setDoc(
                                userRef,
                                {
                                  currentReadTime: `${doubleUserCurrentReadTime}`,
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating user document:",
                                    err
                                  );
                                });
                            } else {
                              setDoc(
                                userRef,
                                {
                                  currentReadTime: "0",
                                },
                                {
                                  merge: true,
                                }
                              )
                                .then(() => {
                                  // Success
                                })
                                .catch((err) => {
                                  this.debug.log(
                                    "Error updating user document:",
                                    err
                                  );
                                });
                            }
                            let policiesRef = doc(
                              FBDatabase,
                              "users",
                              getAuth().currentUser.uid,
                              "assignedPolicies",
                              policyRef
                            );
                            setDoc(
                              policiesRef,
                              {
                                currentScreen: newScreenNumber,
                              },
                              {
                                merge: true,
                              }
                            )
                              .then(() => {
                                // Success
                              })
                              .catch((err) => {
                                this.debug.log(
                                  "Error updating policies document:",
                                  err
                                );
                              });
                          }
                        })
                        .catch((err) => {
                          this.debug.log("Error retrieving screen count:", err);
                        });
                    })
                    .catch((err) => {
                      this.debug.log(
                        "Error retrieving company read progress:",
                        err
                      );
                    });
                }
              })
              .catch((err) => {
                this.debug.log("Error retrieving policy read progress:", err);
              });
          })
          .catch((err) => {
            this.debug.log("Error retrieving policy data:", err);
          });
      })
      .catch((err) => {
        this.debug.log("Error retrieving policy data:", err);
      });
  }
  /**
   * This function updates the read time for a screen in a policy and updates the user and company read
   * progress accordingly.
   * @param policyRef - The reference to a policy document in a Firestore database.
   * @param screenRef - The screen reference, which is a string that identifies a specific screen in a
   * policy. It is used to update the read time for that screen.
   */
  // updateReadTime(policyRef, screenRef, lastScreen = false) {
  //   let randID = this.random(32, 500, true);
  //   let screenNumber = parseInt(screenRef.split('screen')[1]);
  //   this.debug.log('Updating Read Time for Screen: ' + screenNumber);
  //   let newScreenNumber = screenNumber;
  //   if (!lastScreen) {
  //     newScreenNumber = screenNumber + 1;
  //   }
  //   this.debug.log('New Screen Number: ' + newScreenNumber);
  //   let newScreenRef = 'screen' + newScreenNumber;
  //   this.debug.log('New Screen Ref: ' + newScreenRef);
  //   let currentReadTime = 0;
  //   this.getUserData()
  //     .then((userData) => {
  //       this.debug.log('User Data: ' + JSON.stringify(userData, null, 4));
  //       let userCurrentReadTime = parseFloat(userData.data.currentReadTime || '0');
  //       this.debug.log('User Current Read Time: ' + userCurrentReadTime);
  //       this.getPolicyData(policyRef)
  //         .then((policyData) => {
  //           let completedReadTime = 0;
  //           const policyReadTime = parseInt(policyData.ReadTime);
  //           const pagesCount = parseInt(policyData.pagesCount);
  //           this.getScreenCount(policyRef)
  //             .then((screenCount) => {
  //               this.debug.log('Screen Count: ' + pagesCount);
  //               this.getPolicyReadProgress(policyRef)
  //                 .then((readProgressData) => {
  //                   if (typeof readProgressData !== 'undefined') {
  //                     this.debug.log(
  //                       'Read Progress Data: ' + JSON.stringify(readProgressData, null, 4)
  //                     );
  //                     currentReadTime = parseFloat(readProgressData.readProgress || '0');
  //                     localStorage.setItem(
  //                       randID,
  //                       JSON.stringify(
  //                         {
  //                           ...JSON.parse(localStorage.getItem(randID)),
  //                           currentReadTime: currentReadTime,
  //                         },
  //                         null,
  //                         4
  //                       )
  //                     );
  //                     this.debug.log(
  //                       'Current Read Time (Read Progress): ' + readProgressData.readProgress
  //                     );
  //                     if (localStorage.getItem('companyID') !== '') {
  //                       this.getCompanyReadProgress(policyRef)
  //                         .then((companyReadProgressData) => {
  //                           this.debug.log(
  //                             'Company Read Progress Data: ' +
  //                               JSON.stringify(companyReadProgressData, null, 4)
  //                           );
  //                           let companyReadTime = parseInt(
  //                             companyReadProgressData.completedReadMinutes || '0'
  //                           );
  //                           completedReadTime = parseInt(
  //                             companyReadProgressData.completedReadMinutes || '0'
  //                           );
  //                           this.debug.log(
  //                             'Company Read Time: ' + companyReadProgressData.completedReadMinutes
  //                           );
  //                           let companyRef = doc(
  //                             FBDatabase,
  //                             'customers',
  //                             localStorage.getItem('companyID')
  //                           );
  //                           let readTime = (policyReadTime / pagesCount).toFixed(3);
  //                           localStorage.setItem(
  //                             randID,
  //                             JSON.stringify(
  //                               {
  //                                 ...JSON.parse(localStorage.getItem(randID)),
  //                                 completedReadTime: parseInt(
  //                                   parseInt(companyReadTime) + parseInt(readTime)
  //                                 ),
  //                               },
  //                               null,
  //                               4
  //                             )
  //                           );
  //                           this.debug.log('Read Time (company): ' + readTime);
  //                           let userReadData = doc(
  //                             collection(
  //                               FBDatabase,
  //                               'users',
  //                               getAuth().currentUser.uid,
  //                               'usersActualReadTime'
  //                             ),
  //                             policyRef
  //                           );
  //                           this.updateReadingEnd(policyRef, screenRef);
  //                           if (newScreenNumber <= pagesCount) {
  //                             let policyReadProgressRef = doc(
  //                               collection(
  //                                 FBDatabase,
  //                                 'users',
  //                                 getAuth().currentUser.uid,
  //                                 'policyReadProgress'
  //                               ),
  //                               policyRef
  //                             );
  //                             let userRef = doc(
  //                               collection(FBDatabase, 'users'),
  //                               getAuth().currentUser.uid
  //                             );
  //                             completedReadTime = parseInt(
  //                               JSON.parse(localStorage.getItem(randID)).completedReadTime || '0'
  //                             );
  //                             currentReadTime = parseFloat(
  //                               JSON.parse(localStorage.getItem(randID)).currentReadTime || '0'
  //                             );
  //                             this.debug.log(`Policy Read Time (next): ${completedReadTime}`);
  //                             this.debug.log(`Current Screen Count: ${pagesCount}`);
  //                             let readTime = (
  //                               parseInt(policyReadTime) / parseInt(pagesCount)
  //                             ).toFixed(3);
  //                             this.debug.log('Read Time Added => ' + readTime);
  //                             let userReadTime =
  //                               parseFloat(userCurrentReadTime) + parseFloat(readTime);
  //                             let policyReadingProgress =
  //                               parseFloat(currentReadTime) + parseFloat(readTime);
  //                             this.debug.log(`Screen Number: ${screenNumber}`);
  //                             this.debug.log(`Current Read Time Number: ${currentReadTime}`);
  //                             this.debug.log(`Users New Read Time Number: ${userReadTime}`);
  //                             return Promise.all([
  //                               setDoc(
  //                                 policyReadProgressRef,
  //                                 {
  //                                   currentScreen: `${newScreenNumber}`,
  //                                   readProgress: `${policyReadingProgress}`,
  //                                 },
  //                                 {
  //                                   merge: true,
  //                                 }
  //                               ),
  //                               setDoc(
  //                                 userRef,
  //                                 {
  //                                   currentReadTime: `${userReadTime}`,
  //                                 },
  //                                 {
  //                                   merge: true,
  //                                 }
  //                               ),
  //                               setDoc(
  //                                 doc(
  //                                   collection(
  //                                     FBDatabase,
  //                                     'users',
  //                                     getAuth().currentUser.uid,
  //                                     'assignedPolicies'
  //                                   ),
  //                                   policyRef
  //                                 ),
  //                                 {
  //                                   currentScreen: `${newScreenNumber}`,
  //                                 },
  //                                 {
  //                                   merge: true,
  //                                 }
  //                               ),
  //                             ]);
  //                           }
  //                         })
  //                         .catch((err) => {
  //                           this.debug.log('Error updating company read progress:', err);
  //                         });
  //                     }
  //                   } else {
  //                     let readProgressData = {
  //                       readProgress: '0',
  //                     };
  //                     // doc.data() will be undefined in this case
  //                     this.debug.log(
  //                       'Read Progress Data: ' + JSON.stringify(readProgressData, null, 4)
  //                     );
  //                     currentReadTime = parseInt(readProgressData.readProgress || '0');
  //                     localStorage.setItem(
  //                       randID,
  //                       JSON.stringify(
  //                         {
  //                           ...JSON.parse(localStorage.getItem(randID)),
  //                           currentReadTime: currentReadTime,
  //                         },
  //                         null,
  //                         4
  //                       )
  //                     );
  //                     this.debug.log(
  //                       'Current Read Time (Read Progress): ' + readProgressData.readProgress
  //                     );
  //                     if (localStorage.getItem('companyID') !== '') {
  //                       this.getCompanyReadProgress(policyRef)
  //                         .then((companyReadProgressData) => {
  //                           this.debug.log(
  //                             'Company Read Progress Data: ' +
  //                               JSON.stringify(companyReadProgressData, null, 4)
  //                           );
  //                           let companyReadTime = parseInt(
  //                             companyReadProgressData.completedReadMinutes || '0'
  //                           );
  //                           completedReadTime = parseInt(
  //                             companyReadProgressData.completedReadMinutes || '0'
  //                           );
  //                           this.debug.log(
  //                             'Company Read Time: ' + companyReadProgressData.completedReadMinutes
  //                           );
  //                           let companyRef = doc(
  //                             FBDatabase,
  //                             'customers',
  //                             localStorage.getItem('companyID')
  //                           );
  //                           let readTime = (
  //                             parseInt(completedReadTime || '0') / screenCount
  //                           ).toFixed(3);
  //                           localStorage.setItem(
  //                             randID,
  //                             JSON.stringify(
  //                               {
  //                                 ...JSON.parse(localStorage.getItem(randID)),
  //                                 completedReadTime: parseInt(
  //                                   parseInt(companyReadTime) + parseInt(readTime)
  //                                 ),
  //                               },
  //                               null,
  //                               4
  //                             )
  //                           );
  //                           this.debug.log('Read Time (company): ' + readTime);
  //                           let userReadData = doc(
  //                             collection(
  //                               FBDatabase,
  //                               'users',
  //                               getAuth().currentUser.uid,
  //                               'usersActualReadTime'
  //                             ),
  //                             policyRef
  //                           );
  //                           this.updateReadingEnd(policyRef, screenRef);
  //                           if (newScreenNumber <= pagesCount) {
  //                             let policyReadProgressRef = doc(
  //                               collection(
  //                                 FBDatabase,
  //                                 'users',
  //                                 getAuth().currentUser.uid,
  //                                 'policyReadProgress'
  //                               ),
  //                               policyRef
  //                             );
  //                             let userRef = doc(
  //                               collection(FBDatabase, 'users'),
  //                               getAuth().currentUser.uid
  //                             );
  //                             completedReadTime = parseInt(
  //                               JSON.parse(localStorage.getItem(randID)).completedReadTime || '0'
  //                             );
  //                             currentReadTime = parseInt(
  //                               JSON.parse(localStorage.getItem(randID)).currentReadTime || '0'
  //                             );
  //                             this.debug.log(`Policy Read Time (next): ${completedReadTime}`);
  //                             this.debug.log(`Current Screen Count: ${pagesCount}`);
  //                             let readTime = (
  //                               parseInt(policyReadTime) / parseInt(pagesCount)
  //                             ).toFixed(3);
  //                             this.debug.log('Read Time Added => ' + readTime);
  //                             let correctReadTime = Number(currentReadTime) + Number(readTime);
  //                             let userReadTime = parseInt(userCurrentReadTime) + parseInt(readTime);
  //                             let policyReadingProgress =
  //                               parseInt(currentReadTime) + parseInt(readTime);
  //                             this.debug.log(`Screen Number: ${screenNumber}`);
  //                             this.debug.log(`Current Read Time Number: ${currentReadTime}`);
  //                             this.debug.log(`Users New Read Time Number: ${userReadTime}`);
  //                             return Promise.all([
  //                               setDoc(
  //                                 policyReadProgressRef,
  //                                 {
  //                                   currentScreen: `${newScreenNumber}`,
  //                                   readProgress: `${policyReadingProgress}`,
  //                                 },
  //                                 {
  //                                   merge: true,
  //                                 }
  //                               ),
  //                               setDoc(
  //                                 userRef,
  //                                 {
  //                                   currentReadTime: `${userReadTime}`,
  //                                 },
  //                                 {
  //                                   merge: true,
  //                                 }
  //                               ),
  //                               setDoc(
  //                                 doc(
  //                                   collection(
  //                                     FBDatabase,
  //                                     'users',
  //                                     getAuth().currentUser.uid,
  //                                     'assignedPolicies'
  //                                   ),
  //                                   policyRef
  //                                 ),
  //                                 {
  //                                   currentScreen: `${newScreenNumber}`,
  //                                 },
  //                                 {
  //                                   merge: true,
  //                                 }
  //                               ),
  //                             ]);
  //                           }
  //                         })
  //                         .catch((err) => {
  //                           this.debug.log('Error updating company read progress:', err);
  //                         });
  //                     }
  //                   }
  //                 })
  //                 .then(() => {
  //                   this.debug.log('Document Successfully Updated');
  //                 })
  //                 .catch((err) => {
  //                   this.debug.log('Error updating Document: ', err);
  //                 });
  //             })
  //             .catch((err) => {
  //               this.debug.log('Error retrieving policy read progress:', err);
  //             });
  //         })
  //         .catch((err) => {
  //           this.debug.log('Error retrieving policy data:', err);
  //         });
  //     })
  //     .catch((err) => {
  //       this.debug.log('Error retrieving user data:', err);
  //     });
  // }
  async updateReadTime(policyRef, screenRef, lastScreen = false) {
    const randID = this.random(32, 500, true);
    const screenNumber = parseInt(screenRef.split("screen")[1]);

    this.debug.log(`Updating Read Time for Screen: ${screenNumber}`);

    let newScreenNumber = lastScreen ? screenNumber : screenNumber + 1;

    this.debug.log(`New Screen Number: ${newScreenNumber}`);

    const newScreenRef = `screen${newScreenNumber}`;

    this.debug.log(`New Screen Ref: ${newScreenRef}`);

    try {
      const userData = await this.getUserData();

      this.debug.log(`User Data: ${JSON.stringify(userData, null, 4)}`);

      const userCurrentReadTime = parseFloat(
        userData.data.currentReadTime || "0"
      );

      this.debug.log(`User Current Read Time: ${userCurrentReadTime}`);

      const policyData = await this.getPolicyData(policyRef);

      const policyReadTime = parseInt(policyData.ReadTime);
      const pagesCount = parseInt(policyData.pagesCount);

      this.debug.log(`Screen Count: ${pagesCount}`);

      const screenCount = await this.getScreenCount(policyRef);

      const readProgressData = (await this.getPolicyReadProgress(
        policyRef
      )) || {
        readProgress: "0",
      };

      this.debug.log(
        `Read Progress Data: ${JSON.stringify(readProgressData, null, 4)}`
      );

      let currentReadTime = parseFloat(readProgressData.readProgress || "0");

      localStorage.setItem(
        randID,
        JSON.stringify(
          { ...JSON.parse(localStorage.getItem(randID)), currentReadTime },
          null,
          4
        )
      );

      this.debug.log(
        `Current Read Time (Read Progress): ${readProgressData.readProgress}`
      );

      if (localStorage.getItem("companyID") !== "") {
        const companyReadProgressData = await this.getCompanyReadProgress(
          policyRef
        );

        this.debug.log(
          `Company Read Progress Data: ${JSON.stringify(
            companyReadProgressData,
            null,
            4
          )}`
        );

        let companyReadTime = parseInt(
          companyReadProgressData.completedReadMinutes || "0"
        );

        this.debug.log(
          `Company Read Time: ${companyReadProgressData.completedReadMinutes}`
        );

        const companyRef = doc(
          FBDatabase,
          "customers",
          localStorage.getItem("companyID")
        );

        const readTime = (policyReadTime / pagesCount).toFixed(3);

        localStorage.setItem(
          randID,
          JSON.stringify(
            {
              ...JSON.parse(localStorage.getItem(randID)),
              completedReadTime: parseInt(companyReadTime) + parseInt(readTime),
            },
            null,
            4
          )
        );

        this.debug.log(`Read Time (company): ${readTime}`);

        const userReadData = doc(
          collection(
            FBDatabase,
            "users",
            getAuth().currentUser.uid,
            "usersActualReadTime"
          ),
          policyRef
        );

        // this.updateReadingEnd(policyRef, screenRef);

        if (newScreenNumber <= pagesCount) {
          const policyReadProgressRef = doc(
            collection(
              FBDatabase,
              "users",
              getAuth().currentUser.uid,
              "policyReadProgress"
            ),
            policyRef
          );

          const userRef = doc(
            collection(FBDatabase, "users"),
            getAuth().currentUser.uid
          );

          const completedReadTime = parseInt(
            JSON.parse(localStorage.getItem(randID)).completedReadTime || "0"
          );
          const currentReadTime = parseFloat(
            JSON.parse(localStorage.getItem(randID)).currentReadTime || "0"
          );

          this.debug.log(`Policy Read Time (next): ${completedReadTime}`);
          this.debug.log(`Current Screen Count: ${pagesCount}`);

          const readTime = (
            parseInt(policyReadTime) / parseInt(pagesCount)
          ).toFixed(3);

          this.debug.log(`Read Time Added => ${readTime}`);

          const userReadTime =
            parseFloat(userCurrentReadTime) + parseFloat(readTime);
          const policyReadingProgress =
            parseFloat(currentReadTime) + parseFloat(readTime);

          this.debug.log(`Screen Number: ${screenNumber}`);
          this.debug.log(`Current Read Time Number: ${currentReadTime}`);
          this.debug.log(`Users New Read Time Number: ${userReadTime}`);

          await Promise.all([
            setDoc(
              policyReadProgressRef,
              {
                currentScreen: `${newScreenNumber}`,
                readProgress: `${policyReadingProgress}`,
              },
              { merge: true }
            ),
            setDoc(
              userRef,
              { currentReadTime: `${userReadTime}` },
              { merge: true }
            ),
            setDoc(
              doc(
                collection(
                  FBDatabase,
                  "users",
                  getAuth().currentUser.uid,
                  "assignedPolicies"
                ),
                policyRef
              ),
              { currentScreen: `${newScreenNumber}` },
              { merge: true }
            ),
          ]);
        }
      }
    } catch (error) {
      this.debug.log("Error:", error);
    }
  }

  async updateReadTimeCustom(policyRef, lastScreen = false) {
    const randID = this.random(32, 500, true);

    try {
      const userData = await this.getUserData();

      this.debug.log(`User Data: ${JSON.stringify(userData, null, 4)}`);

      const userCurrentReadTime = parseFloat(
        userData.data.currentReadTime || "0"
      );

      this.debug.log(`User Current Read Time: ${userCurrentReadTime}`);

      const policyData = await this.getPolicyData(policyRef);

      const policyReadTime = parseInt(policyData.ReadTime);
      const pagesCount = parseInt(policyData.pagesCount);

      const readProgressData = (await this.getPolicyReadProgress(
        policyRef
      )) || {
        readProgress: "0",
      };

      this.debug.log(
        `Read Progress Data: ${JSON.stringify(readProgressData, null, 4)}`
      );

      let currentReadTime = parseFloat(readProgressData.readProgress || "0");

      localStorage.setItem(
        randID,
        JSON.stringify(
          { ...JSON.parse(localStorage.getItem(randID)), currentReadTime },
          null,
          4
        )
      );

      this.debug.log(
        `Current Read Time (Read Progress): ${readProgressData.readProgress}`
      );

      if (localStorage.getItem("companyID") !== "") {

        const readTime = (policyReadTime / 1).toFixed(3);

        localStorage.setItem(
          randID,
          JSON.stringify(
            {
              ...JSON.parse(localStorage.getItem(randID)),
              completedReadTime: parseInt(readTime),
            },
            null,
            4
          )
        );

        this.debug.log(`Read Time: ${readTime}`);

        // this.updateReadingEnd(policyRef, screenRef);
        const policyReadProgressRef = doc(
          collection(
            FBDatabase,
            "users",
            getAuth().currentUser.uid,
            "policyReadProgress"
          ),
          policyRef
        );

        const userRef = doc(
          collection(FBDatabase, "users"),
          getAuth().currentUser.uid
        );

        const completedReadTime = parseInt(
          JSON.parse(localStorage.getItem(randID)).completedReadTime || "0"
        );
        const currentReadTime = parseFloat(
          JSON.parse(localStorage.getItem(randID)).currentReadTime || "0"
        );

        this.debug.log(`Policy Read Time (next): ${completedReadTime}`);
        this.debug.log(`Current Screen Count: ${pagesCount}`);


        this.debug.log(`Read Time Added => ${readTime}`);

        const userReadTime =
          parseFloat(userCurrentReadTime) + parseFloat(readTime);
        const policyReadingProgress =
          parseFloat(currentReadTime) + parseFloat(readTime);

        this.debug.log(`Current Read Time Number: ${currentReadTime}`);
        this.debug.log(`Users New Read Time Number: ${userReadTime}`);

        await Promise.all([
          setDoc(
            policyReadProgressRef,
            {
              currentScreen: `${pagesCount}`,
              readProgress: `${policyReadingProgress}`,
            },
            { merge: true }
          ),
          setDoc(
            userRef,
            { currentReadTime: `${userReadTime}` },
            { merge: true }
          ),
          setDoc(
            doc(
              collection(
                FBDatabase,
                "users",
                getAuth().currentUser.uid,
                "assignedPolicies"
              ),
              policyRef
            ),
            { currentScreen: `${newScreenNumber}` },
            { merge: true }
          ),
        ]);
      }
    } catch (error) {
      this.debug.log("Error:", error);
    }
  }

  /**
   * This function updates the reading begin time for a specific screen in a user's document in a
   * Firebase database.
   * @param policyRef - The reference to the policy document that needs to be updated with the reading
   * begin time for a specific screen.
   * @param screenRef - The `screenRef` parameter is a string that represents the screen or page that
   * the user is currently reading. It is used to update the `readingBegin` timestamp for that
   * particular screen in the user's `usersActualReadTime` document in Firestore.
   */
  async updateReadingBegin(policyRef, screenRef, lastScreen = false) {
    let userReadDataRef = doc(
      collection(
        FBDatabase,
        "users",
        getAuth().currentUser.uid,
        "usersActualReadTime"
      ),
      policyRef
    );

    console.log(
      "Updating ReadingBegin for Policy:",
      policyRef,
      " and Screen:",
      screenRef
    );
    // await this.updateReadTime(policyRef, screenRef, lastScreen);
    setDoc(
      userReadDataRef,
      {
        [`${screenRef}ReadingBegin`]: new Date(),
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }

  async updateReadingBeginCustom(policyRef, lastScreen = false) {
    let userReadDataRef = doc(
      collection(
        FBDatabase,
        "users",
        getAuth().currentUser.uid,
        "usersActualReadTime"
      ),
      policyRef
    );

    console.log(
      "Updating ReadingBegin for Policy:",
      policyRef,
    );
    // await this.updateReadTime(policyRef, screenRef, lastScreen);
    setDoc(
      userReadDataRef,
      {
        [`ReadingBegin`]: new Date(),
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }
  /**
   * This function updates the reading end time for a specific screen in a user's document in a
   * Firebase database.
   * @param policyRef - The reference to the policy document that is being updated in the Firestore
   * database.
   * @param screenRef - The `screenRef` parameter is a string that represents the screen or page that
   * the user is currently reading. It is used to update the `readingEnd` timestamp for that particular
   * screen in the user's `usersActualReadTime` document in Firestore.
   */
  async updateReadingEnd(policyRef, screenRef, lastScreen) {
    let userReadDataRef = doc(
      collection(
        FBDatabase,
        "users",
        getAuth().currentUser.uid,
        "usersActualReadTime"
      ),
      policyRef
    );
    console.log(
      "Updating ReadingEnd for Policy:",
      policyRef,
      "timestamp: ",
      new Date()
    );
    await this.updateReadTime(policyRef, screenRef, lastScreen);
    setDoc(
      userReadDataRef,
      {
        [`${screenRef}ReadingEnd`]: new Date(),
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }

  async updateReadingEndCustom(policyRef, lastScreen) {
    let userReadDataRef = doc(
      collection(
        FBDatabase,
        "users",
        getAuth().currentUser.uid,
        "usersActualReadTime"
      ),
      policyRef
    );
    console.log(
      "Updating ReadingEnd for Policy:",
      policyRef,
      "timestamp: ",
      new Date()
    );
    await this.updateReadTimeCustom(policyRef, lastScreen);
    setDoc(
      userReadDataRef,
      {
        [`ReadingEnd`]: new Date(),
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }
  /**
   * This function retrieves data from a specific document in a Firebase database and returns it.
   * @param policyRef - The reference to a specific policy document in the Firebase database.
   * @param screenRef - The `screenRef` parameter is not used in the `getCongratulations` function. It
   * is not clear what it is intended for without more context.
   * @returns the data of the "congratulations" screen for a specific policy, which is retrieved from a
   * Firestore database. If the document exists, it returns the data as an object. If the document does
   * not exist, it does not return anything.
   */
  getCongratulations(policyRef, screenRef) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "policies",
      policyRef,
      "screens",
      "congratulations"
    );
    return getDoc(docRef).then((congratsDoc) => {
      if (congratsDoc.exists) {
        this.debug.log("Congrats ID =>", congratsDoc.id);
        this.debug.log("Congrats Data =>", congratsDoc.data());
        return congratsDoc.data();
      }
    });
  }
  /**
   * This function retrieves quiz questions from a Firebase database based on a given policy reference.
   * @param policyRef - The `policyRef` parameter is a string that represents the reference to a
   * specific policy in a Firebase Firestore database. It is used to retrieve quiz questions associated
   * with that policy from the database.
   * @returns This function returns a promise that resolves to an array of quiz questions.
   */
  getQuizQuestions(policyRef) {
    let collectionRef = collection(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "policies",
      policyRef,
      "screens"
    );
    return getDocs(collectionRef).then((querySnapshot) => {
      let quizQuestions = [];
      querySnapshot.forEach((doc) => {
        if (doc.id.includes("quiz")) {
          quizQuestions.push(doc.data());
        }
      });
      return quizQuestions;
    });
  }
  /**
   * This function retrieves quiz data from a Firebase database based on a given policy reference and
   * quiz reference.
   * @param policyRef - The reference ID of a policy within a company's product offerings.
   * @param quizRef - quizRef is a reference to a specific quiz screen within a policy package for a
   * customer in a Firebase database.
   * @returns The function `getQuizData` returns a Promise that resolves to the data of a quiz document
   * in Firestore, identified by the `policyRef` and `quizRef` parameters. If the quiz document exists,
   * the function logs its ID and data to the console and returns the data. If the quiz document does
   * not exist, the function does not return anything.
   */
  getQuizData(policyRef, quizRef) {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "policies",
      policyRef,
      "screens",
      quizRef
    );
    return getDoc(docRef).then((quizDoc) => {
      if (quizDoc.exists) {
        this.debug.log("Quiz ID =>", quizDoc.id);
        this.debug.log("Quiz Data =>", quizDoc.data());
        return quizDoc.data();
      }
    });
  }
  /**
   * This function retrieves quiz answers from quiz data and returns them either as an array or an
   * object depending on the value of the maintainKey parameter.
   * @param policyRef - It is a reference to a policy, which is likely used to retrieve quiz data
   * related to that policy.
   * @param quizRef - The quiz reference, which is used to retrieve the quiz data.
   * @param [maintainKey=false] - `maintainKey` is a boolean parameter that determines whether the
   * returned quiz answers should be in an array or an object. If `maintainKey` is `false`, the
   * function will return an array of quiz answers. If `maintainKey` is `true`, the function will
   * return an
   * @returns The function `getQuizAnswers` is returning a Promise that resolves to an array of quiz
   * answers or an object of quiz answers depending on the value of the `maintainKey` parameter.
   */
  getQuizAnswers(policyRef, quizRef, maintainKey = false) {
    return this.getQuizData(policyRef, quizRef).then((quizData) => {
      if (!maintainKey) {
        let quizAnswers = [];
        Object.keys(quizData).forEach((question) => {
          if (question.includes("proc_question")) {
            let procQuestionData = quizData[question];
            Object.keys(procQuestionData).forEach((procQuestion) => {
              if (procQuestion.includes("proc_answer")) {
                quizAnswers.push(procQuestionData[procQuestion]);
              }
            });
          }
        });
        return quizAnswers;
      } else {
        let quizAnswers = {};
        Object.keys(quizData).forEach((question) => {
          if (question.includes("proc_question")) {
            let procQuestionData = quizData[question];
            Object.keys(procQuestionData).forEach((procQuestion) => {
              if (procQuestion.includes("proc_answer_correct")) {
                quizAnswers["proc_answer_correct"] =
                  procQuestionData[procQuestion];
              }
            });
          }
        });
        return quizAnswers;
      }
    });
  }
  /**
   * This function retrieves quiz results data from a Firebase database for a specific policy assigned to
   * a user.
   * @param policyRef - The `policyRef` parameter is a reference to a specific policy assigned to a user
   * in a Firebase database. It is used to retrieve the quiz results for that policy from the database.
   * @returns The function `getQuizResults(policyRef)` returns a Promise that resolves to the quiz
   * results data for a specific policy reference. If the quiz results exist, it logs the quiz results ID
   * and data to the console and returns the quiz results data. If the quiz results do not exist, it does
   * not log anything and does not return anything.
   */
  getQuizResults(policyRef) {
    let docRef = doc(
      FBDatabase,
      "users",
      getAuth().currentUser.uid,
      "assignedPolicies",
      policyRef,
      "policy_quiz_results",
      "results"
    );
    return getDoc(docRef).then((quizResults) => {
      if (quizResults.exists) {
        this.debug.log("Quiz Results ID =>", quizResults.id);
        this.debug.log("Quiz Results Data =>", quizResults.data());
        return quizResults.data();
      }
    });
  }
  /**
   * The function takes in policy and quiz references, as well as user answers, and updates the user's
   * quiz results in the Firebase database.
   * @param policyRef - The reference to the policy being taken as a quiz.
   * @param quizRef - The parameter quizRef is not explicitly used in the given code snippet, so it is
   * unclear what it represents. It is possible that it is used in the `checkCorrectAnswer` method
   * called within the `forEach` loop, but without seeing the implementation of that method, it is
   * impossible to determine its
   * @param answers - An object containing the user's answers to the quiz questions. The keys of the
   * object are unique identifiers for each question, and the values are objects containing information
   * about the user's answer, including the quiz ID, attempt number, question number, chosen answer
   * position, and the current attempt's answers.
   */
  answerQuizQuestions(policyRef, quizRef, answers) {
    let docRef = doc(
      FBDatabase,
      "users",
      getAuth().currentUser.uid,
      "assignedPolicies",
      policyRef,
      "policy_quiz_results",
      "results"
    );
    let numberOfCorrectAnswers = 0;
    Object.keys(answers).forEach((answer) => {
      new DeiterateCommon()
        .checkCorrectAnswer(
          policyRef,
          `quiz${answers[answer].quizId}`,
          answers[answer].currentAttempt.answers[0].positions
        )
        .then((correctAnswer) => {
          answer = answers[answer].currentAttempt.answers[0];
          let correctAnswerPosition = 0;
          let chooseAnswerPosition = answer.position;
          if (answer.answer === correctAnswer) {
            correctAnswerPosition = answer.position;
            numberOfCorrectAnswers++;
          } else {
            // we now actually have the correct answer position in the array of answers for each question so we can use that
            this.debug.log(answer);
            answer.positions.forEach((AP) => {
              if (AP.answer === correctAnswer) {
                correctAnswerPosition = AP.position;
              }
            });
          }
          setDoc(
            docRef,
            {
              [`attempt_${answer.attemptNumber}`]: {
                [`${answer.questionNumber}GivenAnswer`]: `${chooseAnswerPosition}`,
                [`${answer.questionNumber}CorrectAnswer`]: `${parseInt(
                  correctAnswerPosition
                )}`,
                [`${answer.questionNumber}TimeAnswered`]: serverTimestamp(),
                [`correctlyAnswered`]: `${numberOfCorrectAnswers}`,
              },
              [`attempt_number`]: `${answer.attemptNumber}`,
            },
            {
              merge: true,
            }
          )
            .then(() => {
              this.debug.log("Document successfully written!");
              this.debug.log(
                "ANSWER LENGTH TEST",
                Object.keys(answers).length,
                numberOfCorrectAnswers
              );
              if (numberOfCorrectAnswers === Object.keys(answers).length) {
                // we have passed the quiz
                // we need to update the policy to say that the quiz has been passed
                this.markCompleted(policyRef).then(() => {
                  this.getPolicyData(policyRef).then((policyData) => {
                    let pagesCount = policyData["pagesCount"];
                    let screenCount = policyData["ReadTime"];
                    this.getPolicyReadProgress(policyRef).then(
                      (readProgressData) => {
                        let currentReadTime = parseFloat(
                          readProgressData.readProgress || "0"
                        );
                        this.getUserData().then((userData) => {
                          let userCurrentReadTime = parseFloat(
                            userData.data.currentReadTime || "0"
                          );
                          let newReadTime =
                            userCurrentReadTime - currentReadTime;
                          let newCurrentReadTime =
                            parseFloat(newReadTime) + parseFloat(screenCount);
                          let userRef = doc(
                            FBDatabase,
                            "users",
                            getAuth().currentUser.uid
                          );
                          setDoc(
                            userRef,
                            {
                              currentReadTime: `${newCurrentReadTime}`,
                            },
                            {
                              merge: true,
                            }
                          )
                            .then(() => {
                              this.updateReadProgress(policyRef, {
                                currentScreen: pagesCount,
                                readProgress: screenCount,
                              })
                                .then(() => {
                                  this.debug.log("Quiz Passed!");
                                })
                                .catch((error) => {
                                  this.debug.error(
                                    "Passed -Error writing document: ",
                                    error
                                  );
                                });
                            })
                            .catch((err) => {
                              this.debug.log(
                                "Error updating user document:",
                                err
                              );
                            });
                        });
                      }
                    );
                  });
                });
              }
            })
            .catch((error) => {
              this.debug.error("Error writing document: ", error);
            });
        });
    });
  }
  /**
   * This function checks the correct answer for a given quiz reference and policy reference.
   * @param policyRef - It is a reference to a policy, which is likely a set of rules or guidelines
   * that govern the behavior or actions of a system or organization. It is used as an input to
   * retrieve quiz answers related to that policy.
   * @param quizRef - The quiz reference, which is likely a unique identifier for a specific quiz or
   * set of quiz questions.
   * @param answer - The answer parameter is the user's answer to a quiz question.
   * @returns the value of the variable `correctAnswer`, which is obtained from the `quizAnswers`
   * object. The value of `correctAnswer` is determined by the value of the key `"proc_answer_correct"`
   * in the `quizAnswers` object.
   */
  checkCorrectAnswer(policyRef, quizRef, answer, asBool = false) {
    this.debug.log(
      "Checking Answer (Variables) =>",
      policyRef,
      quizRef,
      answer
    );
    return this.getQuizAnswers(policyRef, quizRef, true).then((quizAnswers) => {
      this.debug.log("Quiz Answers! =>", quizAnswers);
      let correctAnswer = quizAnswers["proc_answer_correct"];
      if (asBool) {
        return correctAnswer === answer;
      }
      return correctAnswer;
    });
  }
  /**
   * This function marks a policy as completed in a Firebase database for a specific user.
   * @param policyRef - The `policyRef` parameter is a reference to a specific policy document in the
   * Firebase Firestore database. It is used to locate the document that needs to be marked as
   * completed.
   * @returns The `markCompleted` function is returning a promise that resolves when the document is
   * successfully written to the Firestore database, and rejects with an error if there is an error
   * writing the document.
   */
  markCompleted(policyRef) {
    let docRef = doc(
      FBDatabase,
      "users",
      getAuth().currentUser.uid,
      "assignedPolicies",
      policyRef
    );
    return setDoc(
      docRef,
      {
        completed: "true",
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document successfully written!");
      })
      .catch((error) => {
        this.debug.error("Error writing document: ", error);
      });
  }
  /**
   * This function updates the read progress of a policy document for a specific user in a Firebase
   * database.
   * @param policyRef - The reference to the specific policy document being updated in the Firebase
   * database.
   * @param progress - The `progress` parameter is an object that contains two properties:
   * `currentScreen` and `readProgress`. These properties are used to update the current screen and the
   * read progress of a policy document for a specific user.
   * @returns The `updateReadProgress` function is returning a promise that resolves to undefined.
   */
  updateReadProgress(policyRef, progress) {
    let policyReadProgressRef = doc(
      FBDatabase,
      "users",
      getAuth().currentUser.uid,
      "policyReadProgress",
      policyRef
    );
    return setDoc(
      policyReadProgressRef,
      {
        currentScreen: progress["currentScreen"],
        readProgress: progress["readProgress"],
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document successfully updated!");
      })
      .catch((error) => {
        this.debug.error("Error updating document: ", error);
      });
  }
  /**
   * This function retrieves quiz answers from local storage and returns them as an object.
   * @returns an object containing the quiz items stored in the local storage. The keys of the object
   * are the keys of the local storage items that start with "quiz" and end with a digit, and the
   * values are the parsed JSON objects of those local storage items.
   */
  grabAnswersFromLocalStorage() {
    var quizLocalStorageItems = {};
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key.startsWith("quiz") && /\d$/.test(key)) {
        quizLocalStorageItems[key] = JSON.parse(localStorage.getItem(key));
      }
    }
    return quizLocalStorageItems;
  }
  checkRetryLocal(policyRef) {
    var quizLocalStorageItems = {};
    for (var i = 0; i < localStorage.length; i++) {
      var key = localStorage.key(i);
      if (key.includes("retry") && key.includes(policyRef)) {
        quizLocalStorageItems[key] = JSON.parse(localStorage.getItem(key));
      }
    }
    return quizLocalStorageItems;
  }
  /**
   * This function clears all quiz results stored in local storage.
   */
  clearQuizResults() {
    Object.keys(this.grabAnswersFromLocalStorage()).forEach((quiz) => {
      localStorage.removeItem(quiz);
      this.debug.log("Cleared Quiz Item =>", quiz);
    });
  }

  /* Notes for Compliance Calendar
      !! Only visible if owner
      Data comes from : /customers/{@companyID}/compliance/{@type}/{register|!assurance}/{@type|!assurance}
      Roles:
          - @role = "owner" (Owner)
          - @msp = "msp" (MSP)
          - @user = "user" (User)
      Types:
          - @type = "assurance" (Assurance Tasks)
          - @type = "risk" (Risk Tasks)
          - @type = "asset" (Asset Tasks)

    */

  async getComplianceCalendar(
    type,
    companyID = localStorage.getItem("companyID"),
    updatePage
  ) {
    // if (localStorage.getItem('complianceCalendar') !== null) {
    //   this.debug.log('[Compliance Calendar] Data found in local storage');

    //   if (type == 'assurance') {
    //     // requestIdleCallback(async () => {
    //     //   this.debug.log("[Compliance Calendar] Updating local storage data")
    //     //   this.getComplianceCalendarData(type, companyID, "default");
    //     // });
    //     return JSON.parse(localStorage.getItem('complianceCalendar'));
    //   }
    // }
    window.requestIdleCallback(async () => {
      this.debug.log("[Compliance Calendar] Updating local storage data");
      await this.getComplianceCalendarData(type, companyID, "default");
      window.updatePage();
      console.log("Updated Page");
      updatePage();
      console.log("Updated Page");
    });

    return await this.getComplianceCalendarData(type, companyID, "fast");
  }

  async getComplianceCalendarData(
    type,
    companyID = localStorage.getItem("companyID"),
    speed = "default"
  ) {
    if (speed === "default") {
      let complianceCalendarRef = doc(
        FBDatabase,
        "customers",
        companyID,
        "compliance",
        type
      );

      return getDoc(complianceCalendarRef)
        .then((doc) => {
          if (doc.exists()) {
            if (type == "assurance") {
              return this.sortComplianceDates(doc.data(), type).then((data) => {
                console.log("Please Check This: ", data);
                localStorage.setItem(
                  "complianceCalendar",
                  JSON.stringify(data)
                );
                return data;
              });
            }

            return this.sortComplianceDates(
              doc.data().register[`${type}s`],
              type
            ).then((data) => {
              return data;
            });
          } else {
            this.debug.warn("[Compliance Calendar] No such document!");
          }
        })
        .catch((error) => {
          this.debug.warn(
            "[Compliance Calendar] Error getting document:",
            error
          );
        });
    } else if (speed === "fast") {
      let complianceCalendarRef = doc(
        FBDatabase,
        "customers",
        companyID,
        "compliance",
        type
      );

      return getDoc(complianceCalendarRef)
        .then((doc) => {
          if (doc.exists()) {
            if (type == "assurance") {
              return this.sortComplianceDates(doc.data(), type).then((data) => {
                return data;
              });
            }

            return this.sortComplianceDates(
              doc.data().register[`${type}s`],
              type
            ).then((data) => {
              return data;
            });
          } else {
            this.debug.warn("[Compliance Calendar] No such document!");
          }
        })
        .catch((error) => {
          this.debug.warn(
            "[Compliance Calendar] Error getting document:",
            error
          );
        });
    }
  }

  async getSupplierRegister(companyID = localStorage.getItem("companyID")) {
    // console.log(window.location.pathname.split('/'));

    const supplierRegisterRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "asset"
    );

    try {
      const docSnapshot = await getDoc(supplierRegisterRef);
      if (docSnapshot.exists()) {
        const register = docSnapshot.data().register;
        let suppliers = register.assets;

        for (const i in suppliers) {
          if (suppliers.hasOwnProperty(i)) {
            if (
              suppliers[i].hasOwnProperty("assetIDstatus") &&
              suppliers[i].assetIDstatus.toLowerCase() === "active"
            ) {
              console.log("Supplier Index: ", i);
              console.log(
                "Supplier Website: ",
                suppliers[i].hasOwnProperty("vendorWebsite")
                  ? suppliers[i].vendorWebsite
                  : "No Website"
              );
              if (suppliers[i].hasOwnProperty("vendorWebsite")) {
                suppliers[i].supplierLogo = await this.findCompanyLogo(
                  suppliers[i].vendorWebsite
                );
              }
              console.log("Supplier Logo: ", suppliers[i].supplierLogo);
            } else {
              delete suppliers[i];
            }
          }
        }

        // console.log(suppliers)
        return suppliers;
      } else {
        console.warn("[Supplier Register] No such document!");
        return null;
      }
    } catch (error) {
      console.warn("[Supplier Register] Error getting document:", error);
      return null;
    }
  }

  getUniqueSupplierNames(dataPoints) {
    const uniqueSuppliers = {};

    const uniqueSupplierNames = [];
    Object.keys(dataPoints).forEach((key) => {
      Object.keys(dataPoints[key]).forEach((key2) => {
        Object.keys(dataPoints[key][key2].suppliers).forEach((key3) => {
          const supplier = dataPoints[key][key2].suppliers[key3];
          if (!uniqueSuppliers[supplier.assetDesc]) {
            uniqueSuppliers[supplier.assetDesc] = true;
            uniqueSupplierNames.push(supplier.assetDesc);
          }
        });
      });
    });

    return uniqueSupplierNames;
  }

  async getDataRegisterFromSupplierRegister(
    companyID = localStorage.getItem("companyID")
  ) {
    return this.getSupplierRegister(companyID).then((suppliers) => {
      console.log("[Data Register] Suppliers => ", suppliers);
      let dataRegister = { locations: {}, types: {} }; // Initialize dataRegister

      for (let supplierID in suppliers) {
        // Use for..in loop for objects
        const supplier = suppliers[supplierID];

        if (supplier.dataStorageLocations) {
          for (let i = 0; i < supplier.dataStorageLocations.length; i++) {
            let dataStorageLocation = supplier.dataStorageLocations[i];
            dataRegister.locations[dataStorageLocation] = {
              suppliers: {
                ...(dataRegister.locations[dataStorageLocation]?.suppliers ??
                  {}), // Preserve existing suppliers
                [supplierID]: {
                  assetDesc: supplier.assetDesc,
                  assetID: supplier.assetID,
                },
              },
            };
          }
        }

        if (supplier.dataTypesShared) {
          for (let i = 0; i < supplier.dataTypesShared.length; i++) {
            let dataTypeShared = supplier.dataTypesShared[i];
            dataRegister.types[dataTypeShared] = {
              suppliers: {
                ...(dataRegister.types[dataTypeShared]?.suppliers ?? {}), // Preserve existing suppliers
                [supplierID]: {
                  assetDesc: supplier.assetDesc,
                  assetID: supplier.assetID,
                },
              },
            };
          }
        }
      }

      console.log("[Data Register] Data Register => ", dataRegister);

      return dataRegister;
    });
  }

  async getDataRegisterFromRetentionSchedule(
    companyID = localStorage.getItem("companyID")
  ) {
    return this.getDataRegisterFromSupplierRegister(companyID).then(
      async (res) => {
        console.log("[Data Register] Data Register => ", res);
        let dataRegisterOld = res;
        return this.getRetentionSchedule(companyID).then(
          (retentionSchedule) => {
            console.log(
              "[Data Register] Retention Schedule => ",
              retentionSchedule
            );
            let dataRegister = {
              locations: { ...(dataRegisterOld.locations ?? {}) },
              types: {},
            }; // Initialize dataRegister

            for (let dataType in retentionSchedule) {
              dataType = retentionSchedule[dataType];
              console.log(dataType);

              dataRegister.types[dataType.dataTypeName] = {
                suppliers: {
                  ...(dataRegisterOld.types[dataType.dataTypeName]?.suppliers ??
                    {}), // Preserve existing suppliers
                },
                typeData: {
                  dataRetentionPeriod: {
                    min: dataType.dataRetentionPeriod.min,
                    max: dataType.dataRetentionPeriod.max,
                  },
                  dataTypeName: dataType.dataTypeName,
                  dataTypeMetadata: dataType.dataTypeMetadata,
                  dataTypeID: dataType.dataTypeID,
                  dataTypeJustification: dataType.dataTypeJustification,
                  deleted: dataType.deleted,
                },
              };
            }

            console.log("[Data Register] Data Register => ", dataRegister);

            return dataRegister;
          }
        );
      }
    );
  }

  async getSupplierFromRegister(
    supplierID,
    companyID = localStorage.getItem("companyID")
  ) {
    const supplierRegisterRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "asset"
    );

    try {
      const docSnapshot = await getDoc(supplierRegisterRef);
      if (docSnapshot.exists()) {
        const register = docSnapshot.data().register;
        const suppliers = register.assets;
        const supplier = suppliers[supplierID];
        console.log("[Supplier Register] Found Supplier => ", supplier);
        return supplier;
      } else {
        console.warn("[Supplier Register] No such document!");
        return null;
      }
    } catch (error) {
      console.warn("[Supplier Register] Error getting document:", error);
      return null;
    }
  }
  arraysEqual(a1, a2) {
    /* WARNING: arrays must not contain {objects} or behavior may be undefined */
    return JSON.stringify(a1) == JSON.stringify(a2);
  }

  async updateSupplierData(supplierID, key, value) {
    const docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "asset"
    );

    return setDoc(
      docRef,
      {
        register: {
          assets: {
            [`${supplierID}`]: {
              [key]: value,
            },
          },
        },
      },
      {
        merge: true,
      }
    ).then(async () => {
      await this.savedNotification({
        title: "Supplier Register",
        text: "Your changes have been saved.",
      });
    });
  }

  async removeSupplier(supplierID) {
    try {
      const supplier = await this.getSupplierFromRegister(supplierID);
      const docRef = doc(
        FBDatabase,
        "customers",
        localStorage.getItem("companyID"),
        "compliance",
        "asset"
      );

      return updateDoc(docRef, {
        [`register.assets.${supplierID}`]: deleteField(),
      }).then(async () => {
        await this.savedNotification({
          title: "Supplier Register",
          text: `${supplier.assetDesc} has been removed from the Supplier Register.`,
        });

        // window.f7.$(`#supplier-${supplierID}`).remove();

        return true;
      });
    } catch (error) {
      // Handle the error here, e.g., log it or show an error message
      console.error("Error removing supplier:", error);

      return false;
    }
  }

  async addSupplier() {
    const docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "asset"
    );

    const docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      let suppliers = await docSnapshot.data().register.assets;
      let supplierID = Object.keys(docSnapshot.data().register.assets).length; // No need to add 1 as the array starts at 0

      let largestID = 0;

      // Loop through the suppliers to find the largest ID.
      for (let i = 0; i < Object.keys(suppliers).length; i++) {
        const supplier = suppliers[i];
        if (supplier.hasOwnProperty("assetID")) {
          if (parseInt(supplier.assetID) > largestID) {
            largestID = parseInt(supplier.assetID);
          }
        } else {
          largestID = i + 1;
        }
      }

      supplierID = largestID + 1;

      let dataStorageLocations = [];
      let dataStorageLocationBadges = document.querySelectorAll(
        "#popup-data .item-input-info.data-locations .badge"
      );

      for (let i = 0; i < dataStorageLocationBadges.length; i++) {
        let badge = dataStorageLocationBadges[i];

        dataStorageLocations.push(badge.innerText);
      }

      let dataTypesShared = [];
      let dataTypesSharedBadges = document.querySelectorAll(
        "#popup-data .item-input-info.data-types .badge"
      );

      for (let i = 0; i < dataTypesSharedBadges.length; i++) {
        let badge = dataTypesSharedBadges[i];

        dataTypesShared.push(badge.innerText);
      }

      console.log("[Supplier Register] Adding new supplier...", {
        register: {
          assets: {
            [`${supplierID}`]: {
              assetCat: "Software",
              assetCriticality: "Low",
              assetDesc: window.f7
                .$('#popup-data input[name="supplierName"]')
                .val(),
              assetHistory: [],
              assetID: supplierID,
              assetIDStatus: "active",
              assetIDstatus: "active",
              assetLocation: dataStorageLocations.join(", "),
              assetOwner: getAuth().currentUser.uid,
              assetPublishInPrivacyPolicy: "No",
              assetRisk: "Low",
              assetSubprocessor: "No",
              assetTeam: "",
              backupNeeded: "No",
              classification: "Business Confidential",
              customFields: [],
              dataStorageLocations: dataStorageLocations,
              dataTypesShared: dataTypesShared,
              dataTypesSharedString: dataTypesShared.join(", "),
              dateAdded: serverTimestamp(),
              label: "No",
              lastReviewDate: serverTimestamp(),
              legalBits: "",
              portability: "No",
              securityReview: "",
              serial: "",
              socCriticality: "",
              socSubserviceOrganisation: "",
              status: "Active",
              vendorManagementNeeded: "No",
              vendorWebsite: window.f7
                .$('#popup-data input[name="supplierWebsite"]')
                .val(),
            },
          },
        },
      });

      await setDoc(
        docRef,
        {
          register: {
            assets: {
              [`${supplierID}`]: {
                assetCat: "Software",
                assetCriticality: "Low",
                assetDesc: window.f7
                  .$('#popup-data input[name="supplierName"]')
                  .val(),
                assetHistory: [],
                assetID: supplierID,
                assetIDStatus: "active",
                assetIDstatus: "active",
                assetLocation: dataStorageLocations.join(", "),
                assetOwner: getAuth().currentUser.uid,
                assetPublishInPrivacyPolicy: "No",
                assetRisk: "Low",
                assetSubprocessor: "No",
                assetTeam: "",
                backupNeeded: "No",
                classification: "Business Confidential",
                customFields: [],
                dataStorageLocations: dataStorageLocations,
                dataTypesShared: dataTypesShared,
                dataTypesSharedString: dataTypesShared.join(", "),
                dateAdded: serverTimestamp(),
                label: "No",
                lastReviewDate: serverTimestamp(),
                legalBits: "",
                portability: "No",
                securityReview: "",
                serial: "",
                socCriticality: "",
                socSubserviceOrganisation: "",
                status: "Active",
                vendorManagementNeeded: "No",
                vendorWebsite: window.f7
                  .$('#popup-data input[name="supplierWebsite"]')
                  .val(),
              },
            },
          },
        },
        { merge: true }
      );

      console.log("Successfully added new supplier!");

      await this.savedNotification({
        title: "Supplier Register",
        text: `${window.f7
          .$('#popup-data input[name="supplierName"]')
          .val()} has been added to the Supplier Register.`,
      });

      window.f7.popup.close("#popup-data", true);

      window.location.reload();

      return true;
    } else {
      console.warn("[Supplier Register] No such document!");
    }
  }

  async getFirstSupplierDataStorageLocations(
    companyID = localStorage.getItem("companyID")
  ) {
    try {
      const supplierRegister = await this.getSupplierRegister(companyID);
      const suppliers = Object.values(supplierRegister);
      console.log(suppliers);
      if (suppliers.length > 0) {
        const firstSupplier = suppliers[0];
        if (firstSupplier.dataStorageLocations) {
          const dataStorageLocations = firstSupplier.dataStorageLocations;
          const countryData = dataStorageLocations.map((location) => {
            const countryName = location;
            const latLong = this.getCoordinates(
              countryName.replace("United States of America", "USA")
            );
            return { name: countryName, latLong: latLong };
          });
          console.log(countryData);
          return countryData;
        }
      } else {
        console.warn("[Supplier Register] No suppliers found!");
        return null;
      }
    } catch (error) {
      console.warn("[Supplier Register] Error:", error);
      return null;
    }
  }

  async getDataStorageLocations(companyID = localStorage.getItem("companyID")) {
    try {
      const supplierRegister = await this.getSupplierRegister(companyID);
      const suppliers = Object.values(supplierRegister);
      console.log(suppliers);
      if (suppliers.length > 0) {
        const dataStorageLocations = [];
        suppliers.forEach((supplier) => {
          if (supplier.dataStorageLocations) {
            dataStorageLocations.push(...supplier.dataStorageLocations);
          }
        });

        const countryData = dataStorageLocations.map((location) => {
          let countryName = location;
          if (countryName.toLowerCase() === "united states of america") {
            countryName = "USA";
          }
          const latLong = this.getCoordinates(countryName.replace(" ", "_"));
          return { name: location, latLong: latLong };
        });

        console.log("Final dataStorageLocations:", countryData); // Output final dataStorageLocations to console

        return countryData;
      } else {
        console.warn("[Supplier Register] No suppliers found!");
        return null;
      }
    } catch (error) {
      console.warn("[Supplier Register] Error:", error);
      return null;
    }
  }

  async getDataRetentionPeriods(
    supplierName,
    companyID = localStorage.getItem("companyID")
  ) {
    try {
      const supplierRegister = await this.getSupplierRegister(companyID);
      const suppliers = Object.values(supplierRegister);
      console.log(suppliers);
      if (suppliers.length > 0) {
        for (const supplier of suppliers) {
          if (supplier.assetDesc === supplierName) {
            const dataRetentionPeriods = supplier.dataRetentionPeriod;
            console.log(dataRetentionPeriods);
            return dataRetentionPeriods;
          }
        }
      } else {
        console.warn("[Supplier Register] No suppliers found!");
        return null;
      }
    } catch (error) {
      console.warn("[Supplier Register] Error:", error);
      return null;
    }
  }

  async getRetentionSchedule(companyID = localStorage.getItem("companyID")) {
    let docRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "retentionSchedule"
    );

    let docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      let retentionSchedule = docSnapshot.data().register.dataTypes;

      return retentionSchedule;
    } else {
      console.warn("[Retention Schedule] No such document!");
      return null;
    }
  }

  async getDataType(
    dataTypeName,
    companyID = localStorage.getItem("companyID")
  ) {
    let retentionSchedule = await this.getRetentionSchedule(companyID);

    for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
      let key = Object.keys(retentionSchedule)[i];
      let dataType = retentionSchedule[key];

      if (dataType.dataTypeName == dataTypeName) {
        return dataType;
      }
    }

    return {
      dataTypeName: dataTypeName,
      dataRetentionPeriod: {
        min: 0,
        max: 0,
      },
      dataTypeJustification: "",
    };
  }

  async removeDataType(
    dataTypeName,
    companyID = localStorage.getItem("companyID")
  ) {
    let docRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "retentionSchedule"
    );

    let docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      let retentionSchedule = docSnapshot.data().register.dataTypes;

      for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
        let key = Object.keys(retentionSchedule)[i];
        let dataType = retentionSchedule[key];

        if (dataType.dataTypeName == dataTypeName) {
          return updateDoc(docRef, {
            [`register.dataTypes.${key}`]: deleteField(),
          }).then(async () => {
            await this.savedNotification({
              title: "Retention Schedule",
              text: `${dataTypeName} has been removed from the Retention Schedule.`,
            });

            return true;
          });
        }
      }
    } else {
      console.warn("[Retention Schedule] No such document!");
      return null;
    }

    return null;
  }

  async updateDataType(dataTypeName, key, value) {
    let dataTypeExists = false;
    let dataTypeID = null;
    let retentionSchedule = await this.getRetentionSchedule();
    const docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "retentionSchedule"
    );

    for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
      let key = Object.keys(retentionSchedule)[i];
      let dataType = retentionSchedule[key];

      if (dataType.dataTypeName == dataTypeName) {
        dataTypeExists = true;
        dataTypeID = key;
        console.log("Found data type ID: ", dataTypeID);
      }
    }

    if (dataTypeExists) {
      await updateDoc(docRef, {
        [`register.dataTypes.${dataTypeID}.${key}`]: value,
      });

      console.log("Successfully updated data type!");

      await this.savedNotification({
        title: "Retention Schedule",
        text: `${dataTypeName} has been updated.`,
      });
    } else {
      let largestID = 0;
      for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
        console.log("Index: ", i);
        console.log("Keys: ", Object.keys(retentionSchedule));
        console.log("Whole Schedule: ", retentionSchedule);
        const schedule = retentionSchedule[i];
        console.log("Schedule: ", schedule);
        if (parseInt(schedule.dataTypeID) > largestID) {
          largestID = parseInt(schedule.dataTypeID);
        }
      }

      dataTypeID = largestID + 1;

      let defaultValues = {
        dataRetentionPeriod: {
          min: 0,
          max: 120,
        },
        dataTypeJustification: "",
        dataTypeName: dataTypeName,
        dataTypeID: dataTypeID,
        deleted: false,
      };

      if (defaultValues[key] !== undefined) {
        // remove the default value if it is not undefined
        delete defaultValues[key];
      }

      return setDoc(
        docRef,
        {
          register: {
            dataTypes: {
              [`${dataTypeID}`]: {
                [key]: value,
                ...defaultValues,
              },
            },
          },
        },
        {
          merge: true,
        }
      ).then(async () => {
        await this.savedNotification({
          title: "Retention Schedule",
          text: `${dataTypeName} has been added to the Retention Schedule.`,
        });
      });
    }
  }

  async addDataType(companyID = localStorage.getItem("companyID")) {
    let dataSet = {
      dataTypeName: window.f7
        .$(`#addDataView input[name="dataTypeName"]`)
        .val(),
      dataRetentionPeriod: {
        min: parseInt(window.f7.$(`#addDataView .retentionMin`).text()),
        max: parseInt(window.f7.$(`#addDataView .retentionMax`).text()),
      },
      dataTypeJustification: window.f7
        .$(`#addDataView input[name="dataTypeJustification"]`)
        .val(),
    };

    let docRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "retentionSchedule"
    );

    let docSnapshot = await getDoc(docRef);

    if (docSnapshot.exists()) {
      let retentionSchedule = docSnapshot.data().register.dataTypes;

      let largestID = 0;

      // Loop through the suppliers to find the largest ID.
      for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
        console.log("Index: ", i);
        console.log("Keys: ", Object.keys(retentionSchedule));
        console.log("Whole Schedule: ", retentionSchedule);
        const schedule = retentionSchedule[i];
        console.log("Schedule: ", schedule);
        if (parseInt(schedule.dataTypeID) > largestID) {
          largestID = parseInt(schedule.dataTypeID);
        }
      }

      let dataTypeID = largestID + 1;

      let defaultValues = {
        dataRetentionPeriod: {
          min: dataSet.hasOwnProperty("dataRetentionPeriod")
            ? dataSet.dataRetentionPeriod.min
            : 0,
          max: dataSet.hasOwnProperty("dataRetentionPeriod")
            ? dataSet.dataRetentionPeriod.max * 12
            : 120,
        },
        dataTypeJustification: dataSet.hasOwnProperty("dataTypeJustification")
          ? dataSet.dataTypeJustification
          : "",
        dataTypeName: dataSet.hasOwnProperty("dataTypeName")
          ? dataSet.dataTypeName
          : dataSet.dataTypeName,
        dataTypeID: dataTypeID,
        deleted: false,
      };

      return setDoc(
        docRef,
        {
          register: {
            dataTypes: {
              [`${dataTypeID}`]: {
                ...defaultValues,
              },
            },
          },
        },
        {
          merge: true,
        }
      ).then(async () => {
        await this.savedNotification({
          title: "Retention Schedule",
          text: `${dataSet.dataTypeName} has been added to the Retention Schedule.`,
        });
      });
    } else {
      console.warn("[Retention Schedule] No such document!");
      return null;
    }
  }

  async updateDataRetentionPeriods(
    dataType,
    dataRetentionPeriods,
    companyID = localStorage.getItem("companyID")
  ) {
    let docRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "retentionSchedule"
    );

    let docSnapshot = await getDoc(docRef);
    let dataTypeExists = false;
    let dataTypeID = null;

    if (docSnapshot.exists()) {
      let retentionSchedule = docSnapshot.data().register.dataTypes;

      for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
        let key = Object.keys(retentionSchedule)[i];
        let data = retentionSchedule[key];

        if (data.dataTypeName == dataType) {
          dataTypeExists = true;
          dataTypeID = key;
          console.log("Found data type ID: ", dataTypeID);
        }
      }

      if (dataTypeExists) {
        await updateDoc(docRef, {
          [`register.dataTypes.${dataTypeID}.dataRetentionPeriod`]:
            dataRetentionPeriods,
        });

        console.log("Successfully updated data retention periods!");

        await this.savedNotification({
          title: "Retention Schedule",
          text: `${dataType} has been updated.`,
        });
      } else {
        let largestID = 0;

        // Loop through the suppliers to find the largest ID.
        for (let i = 0; i < Object.keys(retentionSchedule).length; i++) {
          console.log("Index: ", i);
          console.log("Keys: ", Object.keys(retentionSchedule));
          console.log("Whole Schedule: ", retentionSchedule);
          const schedule = retentionSchedule[i];
          console.log("Schedule: ", schedule);
          if (parseInt(schedule.dataTypeID) > largestID) {
            largestID = parseInt(schedule.dataTypeID);
          }
        }

        dataTypeID = largestID + 1;
        await setDoc(
          docRef,
          {
            register: {
              dataTypes: {
                [`${dataTypeID}`]: {
                  dataRetentionPeriod: dataRetentionPeriods,
                  dataTypeID: dataTypeID,
                  dataTypeName: dataType,
                  deleted: false,
                  dataTypeJustification: "",
                },
              },
            },
          },
          { merge: true }
        );

        console.log("Successfully added new data type!");

        await this.savedNotification({
          title: "Retention Schedule",
          text: `${dataType} has been added to the Retention Schedule.`,
        });
      }
    }
  }

  // MSP Here
  fetchAuditData = async (org, db, mspMode = false) => {
    try {
      const auditDatesRef = doc(
        collection(db, "customers", org, "companySettings"),
        "complianceModules"
      );
      const doc2 = await getDoc(auditDatesRef);
      if (doc2.exists()) {
        const isoDoc = doc2.data();
        const overdueTasks = [];
        const assuranceTasksRef = collection(
          db,
          "customers",
          org,
          "compliance"
        );
        const res = await getDocs(assuranceTasksRef);
        // res.forEach((doc) => {
        //   let todaysDate = new Date();
        //   const dueDate = new Date(doc.data().checkFrequency?.nextCheck?.toDate()); // Provide defaults for nested properties
        //   if (dueDate < todaysDate) {
        //     overdueTasks.push(doc.data());
        //   }
        // });
        let assTaskData = res.docs[1].data();
        console.log(
          "[DeiterateCommon] (fetchAuditData) assTaskData: ",
          assTaskData
        );
        for (let i = 0; i < Object.keys(assTaskData).length; i++) {
          let key = Object.keys(assTaskData)[i];
          let value = assTaskData[key];
          console.log("[DeiterateCommon] (fetchAuditData) task data: ", value);
          let todaysDate = new Date();
          let dueDate = new Date(value.checkFrequency?.nextCheck?.toDate()); // Provide defaults for nested properties
          if (dueDate < todaysDate) {
            overdueTasks.push(value);
          }
        }

        const orgRef = doc(collection(db, "customers"), org); // Create a new reference for org
        const doc1 = await getDoc(orgRef);
        let companyImage = await this.getCompanyImgLink(org);
        if (companyImage == null || companyImage == undefined) {
          companyImage = "logos/deiterate-light.svg";
        }
        let lastAuditDate = null;
        let nextAuditDate = null;
        if (
          isoDoc &&
          isoDoc.hasOwnProperty("iso27001-2013") &&
          isoDoc["iso27001-2013"]["7"] != null &&
          typeof isoDoc["iso27001-2013"]["7"].value.toDate == "function"
        ) {
          if (!mspMode) {
            lastAuditDate = isoDoc["iso27001-2013"]["7"].value.toDate();
            nextAuditDate =
              isoDoc &&
                typeof isoDoc["iso27001-2013"]["7"].value.toDate == "function" &&
                isoDoc["iso27001-2013"]["7"].value.toDate() instanceof Date
                ? isoDoc["iso27001-2013"]["8"].value.toDate()
                : "N/A";
          } else {
            lastAuditDate = isoDoc["iso27001-2013"]["7"].value.toDate();
            nextAuditDate =
              isoDoc &&
                typeof isoDoc["iso27001-2013"]["7"].value.toDate == "function" &&
                isoDoc["iso27001-2013"]["7"].value.toDate() instanceof Date
                ? Math.round(
                  Math.abs(
                    (isoDoc["iso27001-2013"]["8"].value.toDate() -
                      new Date()) /
                    (24 * 60 * 60 * 1000)
                  )
                )
                : "N/A";
          }
        } else {
          lastAuditDate = "N/A";
          nextAuditDate = "N/A";
        }
        return {
          org,
          tenancyName: doc1.exists() ? doc1.data().customerFriendlyName : "N/A", // Use doc1 to get customerFriendlyName
          companyLogo: companyImage, // Use doc1 to get companyLogo
          overdueTasks: {
            count: overdueTasks.length,
            tasks: overdueTasks,
          },
          daysTillAudit: nextAuditDate,
        };
      }
      return null;
    } catch (error) {
      console.error(`Error fetching audit data for org '${org}':`, error);
      return null;
    }
  };

  getMSPTenancies = async (retry = false) => {
    try {
      const auth = getAuth();
      if (!auth.currentUser) {
        console.error("User not authenticated.");
        if (!retry) {
          return setTimeout(() => this.getMSPTenancies(true), 1000);
        }

        return [];
      }

      const userRef = doc(
        collection(getFirestore(), "users"),
        auth.currentUser.uid
      );
      const userDoc = await getDoc(userRef);
      if (userDoc.exists()) {
        const mspOrgsArray = userDoc.data()?.mspOrgs || [];
        const orgsArray = userDoc.data()?.organisations || [];
        const localStorageCompanyID = localStorage.getItem("companyID");

        const tenancies = [];
        const tenanciesMap = {}; // Object to store unique tenancyName and org combinations

        // Iterate through non-MSP organizations
        for (const org of orgsArray) {
          try {
            const orgRef = doc(collection(getFirestore(), "customers"), org);
            const doc1 = await getDoc(orgRef);
            if (doc1.exists()) {
              const data = await this.fetchAuditData(org, getFirestore(), true);
              if (data) {
                const key = `${data.tenancyName}_${org}`;
                if (!tenanciesMap[key]) {
                  tenancies.push(data);
                  tenanciesMap[key] = true;
                }
              }
            }
          } catch (error) {
            console.warn(`Error getting data for non-MSP org '${org}':`, error);
          }
        }

        // Iterate through MSP organizations
        for (const org of mspOrgsArray) {
          try {
            const orgRef = doc(collection(getFirestore(), "customers"), org);
            const doc1 = await getDoc(orgRef);
            if (doc1.exists()) {
              const tenancyPlan = doc1.data()?.customerPlan;
              const data = await this.fetchAuditData(org, getFirestore(), true);
              if (data) {
                const key = `${data.tenancyName}_${org}`;
                if (!tenanciesMap[key]) {
                  data.tenancyPlan = tenancyPlan;
                  tenancies.push(data);
                  tenanciesMap[key] = true;
                }
              }
            }
          } catch (error) {
            console.warn(`Error getting data for MSP org '${org}':`, error);
          }
        }

        // Sort tenancies alphabetically by tenancyName
        tenancies.sort((a, b) => {
          if (a.tenancyName < b.tenancyName) {
            return -1;
          }
          if (a.tenancyName > b.tenancyName) {
            return 1;
          }
          return 0;
        });

        // Check if localStorageCompanyID exists and move the matching entry to the beginning
        if (localStorageCompanyID) {
          const index = tenancies.findIndex(
            (tenancy) => tenancy.org === localStorageCompanyID
          );
          if (index > -1) {
            const companyTenancy = tenancies.splice(index, 1);
            tenancies.unshift(companyTenancy[0]);
          }
        }

        return tenancies;
      }
    } catch (error) {
      console.error("Error getting MSP tenancies:", error);
      return [];
    }
  };

  setOrg = async (id) => {
    console.log(id);
    let companyID = localStorage.getItem("companyID");
    if (companyID == id) {
      const userRef = doc(FBDatabase, "users", FBAuth.currentUser.uid);

      try {
        await updateDoc(userRef, {
          mspImpersonation: false,
          organisations: [id],
        });

        await this.savedNotification({
          title: "MSP Impersonation",
          text: `Activated MSP Mode.`,
        });

        localStorage.setItem("companyID", id);
        sessionStorage.setItem("selectedTenancy", true);

        setTimeout(() => {
          window.location.href = window.location.href.replace(
            "tenancy-select",
            "home"
          );
          window.location.reload(true);
        }, 2500);
      } catch (error) {
        console.error(error);
      }
    } else {
      const tenancyRef = doc(FBDatabase, "customers", id);

      try {
        const docSnap = await getDoc(tenancyRef);

        if (docSnap.exists()) {
          const msp = docSnap.data().mspDetails?.techPartner
            ? docSnap.data().mspDetails.techPartner.msp
            : docSnap.data()?.mspDetails?.msp;
          const impersonationAllowed = docSnap
            .data()
            .mspDetails?.techPartner
            ? docSnap.data().mspDetails.techPartner.impersonationAllowed
            : docSnap.data().mspDetails.impersonationAllowed;

          if (
            (msp == companyID && impersonationAllowed == true) ||
            (msp == id &&
              docSnap.data().users.includes(FBAuth.currentUser.uid)) ||
            (msp == id && impersonationAllowed == true)
          ) {
            const userRef = doc(FBDatabase, "users", FBAuth.currentUser.uid);

            try {
              await updateDoc(userRef, {
                // organisations: [...FBAuth.currentUser.organisations, id],
                organisations: arrayUnion(id),
                mspImpersonation: true,
              });

              await this.savedNotification({
                title: "MSP Impersonation",
                text: `You are now impersonating ${docSnap.data().customerFriendlyName
                  }.`,
              });

              localStorage.setItem("companyID", id);
              sessionStorage.setItem("selectedTenancy", true);

              setTimeout(() => {
                window.location.reload(true);
              }, 2500);
            } catch (error) {
              console.error(error);
            }
          } else {
            console.error("Impersonation not allowed!");
            await this.savedNotification({
              title: "MSP Impersonation",
              text: `You cannot impersonate ${docSnap.data().customerFriendlyName
                } as it is not a valid MSP tenancy.`,
            });
          }
        }
      } catch (error) {
        console.error(error);
      }
    }
  };

  async getCustomerIDFromName(customerName) {
    return new Promise(async (resolve, reject) => {
      return await getDocs(
        query(
          collection(this.FBDatabase, "customers"),
          or(
            where("customerFriendlyName", "==", customerName),
            where("customerName", "==", customerName)
          )
        )
      )
        .then((querySnapshot) => {
          if (querySnapshot.docs.length > 0) {
            return resolve(querySnapshot.docs[0].id);
          } else {
            return resolve(null);
          }
        })
        .catch((error) => {
          console.error(error);
          return resolve(null);
        });
    });
  }

  async getActivePartner() {
    const companyID = localStorage.getItem("companyID");
    console.log(companyID);
    const docRef = doc(this.FBDatabase, "customers", companyID);

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      if (!docSnap.data().hasOwnProperty("mspDetails")) return companyID;
      const techMSPID = docSnap.data().mspDetails.hasOwnProperty("techPartner")
        ? docSnap.data().mspDetails.techPartner.msp
        : docSnap.data()?.mspDetails?.msp;
      const businessMSPID = docSnap
        .data()
        .mspDetails?.businessPartner
        ? docSnap.data().mspDetails.businessPartner.msp
        : undefined;

      console.log("business msp id", businessMSPID);

      return this.loadPartners("all").then((msps) => {
        console.log(msps)
        let techMSP = msps[0].itPartners.find(
          (partner) => partner.mspID === techMSPID
        );
        console.log('Tech MSP ID', techMSPID, techMSP)
        let res = {
          tech: {
            mspName: techMSP?.mspName,
            mspEmail: techMSP?.mspEmail,
            mspID: techMSPID,
            mspLogo: techMSP?.companyLogo,
            mspPhone: techMSP?.mspPhone,
            isSet: true,
          },
          business: {},
        };

        if (businessMSPID !== undefined) {
          let businessMSP = msps[0].businessPartners.find(
            (partner) => partner.mspID === businessMSPID
          );
          res.business = {
            mspName: businessMSP.mspName,
            mspEmail: businessMSP.mspEmail,
            mspID: businessMSPID,
            mspLogo: businessMSP.companyLogo,
            mspPhone: businessMSP.mspPhone,
            isSet: true,
          };
        }
        return res;
      });
      const mspRef = doc(this.FBDatabase, "customers", mspID);

      const mspDocSnap = await getDoc(mspRef);

      if (mspDocSnap.exists()) {
        const mspData = mspDocSnap.data();
        return {
          mspName: mspData.customerFriendlyName,
          mspEmail: mspData.customerOwner,
          mspFullName: mspData.customerOwnerName,
          mspPhone: mspData.hasOwnProperty("customerPhone")
            ? mspData.customerPhone
            : "N/A",
          mspLogo: await this.getCompanyImgLink(mspID),
        };
      }
    }
  }

  async loadPartners(type = "all") {
    return new Promise(async (resolve, reject) => {
      if (type.toLowerCase() == "all") {
        let itPartners = await getDoc(
          doc(this.FBDatabase, "mspDetails", "availableMSPs")
        ).then(async (doc) => {
          if (doc.exists()) {
            let availableMSPs = await doc.data().availableMSPs;
            let mspsArray = [];
            for (const msp of Object.keys(availableMSPs)) {
              if (
                availableMSPs[msp]?.customerID !== undefined &&
                availableMSPs[msp].partnerType === undefined
              ) {
                mspsArray.push({
                  mspName: availableMSPs[msp].mspName,
                  mspID: availableMSPs[msp].customerID,
                  companyLogo: await this.getCompanyImgLink(
                    availableMSPs[msp].customerID
                  ),
                  mspEmail: availableMSPs[msp]?.mspEmail ?? "",
                  mspPhone: availableMSPs[msp]?.mspPhoneNumber ?? "",
                });
              } else {
                // Get mspID from name
                // mspsArray.push({
                //   mspName: availableMSPs[msp].mspName,
                //   mspID: "unknown",
                //   companyLogo: "logos/deiterate-light.svg",
                //   mspEmail: availableMSPs[msp]?.mspEmail ?? "",
                // });
              }
            }
            return mspsArray;
          }
        });

        let businessPartners = await getDoc(
          doc(this.FBDatabase, "mspDetails", "availableMSPs")
        ).then(async (doc) => {
          if (doc.exists()) {
            let availableMSPs = await doc.data().availableMSPs;
            let mspsArray = [];
            for (const msp of Object.keys(availableMSPs)) {
              if (
                availableMSPs[msp]?.customerID !== undefined &&
                availableMSPs[msp].partnerType === "Legal"
              ) {
                mspsArray.push({
                  mspName: availableMSPs[msp].mspName,
                  mspID: availableMSPs[msp].customerID,
                  companyLogo: await this.getCompanyImgLink(
                    availableMSPs[msp].customerID
                  ),
                  mspEmail: availableMSPs[msp]?.mspEmail ?? "",
                  mspPhone: availableMSPs[msp]?.mspPhoneNumber ?? "",
                });
              } else {
                // Get mspID from name
                // mspsArray.push({
                //   mspName: availableMSPs[msp].mspName,
                //   mspID: "unknown",
                //   companyLogo: "logos/deiterate-light.svg",
                //   mspEmail: availableMSPs[msp]?.mspEmail ?? "",
                // });
              }
            }
            return mspsArray;
          }
        }); // Need to change this to use the legal list

        let partners = [
          {
            itPartners: itPartners,
            businessPartners: businessPartners,
          },
        ];
        return resolve(partners);
      } else if (type.toLowerCase() == "it") {
        return getDoc(doc(this.FBDatabase, "mspDetails", "availableMSPs")).then(
          async (doc) => {
            if (doc.exists()) {
              let availableMSPs = await doc.data().availableMSPs;
              let mspsArray = [];
              for (const msp of Object.keys(availableMSPs)) {
                if (availableMSPs[msp]?.customerID !== undefined) {
                  mspsArray.push({
                    mspName: availableMSPs[msp].mspName,
                    mspID: availableMSPs[msp].customerID,
                  });
                }
              }
              return resolve([
                {
                  itPartners: mspsArray,
                },
              ]);
            }
          }
        );
      } else if (type.toLowerCase() == "legal") {
        return resolve([
          {
            businessPartners: [],
          },
        ]);
      }

      return resolve([
        {
          itPartners: [],
          businessPartners: [],
        },
      ]);
    });
  }

  async setPartner(companyID, mspObject, partnerType = "tech") {
    let { mspID, mspName, companyLogo, mspEmail, mspPhone } = mspObject;
    return new Promise(async (resolve, reject) => {
      console.log("setPartner", companyID, mspID);
      if (mspID == "unknown") {
        console.log({
          status: 400,
          message: "MSP not found as no ID was provided.",
        });
        window.f7.dialog.alert(
          "Oops, this is our fault. The chosen partner could not be set as there was no Partner ID Provided. Please contact support."
        );
        return resolve({
          status: 400,
          message: "MSP not found as no ID was provided.",
        });
      }

      return await setDoc(
        doc(this.FBDatabase, "customers", companyID),
        {
          mspDetails: {
            [`${partnerType}Partner`]: {
              impersonationAllowed: false,
              msp: mspID,
            },
          },
        },
        { merge: true }
      ).then(async () => {
        document.querySelector(".techPartnerName").innerText = mspName;
        document.querySelector(".techPartnerLogo").src = companyLogo;
        document.querySelector(".techPartnerLogo").alt = mspName;
        document.querySelector(".techPartnerLogo").title = mspName;

        document.querySelector(".techPartnerEmail").innerText = mspEmail;
        document.querySelector(".techPartnerPhone").innerText = mspPhone;
        await this.savedNotification({
          title: "Partner Settings",
          text: `Partner has been set successfully..`,
        });
        return resolve({ status: 201, message: "MSP set successfully." });
      });
    });
  }

  getAcronym(word) {
    const parts = word.replace(/[^a-zA-Z0-9]/g, "").split(" ");

    return parts.map((part) => part[0].toUpperCase()).join("");
  }

  areWordsEqualInAcronym(word1, word2) {
    const acronym1 = this.getAcronym(word1);
    const acronym2 = this.getAcronym(word2);

    return acronym1 === acronym2;
  }

  async getPrivacyWebsiteDomain() {
    // Firestore URL /customers/${customerId}/companySettings/complianceModules/privacyModules/privacyAct
    // Get websiteDomain from fireStore
    const docRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules",
      "privacyModules",
      "privacyAct"
    );

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      return docSnap.data().websiteDomain;
    }

    return null;
  }

  async updatePrivacyWebsiteDomain(newPrivacyDomain) {
    // Firestore URL /customers/${customerId}/companySettings/complianceModules/privacyModules/privacyAct
    // Update websiteDomain in firestore
    const docRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules",
      "privacyModules",
      "privacyAct"
    );

    await setDoc(
      docRef,
      {
        websiteDomain: newPrivacyDomain,
      },
      { merge: true }
    )
      .then(async () => {
        await this.savedNotification({
          title: "Privacy Act",
          text: `Privacy Act website domain has been updated.`,
        });
      })
      .catch((error) => {
        console.error(error);
      });
  }

  async getE8ComplianceModules() {
    // Firstore URL /customers/${customerId}/companySettings/complianceModules
    // Get the standardsAdded array from firestore
    // each modules is labelled e8_level_1, e8_level_2, e8_level_3, etc.
    // Get the level from the array and return the modules without the e8_level_ prefix

    const docRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules"
    );

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const modules = docSnap.data().standardsAdded;

      return modules.map((module) => module.replace("e8_level", ""));
    }

    return null;
  }

  async getISOComplianceModules() {
    // Firestore URL /customers/${customerId}/companySettings/complianceModules
    // Get the iso27001-2013 map from firestore
    // Iterate through each item in the map
    // return an object containing the settingName, value, and details key data

    const docRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "companySettings",
      "complianceModules"
    );

    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      const modules = docSnap.data()["iso27001-2013"];

      console.log(modules);

      var modulesArray = [];

      for (const module in modules) {
        const moduleData = modules[module];

        if (
          moduleData.hasOwnProperty("value") &&
          moduleData.hasOwnProperty("settingName")
        ) {
          modulesArray.push({
            settingName: this.snakeToCamel(
              moduleData.settingName.toLowerCase().replace(/ /g, "_")
            ),
            value:
              moduleData.value instanceof Timestamp ||
                (moduleData.value.seconds !== undefined &&
                  moduleData.value.nanoseconds !== undefined)
                ? moduleData.value.toDate()
                : moduleData.value,
            details: moduleData.details,
          });
        }
      }

      return modulesArray;
    }

    return null;
  }

  async getDataPrivacyRequests() {
    let dataPrivacyTrackerRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "privacyRequestsTracker"
    );

    let publicTracker = doc(
      FBDatabase,
      "privacyRequestTracker",
      localStorage.getItem("companyID")
    );

    let dataPrivacyTracker = {
      open: {
        count: 0,
        requests: [],
      },
      closed: {
        count: 0,
        requests: [],
      },
      active: {
        count: 0,
        requests: [],
      },
    };

    let dataPrivacyTrackerSnapshot = await getDoc(dataPrivacyTrackerRef);

    if (dataPrivacyTrackerSnapshot.exists()) {
      let docData = dataPrivacyTrackerSnapshot.data();

      for (let i = 0; i < Object.keys(docData).length; i++) {
        let key = Object.keys(docData)[i];
        let request = docData[key];
        let requestStatus = request.status.toLowerCase();

        if (requestStatus == "open") {
          dataPrivacyTracker.open.count++;
          request.requestID = key;
          request.isPublic = false;
          request.isCompleted = false;
          dataPrivacyTracker.open.requests.push(request);
        } else if (requestStatus == "closed") {
          dataPrivacyTracker.closed.count++;
          request.requestID = key;
          request.isPublic = false;
          request.isCompleted = false;
          dataPrivacyTracker.closed.requests.push(request);
        } else if (requestStatus == "active") {
          dataPrivacyTracker.active.count++;
          request.requestID = key;
          request.isPublic = false;
          request.isCompleted = false;
          dataPrivacyTracker.active.requests.push(request);
        } else if (requestStatus == "completed") {
          dataPrivacyTracker.closed.count++;
          request.requestID = key;
          request.isPublic = false;
          request.isCompleted = true;
          dataPrivacyTracker.closed.requests.push(request);
        } else {
          console.log("Invalid request status: ", requestStatus, request);
        }
      }

      let publicTrackerSnapshot = await getDoc(publicTracker);

      if (publicTrackerSnapshot.exists()) {
        let publicTrackerData = publicTrackerSnapshot.data();

        for (let i = 0; i < Object.keys(publicTrackerData).length; i++) {
          let key = Object.keys(publicTrackerData)[i];
          let request = publicTrackerData[key];
          let requestStatus = request.status.toLowerCase();

          if (requestStatus == "open") {
            dataPrivacyTracker.open.count++;
            request.requestID = key;
            request.isPublic = true;
            request.isCompleted = false;
            dataPrivacyTracker.open.requests.push(request);
          } else if (requestStatus == "closed") {
            dataPrivacyTracker.closed.count++;
            request.requestID = key;
            request.isPublic = true;
            request.isCompleted = false;
            dataPrivacyTracker.closed.requests.push(request);
          } else if (requestStatus == "active") {
            dataPrivacyTracker.active.count++;
            request.requestID = key;
            request.isPublic = true;
            request.isCompleted = false;
            dataPrivacyTracker.active.requests.push(request);
          } else if (requestStatus == "completed") {
            dataPrivacyTracker.closed.count++;
            request.requestID = key;
            request.isPublic = true;
            request.isCompleted = true;
            dataPrivacyTracker.closed.requests.push(request);
          } else {
            console.log("Invalid request status: ", requestStatus, request);
          }
        }
      }

      return dataPrivacyTracker;
    } else {
      console.warn("[Data Privacy Tracker] No such document!");
      return dataPrivacyTracker;
    }
  }

  async createPrivacyRequest(defaultValues = {}) {
    let dataPrivacyTrackerRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "privacyRequestsTracker"
    );

    let dataPrivacyTrackerSnapshot = await getDoc(dataPrivacyTrackerRef);

    if (dataPrivacyTrackerSnapshot.exists()) {
      let docData = dataPrivacyTrackerSnapshot.data();

      let largestID = 0;

      // Loop through the requests to find the largest ID.
      for (let i = 0; i < Object.keys(docData).length; i++) {
        console.log("Index: ", i);
        console.log("Keys: ", Object.keys(docData));
        let key = Object.keys(docData)[i];
        let requestID = key;
        console.log("All Requests: ", docData);
        const request = docData[i];
        console.log("Request: ", request);
        if (parseInt(requestID) > largestID) {
          largestID = parseInt(requestID);
        }
      }

      let requestID = largestID + 1;
      if (defaultValues == {}) {
        defaultValues = {
          name:
            document.querySelector(
              '#popup-request input[name="requestFullName"]'
            ).value || "N/A",
          email:
            document.querySelector(
              '#popup-request input[name="requestEmailAddress"]'
            ).value || "N/A",
          phoneNumber:
            document.querySelector(
              '#popup-request input[name="requestPhoneNumber"]'
            ).value || "N/A",
          requestID: requestID,
          requestDate: serverTimestamp(),
          typeOfRequest:
            document.querySelector('#popup-request input[name="requestType"]')
              .value || "N/A",
          status: "Open",
          metadata: {
            dateCreated: serverTimestamp(),
            createdBy: getAuth().currentUser.uid,
          },
        };
      }

      return setDoc(
        dataPrivacyTrackerRef,
        {
          [`${requestID}`]: {
            ...defaultValues,
          },
        },
        { merge: true }
      ).then(async () => {
        await this.savedNotification({
          title: "Privacy Request Tracker",
          text: `You have created a new privacy request for ${defaultValues.name}.`,
        });
      });
    } else {
      console.warn("[Data Privacy Tracker] No such document!");
      return null;
    }
  }

  async acceptPrivacyRequest(requestID, isPublic = false) {
    if (isPublic) {
      let publicTracker = doc(
        this.FBDatabase,
        "privacyRequestTracker",
        localStorage.getItem("companyID")
      );

      let publicTrackerSnapshot = await getDoc(publicTracker);

      if (publicTrackerSnapshot.exists()) {
        let publicTrackerData = publicTrackerSnapshot.data();

        if (publicTrackerData[requestID]) {
          // Create a new request in the company's privacy request tracker.
          let request = publicTrackerData[requestID];
          let requestStatus = request.status.toLowerCase();

          if (requestStatus === "open") {
            request.status = "Active";
            let createRequest = await this.createPrivacyRequest(request);
            console.log("Create Request: ", createRequest);

            // Remove from public tracker
            delete publicTrackerData[requestID]; // Remove the item from the map
            // Now you might want to update the database with the modified data
            console.log("Public Tracker Data: ", publicTrackerData);
            await setDoc(
              publicTracker,
              {
                [`${requestID}`]: deleteField(),
              },
              { merge: true }
            );

            return createRequest;
          }
        }
      }
    }

    let requestDocRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "privacyRequestsTracker"
    );

    let requestDocSnapshot = await getDoc(requestDocRef);

    if (requestDocSnapshot.exists()) {
      let requestData = requestDocSnapshot.data();

      if (requestData[requestID]) {
        let request = requestData[requestID];

        let requestStatus = request.status.toLowerCase();

        if (requestStatus == "open" || requestStatus == "active") {
          let requestUpdate = {
            status: "Active",
            metadata: {
              dateAccepted: serverTimestamp(),
              acceptedBy: getAuth().currentUser.uid,
            },
          };

          if (requestStatus == "active") {
            requestUpdate.status = "Completed";
            requestUpdate.metadata.dateDeclined = serverTimestamp();
            requestUpdate.metadata.declinedBy = getAuth().currentUser.uid;
          }

          await setDoc(
            requestDocRef,
            {
              [`${requestID}`]: requestUpdate,
            },
            { merge: true }
          );

          if (requestStatus == "active") {
            await this.savedNotification({
              title: "Privacy Request Tracker",
              text: `You have completed the privacy request from ${request.name}.`,
            });
          } else {
            await this.savedNotification({
              title: "Privacy Request Tracker",
              text: `You have accepted the privacy request from ${request.name}.`,
            });
          }

          return true;
        } else {
          console.warn("[Privacy Request Tracker] Request is not open!");
          return false;
        }
      }
    }

    return false;
  }

  async declinePrivacyRequest(requestID) {
    let requestDocRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "privacyRequestsTracker"
    );

    let requestDocSnapshot = await getDoc(requestDocRef);

    if (requestDocSnapshot.exists()) {
      let requestData = requestDocSnapshot.data();

      if (requestData[requestID]) {
        let request = requestData[requestID];

        let requestStatus = request.status.toLowerCase();

        if (requestStatus == "open" || requestStatus == "active") {
          let requestUpdate = {
            status: "Closed",
            metadata: {
              dateDeclined: serverTimestamp(),
              declinedBy: getAuth().currentUser.uid,
            },
          };

          await setDoc(
            requestDocRef,
            {
              [`${requestID}`]: requestUpdate,
            },
            { merge: true }
          );

          await this.savedNotification({
            title: "Privacy Request Tracker",
            text: `You have declined the privacy request from ${request.name}.`,
          });

          return true;
        } else {
          console.warn("[Privacy Request Tracker] Request is not open!");
          return false;
        }
      }
    }

    return false;
  }

  async reopenPrivacyRequest(requestID) {
    let requestDocRef = doc(
      this.FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "compliance",
      "privacyRequestsTracker"
    );

    let requestDocSnapshot = await getDoc(requestDocRef);

    if (requestDocSnapshot.exists()) {
      let requestData = requestDocSnapshot.data();

      if (requestData[requestID]) {
        let request = requestData[requestID];

        let requestStatus = request.status.toLowerCase();

        if (requestStatus == "closed" || requestStatus == "completed") {
          let requestUpdate = {
            status: "Open",
            metadata: {
              dateReopened: serverTimestamp(),
              reopenedBy: getAuth().currentUser.uid,
            },
          };

          await setDoc(
            requestDocRef,
            {
              [`${requestID}`]: requestUpdate,
            },
            { merge: true }
          );

          await this.savedNotification({
            title: "Privacy Request Tracker",
            text: `You have reopened the privacy request from ${request.name}.`,
          });

          return true;
        } else {
          console.warn("[Privacy Request Tracker] Request is not closed!");
          return false;
        }
      }
    }
  }

  daysLeftToReply(timestamp) {
    const thirtyDaysInMillis = 30 * 24 * 60 * 60 * 1000;
    const targetDate = new Date(timestamp.toMillis() + thirtyDaysInMillis);
    return Math.abs(
      Math.ceil((targetDate - Date.now()) / (24 * 60 * 60 * 1000))
    );
  }

  formatPhoneNumber(phoneNumberString) {
    if (phoneNumberString.toString().includes("+")) {
      return new AsYouType().input(phoneNumberString);
    } else {
      return new AsYouType("AU").input(phoneNumberString);
    }
  }

  getCountryFlag = (country) => {
    const { iso2 } = country;
    const flag = emojiFlags.countryCode(iso2).emoji;
    return flag;
  };

  getCityElement(cityName) {
    return cityList.filter((city) => {
      if (city.name.toLowerCase() === cityName) {
        return city.country;
      }
    });
  }

  getCountryForCity(cityName) {
    const city = cityName.trim().toLowerCase();
    return this.getCityElement(city).country;
  }

  getTopDataStorageLocations = async (
    companyID = localStorage.getItem("companyID"),
    withCities = false
  ) => {
    try {
      window.f7.$(".currentLoadingItem").text("Top Data Storage Locations");
      const supplierRegister = await this.getSupplierRegister(companyID);
      const suppliers = Object.values(supplierRegister);

      if (suppliers.length > 0) {
        const dataStorageLocations = suppliers.flatMap(
          (supplier) => supplier.dataStorageLocations || []
        );
        const locationCounts = dataStorageLocations.reduce(
          (counts, location) => {
            let countryName = location.replace("_", " ");
            if (!withCities) {
              if (
                ["sydney", "canberra", "perth", "melbourne"].includes(
                  countryName.toLowerCase()
                )
              ) {
                countryName = "Australia";
              }
            }

            let countryCode = this.getCountryCode(countryName);
            if (countryName.toLowerCase() === "united states of america") {
              countryCode = this.getCountryCode("USA");
            }

            if (withCities) {
              if (countryCode.toLowerCase() === countryName.toLowerCase()) {
                let countryGuess = this.getCountryForCity(countryName);
                if (countryGuess) {
                  countryCode = this.getCountryCode(countryGuess);
                }
              }
            }

            if (!counts[countryCode]) {
              counts[countryCode] = {
                location: location,
                count: 0,
              };
            }
            counts[countryCode].count++;
            return counts;
          },
          {}
        );

        const sortedLocations = Object.values(locationCounts).sort(
          (a, b) => b.count - a.count
        );
        const topLocations = sortedLocations.slice(0, 5);

        const topLocationsWithFlags = await Promise.all(
          topLocations.map(async (item) => {
            let { location, count } = item;
            let countryName = location.replace("_", " ");
            if (!withCities) {
              if (
                ["sydney", "canberra", "perth", "melbourne"].includes(
                  countryName.toLowerCase()
                )
              ) {
                countryName = "Australia";
              }
            }

            if (countryName.toLowerCase() === "united states of america") {
              countryName = "USA";
            }

            let countriesByName = CountryAndCurrency.getCountriesBy(
              "name",
              countryName
            );
            let countriesByIso2 = CountryAndCurrency.getCountriesBy(
              "iso2",
              countryName
            );
            let countriesByIso3 = CountryAndCurrency.getCountriesBy(
              "iso3",
              countryName
            );
            let countriesByContinent = CountryAndCurrency.getCountriesBy(
              "continent",
              countryName
            );

            let countries = [
              ...countriesByName,
              ...countriesByIso2,
              ...countriesByIso3,
              ...countriesByContinent,
            ];

            let flag = "";
            if (countries.length > 0) {
              const country = countries[0];
              flag = this.getCountryFlag(country);
            } else {
              if (withCities) {
                let countryGuess = this.getCountryForCity(countryName);
                if (countryGuess) {
                  countriesByName = CountryAndCurrency.getCountriesBy(
                    "name",
                    countryGuess
                  );
                  countriesByIso2 = CountryAndCurrency.getCountriesBy(
                    "iso2",
                    countryGuess
                  );
                  countriesByIso3 = CountryAndCurrency.getCountriesBy(
                    "iso3",
                    countryGuess
                  );
                  countriesByContinent = CountryAndCurrency.getCountriesBy(
                    "continent",
                    countryGuess
                  );
                  countries = [
                    ...countriesByName,
                    ...countriesByIso2,
                    ...countriesByIso3,
                    ...countriesByContinent,
                  ];
                  if (countries.length > 0) {
                    const country = countries[0];
                    flag = this.getCountryFlag(country);
                  }
                }
              }
            }

            if (
              location.toLowerCase() === "united states of america" ||
              location.toLowerCase() === "usa"
            ) {
              location = "United States of America";
            }

            return `${flag} ${location} (${count})`;
          })
        );

        console.log("Top Locations:", topLocationsWithFlags);
        return topLocationsWithFlags;
      } else {
        console.warn("[Supplier Register] No suppliers found!");
        return null;
      }
    } catch (error) {
      console.warn("[Supplier Register] Error:", error);
      return null;
    }
  };

  getCountryCode = (countryName) => {
    const countries = CountryAndCurrency.getCountries();
    const countryCodeMap = {};

    for (const country of countries) {
      const { iso2, iso3 } = country;
      countryCodeMap[iso2] = iso2;
      countryCodeMap[iso3] = iso2;
    }

    return countryCodeMap[countryName] || countryName;
  };

  async buildSankeyDiagram() {
    let dataFlowArray = [];
    const pastelColors = [
      "#FDCB9E",
      "#BEE3DB",
      "#F5CAC3",
      "#D7E5A1",
      "#F3E1A5",
      "#C7CEEA",
      "#E2A9A1",
    ]; // Add your desired pastel colors here

    try {
      const supplierData = await this.getSupplierRegister();
      const suppliersMap = supplierData;

      let colorIndex = 0;
      const colorMap = {}; // Track colors assigned to each unique combination of from and to values

      Object.keys(suppliersMap)
        .sort()
        .forEach((key) => {
          suppliersMap[key].dataStorageLocations.forEach((location) => {
            suppliersMap[key].dataTypesShared.forEach((dataType) => {
              const flowKey = `${dataType}-${suppliersMap[key].assetDesc}-${location}`;
              if (!colorMap[flowKey]) {
                colorMap[flowKey] =
                  pastelColors[colorIndex % pastelColors.length];
                colorIndex++;
              }
              const flowColor = colorMap[flowKey];
              dataFlowArray.push({
                from: dataType,
                to: suppliersMap[key].assetDesc,
                weight: 1,
              });
              dataFlowArray.push({
                from: suppliersMap[key].assetDesc,
                to: location,
                weight: 1,
              });
            });
          });
        });

      Highcharts.chart({
        chart: {
          renderTo: document.querySelector(".page-current .sankeyDiagramDiv"),
          type: "sankey",
          height: 200,
        },
        title: false,
        credits: false,
        exporting: {
          enabled: false,
        },
        series: [
          {
            keys: ["from", "to", "weight"],
            data: dataFlowArray,
            type: "sankey",
            name: "Data Flow Diagram",
            colorByPoint: true,
            colors: pastelColors,
          },
        ],
      });

      console.log("Chart built");
      console.log(dataFlowArray);
    } catch (error) {
      console.error("Error fetching supplier data:", error);
    }
  }

  getCapitalised(str) {
    var smallWords =
      /^(a|an|and|as|at|but|by|en|for|if|in|nor|of|on|or|per|the|to|vs?\.?|via)$/i;
    return str.replace(
      /[A-Za-z0-9\u00C0-\u00FF]+[^\s-']*/g,
      function (match, index, title) {
        if (
          index > 0 &&
          index + match.length !== title.length &&
          match.search(smallWords) > -1 &&
          title.charAt(index - 2) !== ":" &&
          (title.charAt(index + match.length) !== "-" ||
            title.charAt(index - 1) === "-") &&
          (title.charAt(index + match.length) !== "'" ||
            title.charAt(index - 1) === "'") &&
          title.charAt(index - 1).search(/[^\s-]/) < 0
        ) {
          return match.toLowerCase();
        }
        if (match.substr(1).search(/[A-Z]|\../) > -1) {
          return match;
        }
        return match.charAt(0).toUpperCase() + match.substr(1);
      }
    );
  }

  snakeToCamel(str) {
    return str.replace(/_([a-z0-9])/g, function (match, letter) {
      return letter.toUpperCase();
    });
  }

  async buildGauge(frameName, gaugeClass) {
    const data = {
      total: [],
      onTime: [],
      overdue: [],
    };

    try {
      const complianceModulesDoc = await getDoc(doc(FBDatabase, "customers", localStorage.getItem("companyID"), "companySettings", "complianceModules"));
      const e8Enabled = complianceModulesDoc.data()?.standardsAdded !== undefined ? complianceModulesDoc.data()?.standardsAdded.length > 1 : complianceModulesDoc.data()?.essential8?.enabled;
      const paEnabled = complianceModulesDoc.data()?.privacyActEnabled;

      console.log(`Is E8 enabled: ${e8Enabled}`);
      console.log(`Is PA enabled: ${paEnabled}`);

      if (e8Enabled !== true && frameName === "Essential 8") {
        document.querySelector(`#e8GaugeParent`).style.display = "none";
        document.querySelector(`#e8GaugeParent`).parentElement.classList.remove("grid-cols-2")
        document.querySelector(`#e8GaugeParent`).parentElement.classList.add("grid-cols-1")
      }

      if (paEnabled !== true && frameName === "Privacy Act") {
        document.querySelector(`#paGaugeParent`).style.display = "none";
        document.querySelector(`#e8GaugeParent`).parentElement.classList.remove("grid-cols-2")
        document.querySelector(`#e8GaugeParent`).parentElement.classList.add("grid-cols-1")
      }

      const assuranceDoc = await getDoc(
        doc(
          FBDatabase,
          "customers",
          localStorage.getItem("companyID"),
          "compliance",
          "assurance"
        )
      );

      if (assuranceDoc.exists()) {
        const assuranceData = assuranceDoc.data();
        Object.keys(assuranceData)
          .sort()
          .forEach((key) => {
            if (assuranceData[key].checkDetail.active === "true") {
              if (
                assuranceData[key].checkDetail.framework[0].frameName ===
                frameName
              ) {
                const numberPreviousChecks =
                  assuranceData[key].checkHistory.numberPreviousChecks;
                const scheduledDate = assuranceData[key].checkHistory[
                  numberPreviousChecks
                ].scheduledDate
                  .toDate()
                  .setHours(0, 0, 0, 0);
                const performedDate = assuranceData[key].checkHistory[
                  numberPreviousChecks
                ].performedDate
                  .toDate()
                  .setHours(0, 0, 0, 0);

                const is_before_or_equal_date = (date1, date2) =>
                  date1 <= date2;

                data.total.push(assuranceData[key]);

                if (is_before_or_equal_date(scheduledDate, performedDate)) {
                  data.onTime.push(assuranceData[key]);
                } else {
                  data.overdue.push(assuranceData[key]);
                }
              }
            }
          });

        // Output data as JSON
        console.log(JSON.stringify(data));

        console.log(
          data.total.length.toString(),
          // + data.overdue.length
          ((data.onTime.length / data.total.length) * 100).toString() + "%"
        );

        var gauge = window.f7.gauge.get(
          `.page-current .${gaugeClass.replace(".", "")}`
        );

        console.log("Changing to gauge class: ", gaugeClass);
        console.log("New Details =>", {
          // + data.overdue.length
          value: ((data.onTime.length / data.total.length) * 100).toFixed(1),
          //+ data.overdue.length
          valueText: isNaN((data.onTime.length / data.total.length) * 100)
            ? "0%"
            : // + data.overdue.length
            ((data.onTime.length / data.total.length) * 100)
              .toFixed(1)
              .toString() + "%",
        });
        if (frameName === "Privacy Act") {
          gauge.update({
            value: isNaN(
              //+ data.overdue.length
              ((data.onTime.length / data.total.length) * 100).toFixed(1)
            )
              ? 0
              : //+ data.overdue.length
              ((data.onTime.length / data.total.length) * 100).toFixed(1),
            //+ data.overdue.length
            valueText: isNaN((data.onTime.length / data.total.length) * 100)
              ? "0%"
              : // + data.overdue.length
              ((data.onTime.length / data.total.length) * 100)
                .toFixed(1)
                .toString() + "%",
          });
        } else {
          gauge.update({
            value: isNaN(
              ((data.onTime.length / data.total.length) * 100).toFixed(1)
            )
              ? 0
              : ((data.onTime.length / data.total.length) * 100).toFixed(1),
            valueText: isNaN((data.onTime.length / data.total.length) * 100)
              ? "0%"
              : ((data.onTime.length / data.total.length) * 100)
                .toFixed(1)
                .toString() + "%",
          });
        }

        return {
          total: data.total.length.toString(),
          onTime: data.onTime.length.toString(),
        };
      }
    } catch (error) {
      // Handle error
      console.error(error);
    }
  }

  getTextColor(rgba) {
    rgba = rgba.match(/\d+/g);
    if (rgba[0] * 0.299 + rgba[1] * 0.587 + rgba[2] * 0.114 > 186) {
      return "black";
    } else {
      return "white";
    }
  }

  async getE8AssuranceData() {
    const data = {
      total: [],
      onTime: [],
      overdue: [],
    };

    try {
      const assuranceDoc = await getDoc(
        doc(
          FBDatabase,
          "customers",
          localStorage.getItem("companyID"),
          "compliance",
          "assurance"
        )
      );

      if (assuranceDoc.exists()) {
        const assuranceData = assuranceDoc.data();
        Object.keys(assuranceData)
          .sort()
          .forEach((key) => {
            if (assuranceData[key].checkDetail.active === "true") {
              if (
                assuranceData[key].checkDetail.framework[0].frameName ===
                "Essential 8"
              ) {
                const numberPreviousChecks =
                  assuranceData[key].checkHistory.numberPreviousChecks;
                const scheduledDate = assuranceData[key].checkHistory[
                  numberPreviousChecks
                ].scheduledDate
                  .toDate()
                  .setHours(0, 0, 0, 0);
                const performedDate = assuranceData[key].checkHistory[
                  numberPreviousChecks
                ].performedDate
                  .toDate()
                  .setHours(0, 0, 0, 0);

                const is_before_or_equal_date = (date1, date2) =>
                  date1 <= date2;

                data.total.push(assuranceData[key]);

                if (is_before_or_equal_date(scheduledDate, performedDate)) {
                  data.onTime.push(assuranceData[key]);
                } else {
                  data.overdue.push(assuranceData[key]);
                }
              }
            }
          });

        // Output data as JSON
        console.log(JSON.stringify(data));

        console.log(
          data.total.length.toString(),
          (
            ((data.onTime.length + data.overdue.length) / data.total.length) *
            100
          ).toString() + "%"
        );

        var gauge = window.f7.gauge.get(".page-current .e8-gauge");

        gauge.update({
          value: (
            ((data.onTime.length + data.overdue.length) / data.total.length) *
            100
          ).toFixed(1),
          valueText:
            (
              ((data.onTime.length + data.overdue.length) / data.total.length) *
              100
            ).toString() + "%",
        });

        return {
          total: data.total.length.toString(),
          onTime: data.onTime.length.toString(),
        };
      }
    } catch (error) {
      // Handle error
      console.error(error);
    }
  }

  // async sortComplianceDates(data, type, speed = 'default') {
  //   let sortedData = [];
  //   let today = new Date();
  //   let todayDate = today.getDate();
  //   let todayMonth = today.getMonth();
  //   let todayYear = today.getFullYear();
  //   let todayDateObj = new Date(todayYear, todayMonth, todayDate);

  //   for (let i = 0; i < Object.keys(data).length; i++) {
  //     // this.debug.log('[Compliance Calendar] Data' +i+' =>', data[Object.keys(data)[i]])
  //     let date = undefined;

  //     if (type == 'assurance') {
  //       console.log('ERROR HERE - ', data[Object.keys(data)[i]]);
  //       if (data[Object.keys(data)[i]].checkFrequency.nextCheck == undefined) {
  //         date = new Date();
  //         console.log('ERROR FOR REAL - ', data[Object.keys(data)[i]]);
  //       } else {
  //         date = data[Object.keys(data)[i]].checkFrequency.nextCheck.toDate();
  //         // date = this.firebaseTimeConverter(data[Object.keys(data)[i]].checkFrequency.nextCheck);
  //       }
  //     } else {
  //       date = data[Object.keys(data)[i]].nextReview.toDate();
  //     }

  //     // this.debug.log('[Compliance Calendar] Date =>', date)
  //     let dateObj = new Date(date);
  //     // this.debug.log('[Compliance Calendar] Date Obj =>', dateObj)
  //     console.log(
  //       'Assurance Task',
  //       data[Object.keys(data)[i]].assID,
  //       'date matches or is greater than today',
  //     );
  //     this.debug
  //       .log
  //       // "[Compliance Calendar] Date is greater than or equal to today =>",
  //       // dateObj
  //       ();

  //     let colour = this.generatePastelColor().hex;
  //     this.debug.log('[Compliance Calendar] Colour =>', colour);

  //     let classifications = await this.getClassifications();
  //     data[Object.keys(data)[i]].classifications = classifications;

  //     if (
  //       (type == 'assurance' &&
  //         data[Object.keys(data)[i]].checkDetail.active == 'true' &&
  //         data[Object.keys(data)[i]].checkDetail.check != '' &&
  //         data[Object.keys(data)[i]].checkDetail.check != undefined &&
  //         data[Object.keys(data)[i]].checkDetail.assignedTo != '' &&
  //         data[Object.keys(data)[i]].checkDetail.assignedTo != undefined) ||
  //       (type == 'assurance' &&
  //         data[Object.keys(data)[i]].checkDetail.active == 'active' &&
  //         data[Object.keys(data)[i]].checkDetail.check != '' &&
  //         data[Object.keys(data)[i]].checkDetail.check != undefined &&
  //         data[Object.keys(data)[i]].checkDetail.assignedTo != '' &&
  //         data[Object.keys(data)[i]].checkDetail.assignedTo != undefined) ||
  //       (type == 'assurance' &&
  //         data[Object.keys(data)[i]].checkDetail.active == true &&
  //         data[Object.keys(data)[i]].checkDetail.check != '' &&
  //         data[Object.keys(data)[i]].checkDetail.check != undefined &&
  //         data[Object.keys(data)[i]].checkDetail.assignedTo != '' &&
  //         data[Object.keys(data)[i]].checkDetail.assignedTo != undefined)
  //     ) {
  //       let userFullName = await this.getAssignedToName(
  //         data[Object.keys(data)[i]].checkDetail.assignedTo,
  //       );
  //       this.debug.log(
  //         '[Compliance Calendar] (Assurance) User Full Name =>',
  //         userFullName,
  //         'Assigned To =>',
  //         data[Object.keys(data)[i]].checkDetail.assignedTo,
  //       );
  //       if (
  //         data[Object.keys(data)[i]].checkDetail.check !== undefined &&
  //         data[Object.keys(data)[i]].checkDetail.check !== '' &&
  //         data[Object.keys(data)[i]].checkDetail.check !== null
  //       ) {
  //         console.log(
  //           'Assurance Task',
  //           data[Object.keys(data)[i]].assID,
  //           ' will be added to calendar',
  //         );
  //         this.debug.log('Checking Titles =>', data[Object.keys(data)[i]].checkDetail.check);
  //         this.debug.log('Assurance ID =>', data[Object.keys(data)[i]].assID);
  //         sortedData.push({
  //           date: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
  //           eventDate: date,
  //           hours: date.getHours(),
  //           minutes: date.getMinutes(),
  //           title: data[Object.keys(data)[i]].checkDetail.check,
  //           assignedTo: userFullName,
  //           id: data[Object.keys(data)[i]].assID,
  //           color: colour,
  //           taskData: data[Object.keys(data)[i]],
  //         });
  //       } else {
  //         console.log(
  //           'Assurance Task',
  //           data[Object.keys(data)[i]].assID,
  //           ' wont be added to calendar',
  //         );
  //         this.debug.log('No Titler => ', data[Object.keys(data)[i]].assID);
  //       }

  //       this.debug.log(
  //         '[Compliance Calendar] (Assurance) Task ID => ',
  //         data[Object.keys(data)[i]].assID,
  //       );
  //     } else if (type == 'risk') {
  //       let userFullName = await this.getAssignedToName(data[Object.keys(data)[i]].riskOwner);
  //       this.debug.log(
  //         '[Compliance Calendar] (Risk) User Full Name =>',
  //         userFullName,
  //         'Assigned To =>',
  //         data[Object.keys(data)[i]].riskOwner,
  //       );
  //       sortedData.push({
  //         date: date,
  //         hours: date.getHours(),
  //         minutes: date.getMinutes(),
  //         title: data[Object.keys(data)[i]].risk,
  //         assignedTo: userFullName,
  //         id: data[Object.keys(data)[i]].riskID,
  //         color: colour,
  //         taskData: data[Object.keys(data)[i]],
  //       });
  //       this.debug.log(
  //         '[Compliance Calendar] (Risk) Task ID => ',
  //         data[Object.keys(data)[i]].riskID,
  //       );
  //     }
  //   }

  //   return sortedData;
  // }

  // async sortComplianceDates(data, type) {
  //   let sortedData = [];
  //   let today = new Date();
  //   let todayDateObj = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  //   const keys = Object.keys(data);

  //   for (let i = 0; i < keys.length; i++) {
  //     const currentData = data[keys[i]];
  //     let date = undefined;

  //     if (type === 'assurance') {
  //       const nextCheck = currentData.checkFrequency?.nextCheck?.toDate() || new Date();
  //       date = nextCheck;
  //     } else {
  //       date = currentData.nextReview?.toDate();
  //     }

  //     if (date) {
  //       const dateObj = new Date(date);
  //       let colour = this.generatePastelColor().hex;
  //       const classifications = await this.getClassifications();

  //       // Avoid unnecessary function calls and simplify conditionals
  //       const checkDetail = currentData.checkDetail || {};
  //       const isActive =
  //         (type === 'assurance' &&
  //           (checkDetail.active === 'true' || checkDetail.active === true)) ||
  //         type === 'risk';

  //       if (isActive && checkDetail.check) {
  //         let userFullName = await this.getAssignedToName(checkDetail.assignedTo);

  //         sortedData.push({
  //           date: new Date(dateObj.getFullYear(), dateObj.getMonth(), dateObj.getDate()),
  //           eventDate: dateObj,
  //           hours: dateObj.getHours(),
  //           minutes: dateObj.getMinutes(),
  //           title: checkDetail.check,
  //           assignedTo: userFullName,
  //           id: currentData.assID || currentData.riskID,
  //           color: colour,
  //           taskData: currentData,
  //         });
  //       }
  //     }
  //   }

  //   return sortedData;
  // }

  async sortComplianceDates(data, type, speed = "default") {
    const sortedData = [];
    const today = new Date();
    const todayDateObj = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate()
    );
    const keys = Object.keys(data);
    // const classifications = await this.getClassifications();

    for (let i = 0; i < keys.length; i++) {
      const currentKey = keys[i];
      const currentData = data[currentKey];
      let date = undefined;

      if (type === "assurance") {
        const nextCheck =
          currentData.checkFrequency?.nextCheck?.toDate() || new Date();
        date = nextCheck;
      } else {
        date = currentData.nextReview?.toDate();
      }

      if (date) {
        const dateObj = new Date(date);
        let colour = this.generatePastelColor().hex;

        const checkDetail = currentData.checkDetail || {};
        const isActive =
          (type === "assurance" &&
            (checkDetail.active === "true" || checkDetail.active === true)) ||
          type === "risk";

        if (isActive && checkDetail.check) {
          const userFullName = await this.getAssignedToName(
            checkDetail.assignedTo
          );

          sortedData.push({
            date: new Date(
              dateObj.getFullYear(),
              dateObj.getMonth(),
              dateObj.getDate()
            ),
            eventDate: dateObj,
            hours: dateObj.getHours(),
            minutes: dateObj.getMinutes(),
            title: checkDetail.check,
            assignedTo: userFullName,
            id: currentData.assID || currentData.riskID,
            color: colour,
            taskData: currentData,
          });
        }
      }
    }

    return sortedData;
  }

  async getClassifications(companyID = localStorage.getItem("companyID")) {
    let classificationRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "asset"
    );
    return getDoc(classificationRef)
      .then((doc) => {
        if (doc.exists()) {
          return doc.data().register.menu.classification;
        } else {
          this.debug.warn("[Compliance Calendar] No such document!");
        }
      })
      .catch((error) => {
        this.debug.warn("[Compliance Calendar] Error getting document:", error);
      });
  }

  loadMarked() {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = "https://cdn.jsdelivr.net/npm/marked@2.0.3/marked.min.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  loadTurndown() {
    return new Promise(function (resolve, reject) {
      var script = document.createElement("script");
      script.src = "https://unpkg.com/turndown/dist/turndown.js";
      script.onload = resolve;
      script.onerror = reject;
      document.head.appendChild(script);
    });
  }

  async loadPrivacyPolicy() {
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "privacyPolicy",
      "policies",
      "policy_current",
      "privacy_policy"
    );

    await this.loadMarked();

    return getDoc(docRef)
      .then((doc) => {
        if (doc.exists()) {
          this.debug.log("Privacy Policy Data =>", doc.data());
          var privacyPolicyContent = doc.data().policy_content;
          if (privacyPolicyContent) {
            console.log(
              decodeURIComponent(
                privacyPolicyContent.replace("%0A%0A%20%20%0A%0A", "<br><br>")
              )
            );
            return decodeURIComponent(
              privacyPolicyContent.replace("%0A%0A%20%20%0A%0A", "<br><br>")
            );
          } else {
            container.innerHTML = "Privacy policy content is empty.";
            reject(new Error("Privacy policy content is empty."));
            return;
          }
        } else {
          container.innerHTML = "Privacy policy not found.";
          reject(new Error("Privacy policy not found."));
        }
      })
      .catch(function (error) {
        console.error("Error getting privacy policy:", error);
        reject(error);
      });
  }

  async htmlToMarkdown(html) {
    await this.loadTurndown();
    let turndownService = new TurndownService();
    let markdown = turndownService.turndown(html);
    return markdown;
  }

  async savePrivacyPolicy(editorContent) {
    let policyContent = encodeURIComponent(editorContent);
    console.log("Privacy Policy Content:", policyContent);
    console.log("Editor Policy Content:", editorContent);
    let docRef = doc(
      FBDatabase,
      "customers",
      localStorage.getItem("companyID"),
      "product",
      "policyPackages",
      "privacyPolicy",
      "policies",
      "policy_current",
      "privacy_policy"
    );

    return setDoc(
      docRef,
      {
        policy_content: policyContent,
      },
      {
        merge: true,
      }
    )
      .then(async () => {
        await this.savedNotification({
          title: "Privacy Policy",
          text: "Your changes have been saved.",
        });
      })
      .catch((error) => {
        this.debug.error("Error writing document: ", error);
      });
  }

  async savedNotification(
    data = {
      title: "Saved",
      text: "Your changes have been saved.",
    }
  ) {
    let notificationFull;
    this.debug.log("Document successfully written!");
    if (!notificationFull) {
      notificationFull = window.f7.notification.create({
        icon: '<img src="/logos/deiterate-light.svg" style="width: 32px;"></img>',
        title: '<span style="padding-left: 5px;">de.iterate</span>',
        titleRightText: "now",
        subtitle: data["title"],
        text: data["text"],
        closeTimeout: 3000,
      });
    }

    notificationFull.open();

    setTimeout(() => {
      notificationFull = undefined;
    }, 3000);
  }

  calculateDaysTillAudit(nextAuditDate) {
    const today = new Date();
    const auditDate = new Date(nextAuditDate);
    const oneDay = 24 * 60 * 60 * 1000;
    const daysTillAudit = Math.round((auditDate - today) / oneDay);
    return daysTillAudit > 0 ? daysTillAudit : 0;
  }

  async getAssignedToName(userID) {
    if (userID == undefined || userID == "" || userID == null) {
      return "Unknown";
    }
    this.debug.log("[Compliance Calendar] User ID =>", userID);
    this.debug.log("[Compliance Calendar] User ID is a Firebase ID");

    let assigneeName = userID;

    if (window.assignees === undefined) {
      await this.getAssignableUsers();
    } else {
      for (let i = 0; i < window.assignees.length; i++) {
        let assignee = window.assignees[i];
        if (assignee.userID === userID) {
          assigneeName = assignee.firstName + " " + assignee.lastName;
        }
      }
    }

    return assigneeName;
  }

  async getAssuranceData(
    assuranceID,
    companyID = localStorage.getItem("companyID")
  ) {
    let assuranceRef = doc(
      FBDatabase,
      "customers",
      companyID,
      "compliance",
      "assurance"
    );

    getDoc(assuranceRef)
      .then((doc) => {
        if (doc.exists()) {
          this.debug.log("Document data:", doc.data());
          return doc.data()[assuranceID];
        } else {
          this.debug.warn("[Compliance Calendar] No such document!");
        }
      })
      .catch((error) => {
        this.debug.warn("[Compliance Calendar] Error getting document:", error);
      });
  }

  async saveEvidenceFiles(
    files,
    assuranceID,
    noPreviousChecks,
    companyID = localStorage.getItem("companyID")
  ) {
    this.debug.log("[Compliance Calendar] Files =>", files);
    this.debug.log("[Compliance Calendar] Assurance ID =>", assuranceID);
    this.debug.log(
      "[Compliance Calendar] No Previous Checks =>",
      noPreviousChecks
    );
    this.debug.log("[Compliance Calendar] Company ID =>", companyID);

    let evidenceArray = [];
    for (let i = 0; i < files.length; i++) {
      let file = files[i];
      let evidenceName = file.name;
      let storageRef = ref(
        FBStorage,
        `/customers/${companyID}/compliance/assurance/${assuranceID}/${noPreviousChecks}/${evidenceName}`
      );
      evidenceArray.push(
        `/customers/${companyID}/compliance/assurance/${assuranceID}/${noPreviousChecks}/${evidenceName}`
      );
      let metadata = {
        contentType: file.type,
      };

      let uploadTask = uploadBytesResumable(storageRef, file, metadata);

      uploadTask.on("state_changed", (snapshot) => {
        let progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        this.debug.log("[Compliance Calendar] Upload Progress =>", progress);
        switch (snapshot.state) {
          case "paused":
            this.debug.log("[Compliance Calendar] Upload is paused");
            break;
          case "running":
            this.debug.log("[Compliance Calendar] Upload is running");
            break;
        }
      });

      this.debug.log("[Compliance Calendar] Evidence Array =>", evidenceArray);
    }

    return evidenceArray;
  }

  async findCompanyLogo(companyDomain) {
    // let response = await fetch('https://api.ritekit.com/v2/company-insights/logo', {
    //   method: 'GET',
    //   mode: 'no-cors',
    //   params: {
    //     client_id: 'af6e9050b96b71adc2945258065ebc81e6d5a52719da',
    //     domain: companyDomain
    //       .replaceAll('https://', '')
    //       .replaceAll('http://', '')
    //       .replaceAll('www.', ''),
    //     generateFallbackLogo: '1',
    //     squareLogoSize: '256',
    //     squareLogoBackground: 'original',
    //   },
    // });

    // console.log(response.data);
    // if (response.data.result) {
    //   return response.data.url;
    // } else {
    //   return 'logos/deiterate-light.svg';
    // }
    return null;
  }

  /**
   * This function toggles the preferred color scheme of a webpage based on the user's preference or
   * the device's default setting.
   */
  togglePreferredColours() {
    return this.applyPersonalSettings();
    let darkMode =
      localStorage.getItem("darkMode") ||
      (window.matchMedia &&
        window.matchMedia("(prefers-color-scheme: dark)").matches
        ? true
        : false);
    if (darkMode == "true" || darkMode == true) {
      document.querySelector("html").classList.add("dark");

      if (window.f7.device.android) {
        document.querySelectorAll(".deit-logo").forEach((logo) => {
          logo.setAttribute("src", "logos/deit-dark.svg");
        });
      } else {
        document.querySelectorAll(".deit-logo").forEach((logo) => {
          logo.setAttribute("src", "logos/deiterate-dark.svg");
        });
      }
      setTimeout(() => {
        if (window.f7.device.android) {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deit-dark.svg");
          });
        } else {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deiterate-dark.svg");
          });
        }
      }, 1500);
      window.f7.statusbar.setTextColor("white");
    } else {
      document.querySelector("html").classList.remove("dark");

      if (window.f7.device.android) {
        document.querySelectorAll(".deit-logo").forEach((logo) => {
          logo.setAttribute("src", "logos/deit-light.svg");
        });
      } else {
        document.querySelectorAll(".deit-logo").forEach((logo) => {
          logo.setAttribute("src", "logos/deiterate-light.svg");
        });
      }
      setTimeout(() => {
        if (window.f7.device.android) {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deit-light.svg");
          });
        } else {
          document.querySelectorAll(".deit-logo").forEach((logo) => {
            logo.setAttribute("src", "logos/deiterate-light.svg");
          });
        }
      }, 1500);
      window.f7.statusbar.setTextColor("black");
    }
    return darkMode;
  }

  async fixTabs() {
    let tabLinks = document.querySelectorAll(".tab-link");
    let morphVisible = false;
    tabLinks.forEach((link) => {
      link.addEventListener("click", (e) => {
        if (link.id == "more-link") {
          e.preventDefault();
          window.f7.$(".fab-morph-target").prependTo(".view.view-main");
          const fabs = document
            .querySelector(".view.view-main")
            .getElementsByClassName("fab-morph-target");

          // Step 3: Loop through the li elements and remove all but one (keeping the first one)
          if (fabs.length > 1) {
            for (let i = fabs.length - 1; i > 0; i--) {
              document.querySelector(".view.view-main").removeChild(fabs[i]);
            }
          }
          window.f7.fab.open("#more-link", ".fab-morph-target");
          document.querySelectorAll(".view").forEach((page) => {
            page.classList.add("fab-close");
          });
          document.querySelectorAll(".tab-link").forEach((page) => {
            page.classList.add("fab-close");
          });

          // setTimeout(() => {
          //   morphVisible = true;
          //   let fabListener = document.addEventListener('click', function (event) {
          //     // Check if the clicked element is inside the div
          //     if (
          //       !document.querySelector('.fab-morph-target').contains(event.target) &&
          //       morphVisible
          //     ) {
          //       console.log('im closing');
          //       // Clicked outside the div, so close it
          //       window.f7.fab.close('#more-link', '.fab-morph-target');
          //       morphVisible = false;
          //       // Remove the listener
          //       document.removeEventListener('click', fabListener);
          //     }
          //   });
          // }, 4000);

          return;
        }
        tabLinks.forEach((link) => {
          link.classList.remove("tab-link-active");
        });
        // $f7.$('#more-link').attr('href', $f7.views.main.router.url);
        link.classList.add("tab-link-active");
      });
    });

    setTimeout(() => {
      document.querySelectorAll(".toolbar .tab-link-active").forEach((tab) => {
        tab.classList.remove("tab-link-active");
      });
      let url = window.f7.views.main.router.hasOwnProperty("url")
        ? window.f7.views.main.router.url
        : "home";
      if (url === "/") {
        url = "home";
      }
      console.log("THIS IS MY URL", url);
      document
        .querySelectorAll(`#${url.replaceAll("/", "")}-link`)
        .forEach((tab) => {
          tab.classList.add("tab-link-active");
        });
    }, 1000);
  }

  prefersColorScheme() {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "dark";
    }
    return "light";
  }

  prefersColorSchemeImage() {
    if (
      window.matchMedia &&
      window.matchMedia("(prefers-color-scheme: dark)").matches
    ) {
      return "light";
    }
    return "dark";
  }

  firebaseTimeConverter = (timestamp) => {
    let fireBaseTime = new Date(
      timestamp.seconds * 1000 + timestamp.nanoseconds / 1000000
    );
    return fireBaseTime;
  };

  generateRandomColor = () => {
    // Get all the stylesheets in the document
    const stylesheets = Array.from(document.styleSheets);

    // Collect all the color values from the stylesheets
    const colors = [];
    stylesheets.forEach((sheet) => {
      try {
        const rules = Array.from(sheet.cssRules || sheet.rules);
        rules.forEach((rule) => {
          if (rule.style) {
            const colorValue = rule.style.getPropertyValue("color");
            if (colorValue) {
              if (colorValue.startsWith("#")) {
                colors.push(colorValue);
              } else if (colorValue.startsWith("rgb")) {
                colors.push(this.convertRgbToHex(colorValue));
              } else if (colorValue.startsWith("hsl")) {
                colors.push(this.convertHslToHex(colorValue));
              } else if (colorValue.startsWith("cmyk")) {
                colors.push(this.convertCmykToHex(colorValue));
              }
            }
          }
        });
      } catch (error) {
        this.debug.error("Error parsing stylesheet:", error);
      }
    });

    // Generate a random index based on the length of the colors array
    const randomIndex = Math.floor(Math.random() * colors.length);

    // Return the randomly selected color
    return colors[randomIndex];
  };

  // Helper function to convert RGB color to hex color
  convertRgbToHex = (rgbColor) => {
    const match = rgbColor.match(/^rgb\((\d+),\s*(\d+),\s*(\d+)\)$/);
    if (match) {
      const r = parseInt(match[1], 10).toString(16).padStart(2, "0");
      const g = parseInt(match[2], 10).toString(16).padStart(2, "0");
      const b = parseInt(match[3], 10).toString(16).padStart(2, "0");
      return `#${r}${g}${b}`;
    }
    return rgbColor;
  };

  // Helper function to convert HSL color to hex color
  convertHslToHex = (hslColor) => {
    const match = hslColor.match(/^hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)$/);
    if (match) {
      const h = parseInt(match[1], 10);
      const s = parseFloat(match[2]) / 100;
      const l = parseFloat(match[3]) / 100;
      const rgb = hslToRgb(h, s, l);
      return this.convertRgbToHex(`rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`);
    }
    return hslColor;
  };

  // Helper function to convert CMYK color to hex color
  convertCmykToHex = (cmykColor) => {
    const match = cmykColor.match(
      /^cmyk\(([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)%\)$/
    );
    if (match) {
      const c = parseFloat(match[1]) / 100;
      const m = parseFloat(match[2]) / 100;
      const y = parseFloat(match[3]) / 100;
      const k = parseFloat(match[4]) / 100;
      const rgb = this.cmykToRgb(c, m, y, k);
      return this.convertRgbToHex(`rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`);
    }
    return cmykColor;
  };

  // Helper function to convert HSL to RGB
  hslToRgb = (h, s, l) => {
    let r, g, b;

    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      const hue2rgb = (p, q, t) => {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };

      const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      const p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }

    return {
      r: Math.round(r * 255),
      g: Math.round(g * 255),
      b: Math.round(b * 255),
    };
  };

  // Helper function to convert CMYK to RGB
  cmykToRgb = (c, m, y, k) => {
    const r = 255 * (1 - c) * (1 - k);
    const g = 255 * (1 - m) * (1 - k);
    const b = 255 * (1 - y) * (1 - k);
    return {
      r: Math.round(r),
      g: Math.round(g),
      b: Math.round(b),
    };
  };

  generatePastelColor() {
    var hue = Math.floor(Math.random() * 280); // Random hue value between 0 and 359
    var saturation = Math.floor(Math.random() * 30) + 30; // Random saturation between 70 and 100
    var lightness = Math.floor(Math.random() * 10) + 30; // Random lightness between 70 and 80

    // Convert HSL to RGB
    var h = hue / 360;
    var s = saturation / 100;
    var l = lightness / 100;
    var r, g, b;

    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var hueToRGB = function hueToRGB(p, q, t) {
        if (t < 0) t += 1;
        if (t > 1) t -= 1;
        if (t < 1 / 6) return p + (q - p) * 6 * t;
        if (t < 1 / 2) return q;
        if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
        return p;
      };

      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = Math.round(hueToRGB(p, q, h + 1 / 3) * 255);
      g = Math.round(hueToRGB(p, q, h) * 255);
      b = Math.round(hueToRGB(p, q, h - 1 / 3) * 255);
    }

    // Convert RGB to Hex
    var rgb = (r << 16) | (g << 8) | b;
    var hex = "#" + (0x1000000 + rgb).toString(16).slice(1);

    // Convert RGB to CMYK
    var c = 1 - r / 255;
    var m = 1 - g / 255;
    var y = 1 - b / 255;
    var k = Math.min(c, m, y);
    c = (c - k) / (1 - k);
    m = (m - k) / (1 - k);
    y = (y - k) / (1 - k);
    c = Math.round(c * 100);
    m = Math.round(m * 100);
    y = Math.round(y * 100);
    k = Math.round(k * 100);

    // Prepare the HSL string
    var hsl = "hsl(" + hue + ", " + saturation + "%, " + lightness + "%)";

    // Return an object containing the different color values
    return {
      rgb: {
        r,
        g,
        b,
      },
      hex,
      cmyk: {
        c,
        m,
        y,
        k,
      },
      hsl,
    };
  }

  getDataAttr = (element, attr) => {
    this.debug.log(element);
    if (element.isTrusted === undefined) {
      return element.getAttribute(`data-${attr}`);
    }
    return element.srcElement.attributes[`data-${attr}`] !== undefined
      ? element.srcElement.attributes[`data-${attr}`].nodeValue
      : element.srcElement.offsetParent.attributes[`data-${attr}`].nodeValue;
  };

  getCoordinates = (countryName) => {
    countryName = countryName.replace("_", " ");
    console.log("Country Name Test", countryName.toLowerCase());

    if (countryName.toLowerCase() === "sydney") {
      countryName = "Australia";
    }

    const countriesByName = CountryAndCurrency.getCountriesBy(
      "name",
      countryName
    );
    const countriesByIso2 = CountryAndCurrency.getCountriesBy(
      "iso2",
      countryName
    );
    const countriesByIso3 = CountryAndCurrency.getCountriesBy(
      "iso3",
      countryName
    );
    const countriesByContinent = CountryAndCurrency.getCountriesBy(
      "continent",
      countryName
    );

    const countries = [
      ...countriesByName,
      ...countriesByIso2,
      ...countriesByIso3,
      ...countriesByContinent,
    ];

    if (countries.length > 0) {
      const { latitude, longitude } = countries[0];
      const coordinates = {
        latitude,
        longitude,
      };
      const jsonOutput = JSON.stringify(coordinates);
      console.log(jsonOutput);
      return coordinates;
    } else {
      console.log("Country not found.");
      return null;
    }
  };

  /**
   * The function generates a random number or string within a given range, with an option to include
   * alphabets.
   * @param min - The minimum value that can be generated by the random function.
   * @param max - The "max" parameter in the "random" function represents the maximum value that can be
   * generated by the function. If the "alpha" parameter is set to false, then the function will
   * generate a random integer between the "min" and "max" values (inclusive). If the "alpha"
   * @param [alpha=false] - The "alpha" parameter is a boolean (true/false) value that determines
   * whether the random output should be alphanumeric or just a number. If "alpha" is set to true, the
   * function will generate a random string of characters that includes both letters and numbers. If
   * "alpha" is set to false
   * @returns The function `random` returns a random integer between the `min` and `max` values
   * (inclusive) if the `alpha` parameter is not provided or is `false`. If `alpha` is `true`, the
   * function returns a random string of length `max` consisting of alphanumeric characters.
   */
  random(min, max, alpha = false) {
    if (alpha) {
      return [...Array(max)]
        .map(() => (~~(Math.random() * 36)).toString(36))
        .join("");
    }
    return Math.floor(Math.random() * (max - min + 1) + min);
  }
  /**
   * The function converts a total completed time in minutes to a human-readable format in minutes,
   * hours, days, weeks, months, or years.
   * @param totalCompletedTime - The total amount of time completed, in minutes.
   * @returns An object with two properties: `time` and `timeUnit`. `time` is the rounded time value
   * divided by the appropriate divisor based on the total completed time, and `timeUnit` is the
   * corresponding time unit (e.g. minute, hour, day) with an 's' appended if the time value is not
   * equal to 1.
   */
  humaniseTime(totalCompletedTime, type = "none") {
    console.log('Read Time (humanise', totalCompletedTime)
    if (totalCompletedTime < 0) {
      return {
        time: 0,
        timeUnit: "minutes",
      };
    }

    totalCompletedTime = Math.abs(totalCompletedTime); // Ensure the value is positive
    console.log("Total Completed Time", totalCompletedTime, type);

    let timeUnits = ["minute", "hour", "day", "week", "month", "year"];
    let timeDivisors = [1, 60, 1440, 10080, 43200, 525600];
    let timeUnit = "minute";
    let divisor = 1;
    let roundedTime = Math.round(parseFloat(totalCompletedTime));
    for (let i = timeDivisors.length - 1; i >= 0; i--) {
      if (roundedTime >= timeDivisors[i]) {
        timeUnit = timeUnits[i];
        divisor = timeDivisors[i];
        break;
      }
    }
    let roundedTimeUnit = Math.round(roundedTime / divisor);
    return {
      time: roundedTimeUnit,
      timeUnit: timeUnit + (roundedTimeUnit !== 1 ? "s" : ""),
    };
  }
  /**
   * The function capitalizes the first letter of a given string.
   * @param string - The input string that needs to be capitalized.
   * @returns The function `capitaliseFirst` is returning a string with the first character
   * capitalized and the rest of the string unchanged.
   */
  capitaliseFirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
  /**
   * The function converts a timestamp to a formatted date string in the format of dd/mm/yyyy.
   * @param timestamp - The input parameter `timestamp` is expected to be a Firebase Timestamp
   * object.
   * @returns a formatted date string in the format "dd/mm/yyyy" based on the input timestamp.
   */
  convertTimestamp(timestamp) {
    let date = timestamp.toDate();
    let mm = date.getMonth() + 1; // Add 1 to the month since it starts from 0
    let dd = date.getDate();
    let yyyy = date.getFullYear();
    // Add leading zeros to month and date if needed
    if (mm < 10) {
      mm = "0" + mm;
    }
    if (dd < 10) {
      dd = "0" + dd;
    }
    date = dd + "/" + mm + "/" + yyyy;
    return date;
  }
  /**
   * The function dynamically wraps a string to a specified width by inserting line breaks.
   * @param s - The input string that needs to be wrapped dynamically based on the specified width.
   * @param w - The parameter "w" in the function "dynamicWrap" represents the maximum width of each
   * line in the wrapped string. The function takes a string "s" and wraps it dynamically based on
   * the given width "w".
   * @returns The `dynamicWrap` function is returning a modified string `s` with line breaks added at
   * appropriate positions to wrap the text to a maximum width of `w` characters. The regular
   * expression used in the `replace` method matches any non-newline character that is not followed
   * by `w` or more non-newline characters and a whitespace character. The matched character is then
   * replaced with itself (`$
   */
  dynamicWrap(s, w) {
    return s.replace(
      new RegExp(`(?![^\\n]{1,${w}}$)([^\\n]{1,${w}})\\s`, "g"),
      "$1\n"
    );
  }
  /* The above code is defining a function called `enc2html` which takes in a string `text` and an
      optional boolean parameter `reverse`. The function converts line breaks in the string to HTML
      `<br/>` tags if `reverse` is false, and converts HTML `<br>` tags to line breaks if `reverse` is
      true. If the input string is null or empty, the function returns the input string as is. */
  enc2html(text, reverse = false) {
    if (text != null && text.length > 0) {
      if (reverse) {
        return text.replace(/(<br>|<br\/>|<br \/>)/gim, "\n");
      } else {
        return text.replace(/(?:\r\n|\r|\n)/g, "<br/>");
      }
    } else {
      return text;
    }
  }
  /**
   * The function checks if a string contains any HTML tags by using a regular expression.
   * @param str - The parameter `str` is a string that represents an HTML code or a portion of it.
   * The function `isActiveByBrackets` uses a regular expression to check if there are any HTML tags
   * in the string. If there are, it returns `true`, indicating that the HTML code is active.
   * @returns The function `isActiveByBrackets` is returning a boolean value. It is using a regular
   * expression to test if there are any HTML tags in the input string `str`. If there are, it will
   * return `true`, indicating that the string is "active" (i.e. contains HTML tags). If there are no
   * HTML tags, it will return `false`, indicating that the string is "
   */
  isActiveByBrackets(str) {
    return /<[^<>]+>/g.test(str);
  }
  /**
   * The function converts a given number into its equivalent words in English.
   * @param n - The number that needs to be converted to words.
   * @returns The function `numToWords(n)` is returning a string that represents the input number `n`
   * in words.
   */
  numToWords(n) {
    const arr = (x) => Array.from(x);
    const num = (x) => Number(x) || 0;
    const str = (x) => String(x);
    const isEmpty = (xs) => xs.length === 0;
    const take = (n) => (xs) => xs.slice(0, n);
    const drop = (n) => (xs) => xs.slice(n);
    const reverse = (xs) => xs.slice(0).reverse();
    const comp = (f) => (g) => (x) => f(g(x));
    const not = (x) => !x;
    const chunk = (n) => (xs) =>
      isEmpty(xs) ? [] : [take(n)(xs), ...chunk(n)(drop(n)(xs))];
    let a = [
      "",
      "one",
      "two",
      "three",
      "four",
      "five",
      "six",
      "seven",
      "eight",
      "nine",
      "ten",
      "eleven",
      "twelve",
      "thirteen",
      "fourteen",
      "fifteen",
      "sixteen",
      "seventeen",
      "eighteen",
      "nineteen",
    ];
    let b = [
      "",
      "",
      "twenty",
      "thirty",
      "forty",
      "fifty",
      "sixty",
      "seventy",
      "eighty",
      "ninety",
    ];
    let g = [
      "",
      "thousand",
      "million",
      "billion",
      "trillion",
      "quadrillion",
      "quintillion",
      "sextillion",
      "septillion",
      "octillion",
      "nonillion",
    ];
    let makeGroup = ([ones, tens, huns]) => {
      return [
        num(huns) === 0 ? "" : a[huns] + " hundred ",
        num(ones) === 0 ? b[tens] : (b[tens] && b[tens] + "-") || "",
        a[tens + ones] || a[ones],
      ].join("");
    };
    let thousand = (group, i) => (group === "" ? group : `${group} ${g[i]}`);
    if (typeof n === "number") {
      return numToWords(String(n));
    } else if (n === "0") {
      return "zero";
    } else {
      return comp(chunk(3))(reverse)(arr(n))
        .map(makeGroup)
        .map(thousand)
        .filter(comp(not)(isEmpty))
        .reverse()
        .join(" ");
    }
  }
  /**
   * This function sorts an object by its keys in ascending order based on the numeric value found in
   * the key.
   * @param object - The `object` parameter is an object that needs to be sorted by its keys. The keys
   * are assumed to be strings that contain a number, and the function sorts the keys based on the
   * numeric value of that number. The function then returns a new object with the sorted keys.
   * @returns The function `sortObjectByKey` is returning a new object with the same key-value pairs as
   * the input object, but with the keys sorted in ascending order based on the numeric value found in
   * each key's name.
   */
  sortObjectByKey(object) {
    return Object.fromEntries(
      Object.entries(object).sort(
        (a, b) =>
          parseInt(a[0].match(/\d+/)[0]) - parseInt(b[0].match(/\d+/)[0])
      )
    );
  }
  /**
   * This function sorts the keys of an object alphabetically and returns a new object with the sorted
   * keys.
   * @param object - The "object" parameter in the function "sortObjectByKeyAlpha" is expected to be an
   * object (i.e., a collection of key-value pairs) that needs to be sorted alphabetically by its keys.
   * @returns The function `sortObjectByKeyAlpha` is returning a new object with the same key-value
   * pairs as the input object, but with the keys sorted alphabetically.
   */
  sortObjectByKeyAlpha(object) {
    return Object.fromEntries(Object.entries(object).sort());
  }

  syntaxHighlight(json) {
    const isString = typeof json === "string";
    json = isString ? json : JSON.stringify(json, undefined, 2);
    json = json
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;");
    return json.replace(
      /("(\\u[a-zA-Z0-9]{4}|\\[^u]|[^\\"])*"(\s*:)?|\b(true|false|null)\b|-?\d+(?:\.\d*)?(?:[eE][+\-]?\d+)?)/g,
      (match) => {
        const cls = (() => {
          if (/^"/.test(match)) {
            return /:$/.test(match) ? "key" : "tring";
          } else if (/true|false/.test(match)) {
            return "boolean";
          } else if (/null/.test(match)) {
            return "null";
          } else {
            return "number";
          }
        })();
        return `<span class="${cls}">${match.replace(/"/g, "&quot;")}</span>`;
      }
    );
  }

  async captureCustomPolicyReadingBegin(policyRef) {
    let userReadDataRef = doc(
      collection(
        FBDatabase,
        "users",
        getAuth().currentUser.uid,
        "usersActualReadTime"
      ),
      policyRef
    );

    console.log(
      "Updating ReadingBegin for Policy:",
      policyRef,
    );
    // await this.updateReadTime(policyRef, screenRef, lastScreen);
    await setDoc(
      userReadDataRef,
      {
        [`ReadingBegin`]: new Date(),
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }

  async captureCustomPolicyReadingEnd(policyRef) {
    let userReadDataRef = doc(
      collection(
        FBDatabase,
        "users",
        getAuth().currentUser.uid,
        "usersActualReadTime"
      ),
      policyRef
    );
    console.log(
      "Updating ReadingEnd for Policy:",
      policyRef,
      "timestamp: ",
      new Date()
    );
    await setDoc(
      userReadDataRef,
      {
        [`ReadingEnd`]: new Date(),
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }

  async completeCustomPolicy(policyRef) {
    let userReadDataRef = doc(
      FBDatabase,
      "users",
      getAuth().currentUser.uid,
      "assignedPolicies",
      policyRef
    );
    console.log(
      "Marking as completed for the following Policy:",
      policyRef,
    );
    await setDoc(
      userReadDataRef,
      {
        "completed": 'true'
      },
      {
        merge: true,
      }
    )
      .then(() => {
        this.debug.log("Document Successfully Updated");
      })
      .catch((err) => {
        this.debug.log("Error updating Document:", err);
      });
  }

}
